import { a as vt } from "./js-cookie-d54fed8f.js";
import { S as je } from "./@aws-crypto-5d5961ee.js";
import { t as is } from "./@smithy-2331ff76.js";
import { f as os, O as pt, m as Ln, a as rs, c as ss } from "./rxjs-c3576f66.js";
import { v as as } from "./uuid-5adc31c9.js";
const cs = "Logging", Fo = "x-amz-user-agent", us = "NoHubcallbackProvidedException";
var X;
(function(e) {
  e.DEBUG = "DEBUG", e.ERROR = "ERROR", e.INFO = "INFO", e.WARN = "WARN", e.VERBOSE = "VERBOSE", e.NONE = "NONE";
})(X || (X = {}));
const Ei = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5,
  NONE: 6
};
class W {
  /**
   * @constructor
   * @param {string} name - Name of the logger
   */
  constructor(t, n = X.WARN) {
    this.name = t, this.level = n, this._pluggables = [];
  }
  _padding(t) {
    return t < 10 ? "0" + t : "" + t;
  }
  _ts() {
    const t = /* @__PURE__ */ new Date();
    return [this._padding(t.getMinutes()), this._padding(t.getSeconds())].join(":") + "." + t.getMilliseconds();
  }
  configure(t) {
    return t ? (this._config = t, this._config) : this._config;
  }
  /**
   * Write log
   * @method
   * @memeberof Logger
   * @param {LogType|string} type - log type, default INFO
   * @param {string|object} msg - Logging message or object
   */
  _log(t, ...n) {
    let i = this.level;
    W.LOG_LEVEL && (i = W.LOG_LEVEL), typeof window < "u" && window.LOG_LEVEL && (i = window.LOG_LEVEL);
    const o = Ei[i];
    if (!(Ei[t] >= o))
      return;
    let s = console.log.bind(console);
    t === X.ERROR && console.error && (s = console.error.bind(console)), t === X.WARN && console.warn && (s = console.warn.bind(console)), W.BIND_ALL_LOG_LEVELS && (t === X.INFO && console.info && (s = console.info.bind(console)), t === X.DEBUG && console.debug && (s = console.debug.bind(console)));
    const a = `[${t}] ${this._ts()} ${this.name}`;
    let c = "";
    if (n.length === 1 && typeof n[0] == "string")
      c = `${a} - ${n[0]}`, s(c);
    else if (n.length === 1)
      c = `${a} ${n[0]}`, s(a, n[0]);
    else if (typeof n[0] == "string") {
      let u = n.slice(1);
      u.length === 1 && (u = u[0]), c = `${a} - ${n[0]} ${u}`, s(`${a} - ${n[0]}`, u);
    } else
      c = `${a} ${n}`, s(a, n);
    for (const u of this._pluggables) {
      const d = { message: c, timestamp: Date.now() };
      u.pushLogs([d]);
    }
  }
  /**
   * Write General log. Default to INFO
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  log(...t) {
    this._log(X.INFO, ...t);
  }
  /**
   * Write INFO log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  info(...t) {
    this._log(X.INFO, ...t);
  }
  /**
   * Write WARN log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  warn(...t) {
    this._log(X.WARN, ...t);
  }
  /**
   * Write ERROR log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  error(...t) {
    this._log(X.ERROR, ...t);
  }
  /**
   * Write DEBUG log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  debug(...t) {
    this._log(X.DEBUG, ...t);
  }
  /**
   * Write VERBOSE log
   * @method
   * @memeberof Logger
   * @param {string|object} msg - Logging message or object
   */
  verbose(...t) {
    this._log(X.VERBOSE, ...t);
  }
  addPluggable(t) {
    t && t.getCategoryName() === cs && (this._pluggables.push(t), t.configure(this._config));
  }
  listPluggables() {
    return this._pluggables;
  }
}
W.LOG_LEVEL = null;
W.BIND_ALL_LOG_LEVELS = !1;
class Y extends Error {
  /**
   *  Constructs an AmplifyError.
   *
   * @param message text that describes the main problem.
   * @param underlyingError the underlying cause of the error.
   * @param recoverySuggestion suggestion to recover from the error.
   *
   */
  constructor({ message: t, name: n, recoverySuggestion: i, underlyingError: o }) {
    super(t), this.name = n, this.underlyingError = o, this.recoverySuggestion = i, this.constructor = Y, Object.setPrototypeOf(this, Y.prototype);
  }
}
var Kt;
(function(e) {
  e.NoEndpointId = "NoEndpointId", e.PlatformNotSupported = "PlatformNotSupported", e.Unknown = "Unknown";
})(Kt || (Kt = {}));
const Lo = (e, t = Y) => (n, i, o) => {
  const { message: r, recoverySuggestion: s } = e[i];
  if (!n)
    throw new t({
      name: i,
      message: o ? `${r} ${o}` : r,
      recoverySuggestion: s
    });
}, ae = typeof Symbol < "u" ? Symbol("amplify_default") : "@@amplify_default", st = new W("Hub");
class ds {
  constructor(t) {
    this.listeners = /* @__PURE__ */ new Map(), this.protectedChannels = [
      "core",
      "auth",
      "api",
      "analytics",
      "interactions",
      "pubsub",
      "storage",
      "ui",
      "xr"
    ], this.name = t;
  }
  /**
   * Used internally to remove a Hub listener.
   *
   * @remarks
   * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
   */
  _remove(t, n) {
    const i = this.listeners.get(t);
    if (!i) {
      st.warn(`No listeners for ${t}`);
      return;
    }
    this.listeners.set(t, [
      ...i.filter(({ callback: o }) => o !== n)
    ]);
  }
  dispatch(t, n, i, o) {
    typeof t == "string" && this.protectedChannels.indexOf(t) > -1 && (o === ae || st.warn(`WARNING: ${t} is protected and dispatching on it can have unintended consequences`));
    const r = {
      channel: t,
      payload: { ...n },
      source: i,
      patternInfo: []
    };
    try {
      this._toListeners(r);
    } catch (s) {
      st.error(s);
    }
  }
  listen(t, n, i = "noname") {
    let o;
    if (typeof n != "function")
      throw new Y({
        name: us,
        message: "No callback supplied to Hub"
      });
    o = n;
    let r = this.listeners.get(t);
    return r || (r = [], this.listeners.set(t, r)), r.push({
      name: i,
      callback: o
    }), () => {
      this._remove(t, o);
    };
  }
  _toListeners(t) {
    const { channel: n, payload: i } = t, o = this.listeners.get(n);
    o && o.forEach((r) => {
      st.debug(`Dispatching to ${n} with `, i);
      try {
        r.callback(t);
      } catch (s) {
        st.error(s);
      }
    });
  }
}
const ce = new ds("__default__"), Uo = () => {
  if (typeof window == "object" && typeof window.crypto == "object")
    return window.crypto;
  if (typeof crypto == "object")
    return crypto;
  throw new Y({
    name: "MissingPolyfill",
    message: "Cannot resolve the `crypto` function from the environment."
  });
}, ls = () => {
  if (typeof window < "u" && typeof window.btoa == "function")
    return window.btoa;
  if (typeof btoa == "function")
    return btoa;
  throw new Y({
    name: "Base64EncoderError",
    message: "Cannot resolve the `btoa` function from the environment."
  });
}, hs = () => {
  if (typeof window < "u" && typeof window.atob == "function")
    return window.atob;
  if (typeof atob == "function")
    return atob;
  throw new Y({
    name: "Base64EncoderError",
    message: "Cannot resolve the `atob` function from the environment."
  });
}, Ko = {
  convert(e) {
    return hs()(e);
  }
};
var me;
(function(e) {
  e.AuthTokenConfigException = "AuthTokenConfigException", e.AuthUserPoolAndIdentityPoolException = "AuthUserPoolAndIdentityPoolException", e.AuthUserPoolException = "AuthUserPoolException", e.InvalidIdentityPoolIdException = "InvalidIdentityPoolIdException", e.OAuthNotConfigureException = "OAuthNotConfigureException";
})(me || (me = {}));
const ps = {
  [me.AuthTokenConfigException]: {
    message: "Auth Token Provider not configured.",
    recoverySuggestion: "Make sure to call Amplify.configure in your app."
  },
  [me.AuthUserPoolAndIdentityPoolException]: {
    message: "Auth UserPool or IdentityPool not configured.",
    recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
  },
  [me.AuthUserPoolException]: {
    message: "Auth UserPool not configured.",
    recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
  },
  [me.InvalidIdentityPoolIdException]: {
    message: "Invalid identity pool id provided.",
    recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
  },
  [me.OAuthNotConfigureException]: {
    message: "oauth param not configured.",
    recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
  }
}, Un = Lo(ps);
function L(e) {
  let t = !0;
  e ? t = !!e.userPoolId && !!e.userPoolClientId : t = !1, Un(t, me.AuthUserPoolException);
}
function zt(e) {
  var n, i, o, r, s, a, c, u;
  const t = !!((i = (n = e == null ? void 0 : e.loginWith) == null ? void 0 : n.oauth) != null && i.domain) && !!((r = (o = e == null ? void 0 : e.loginWith) == null ? void 0 : o.oauth) != null && r.redirectSignOut) && !!((a = (s = e == null ? void 0 : e.loginWith) == null ? void 0 : s.oauth) != null && a.redirectSignIn) && !!((u = (c = e == null ? void 0 : e.loginWith) == null ? void 0 : c.oauth) != null && u.responseType);
  Un(t, me.OAuthNotConfigureException);
}
function Rt(e) {
  const t = !!(e != null && e.identityPoolId);
  Un(t, me.InvalidIdentityPoolIdException);
}
function Ee(e) {
  const t = e.split(".");
  if (t.length !== 3)
    throw new Error("Invalid token");
  try {
    const i = t[1].replace(/-/g, "+").replace(/_/g, "/"), o = decodeURIComponent(Ko.convert(i).split("").map((s) => `%${`00${s.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")), r = JSON.parse(o);
    return {
      toString: () => e,
      payload: r
    };
  } catch {
    throw new Error("Invalid token payload");
  }
}
const Bo = (e) => e && e["nonRetryable"], wt = new W("retryUtil");
async function fs(e, t, n, i) {
  if (typeof e != "function")
    throw Error("functionToRetry must be a function");
  return new Promise(async (o, r) => {
    let s = 0, a = !1, c, u = () => {
    }, d;
    for (i && i.then(() => {
      a = !0, clearTimeout(c), u();
    }); !a; ) {
      s++, wt.debug(`${e.name} attempt #${s} with this vars: ${JSON.stringify(t)}`);
      try {
        o(await e(...t));
        return;
      } catch (l) {
        if (d = l, wt.debug(`error on ${e.name}`, l), Bo(l)) {
          wt.debug(`${e.name} non retryable error`, l), r(l);
          return;
        }
        const h = n(s, t, l);
        if (wt.debug(`${e.name} retrying in ${h} ms`), h === !1 || a) {
          r(l);
          return;
        } else
          await new Promise((f) => {
            u = f, c = setTimeout(u, h);
          });
      }
    }
    r(d);
  });
}
const $o = (e) => {
  const t = Reflect.ownKeys(e);
  for (const n of t) {
    const i = e[n];
    (i && typeof i == "object" || typeof i == "function") && $o(i);
  }
  return Object.freeze(e);
}, ms = new W("parseAWSExports"), ys = {
  API_KEY: "apiKey",
  AWS_IAM: "iam",
  AMAZON_COGNITO_USER_POOLS: "userPool",
  OPENID_CONNECT: "oidc",
  NONE: "none",
  AWS_LAMBDA: "lambda",
  // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
  // Keeping it as a valid value until v7 to prevent breaking customers who might
  // be relying on it as a workaround.
  // ref: https://github.com/aws-amplify/amplify-js/pull/12922
  // TODO: @v7 remove next line
  LAMBDA: "lambda"
}, Es = (e = {}) => {
  var ui, di, li, hi, pi, fi;
  if (!Object.prototype.hasOwnProperty.call(e, "aws_project_region"))
    throw new Y({
      name: "InvalidParameterException",
      message: "Invalid config parameter.",
      recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
  const { aws_appsync_apiKey: t, aws_appsync_authenticationType: n, aws_appsync_graphqlEndpoint: i, aws_appsync_region: o, aws_bots_config: r, aws_cognito_identity_pool_id: s, aws_cognito_sign_up_verification_method: a, aws_cognito_mfa_configuration: c, aws_cognito_mfa_types: u, aws_cognito_password_protection_settings: d, aws_cognito_verification_mechanisms: l, aws_cognito_signup_attributes: h, aws_cognito_social_providers: f, aws_cognito_username_attributes: p, aws_mandatory_sign_in: m, aws_mobile_analytics_app_id: g, aws_mobile_analytics_app_region: E, aws_user_files_s3_bucket: S, aws_user_files_s3_bucket_region: v, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: N, aws_user_pools_id: A, aws_user_pools_web_client_id: w, geo: _, oauth: D, predictions: O, aws_cloud_logic_custom: U, Notifications: Re, modelIntrospection: Ue } = e, K = {};
  g && (K.Analytics = {
    Pinpoint: {
      appId: g,
      region: E
    }
  });
  const { InAppMessaging: C, Push: b } = Re ?? {};
  if (C != null && C.AWSPinpoint || b != null && b.AWSPinpoint) {
    if (C != null && C.AWSPinpoint) {
      const { appId: q, region: _e } = C.AWSPinpoint;
      K.Notifications = {
        InAppMessaging: {
          Pinpoint: {
            appId: q,
            region: _e
          }
        }
      };
    }
    if (b != null && b.AWSPinpoint) {
      const { appId: q, region: _e } = b.AWSPinpoint;
      K.Notifications = {
        ...K.Notifications,
        PushNotification: {
          Pinpoint: {
            appId: q,
            region: _e
          }
        }
      };
    }
  }
  if (Array.isArray(r) && (K.Interactions = {
    LexV1: Object.fromEntries(r.map((q) => [q.name, q]))
  }), i) {
    const q = ys[n];
    q || ms.debug(`Invalid authentication type ${n}. Falling back to IAM.`), K.API = {
      GraphQL: {
        endpoint: i,
        apiKey: t,
        region: o,
        defaultAuthMode: q ?? "iam"
      }
    }, Ue && (K.API.GraphQL.modelIntrospection = Ue);
  }
  const k = c ? {
    status: c && c.toLowerCase(),
    totpEnabled: (u == null ? void 0 : u.includes("TOTP")) ?? !1,
    smsEnabled: (u == null ? void 0 : u.includes("SMS")) ?? !1
  } : void 0, M = d ? {
    minLength: d.passwordPolicyMinLength,
    requireLowercase: ((ui = d.passwordPolicyCharacters) == null ? void 0 : ui.includes("REQUIRES_LOWERCASE")) ?? !1,
    requireUppercase: ((di = d.passwordPolicyCharacters) == null ? void 0 : di.includes("REQUIRES_UPPERCASE")) ?? !1,
    requireNumbers: ((li = d.passwordPolicyCharacters) == null ? void 0 : li.includes("REQUIRES_NUMBERS")) ?? !1,
    requireSpecialCharacters: ((hi = d.passwordPolicyCharacters) == null ? void 0 : hi.includes("REQUIRES_SYMBOLS")) ?? !1
  } : void 0, ot = Array.from(/* @__PURE__ */ new Set([
    ...l ?? [],
    ...h ?? []
  ])).reduce((q, _e) => ({
    ...q,
    // All user attributes generated by the CLI are required
    [_e.toLowerCase()]: { required: !0 }
  }), {}), Te = (p == null ? void 0 : p.includes("EMAIL")) ?? !1, rt = (p == null ? void 0 : p.includes("PHONE_NUMBER")) ?? !1;
  (s || A) && (K.Auth = {
    Cognito: {
      identityPoolId: s,
      allowGuestAccess: m !== "enable",
      signUpVerificationMethod: a,
      userAttributes: ot,
      userPoolClientId: w,
      userPoolId: A,
      mfa: k,
      passwordFormat: M,
      loginWith: {
        username: !(Te || rt),
        email: Te,
        phone: rt
      }
    }
  });
  const Zr = D ? Object.keys(D).length > 0 : !1, es = f ? f.length > 0 : !1;
  if (K.Auth && Zr && (K.Auth.Cognito.loginWith = {
    ...K.Auth.Cognito.loginWith,
    oauth: {
      ...gs(D),
      ...es && {
        providers: Ss(f)
      }
    }
  }), S && (K.Storage = {
    S3: {
      bucket: S,
      region: v,
      dangerouslyConnectToHttpEndpointForTesting: N
    }
  }), _) {
    const { amazon_location_service: q } = _;
    K.Geo = {
      LocationService: {
        maps: q.maps,
        geofenceCollections: q.geofenceCollections,
        searchIndices: q.search_indices,
        region: q.region
      }
    };
  }
  if (U && (K.API = {
    ...K.API,
    REST: U.reduce((q, _e) => {
      const { name: ts, endpoint: ns, region: mi, service: yi } = _e;
      return {
        ...q,
        [ts]: {
          endpoint: ns,
          ...yi ? { service: yi } : void 0,
          ...mi ? { region: mi } : void 0
        }
      };
    }, {})
  }), O) {
    const { VoiceId: q } = ((fi = (pi = O == null ? void 0 : O.convert) == null ? void 0 : pi.speechGenerator) == null ? void 0 : fi.defaults) ?? {};
    K.Predictions = q ? {
      ...O,
      convert: {
        ...O.convert,
        speechGenerator: {
          ...O.convert.speechGenerator,
          defaults: { voiceId: q }
        }
      }
    } : O;
  }
  return K;
}, gi = (e) => (e == null ? void 0 : e.split(",")) ?? [], gs = ({ domain: e, scope: t, redirectSignIn: n, redirectSignOut: i, responseType: o }) => ({
  domain: e,
  scopes: t,
  redirectSignIn: gi(n),
  redirectSignOut: gi(i),
  responseType: o
}), Ss = (e) => e.map((t) => {
  const n = t.toLowerCase();
  return n.charAt(0).toUpperCase() + n.slice(1);
}), qo = Symbol("oauth-listener");
function Is(e) {
  const { version: t } = e;
  return t ? t.startsWith("1") : !1;
}
function Ts(e) {
  if (!e)
    return;
  const { bucket_name: t, aws_region: n } = e;
  return {
    S3: {
      bucket: t,
      region: n
    }
  };
}
function vs(e) {
  if (!e)
    return;
  const { user_pool_id: t, user_pool_client_id: n, identity_pool_id: i, password_policy: o, mfa_configuration: r, mfa_methods: s, unauthenticated_identities_enabled: a, oauth: c, username_attributes: u, standard_required_attributes: d } = e, l = {
    Cognito: {
      userPoolId: t,
      userPoolClientId: n
    }
  };
  return i && (l.Cognito = {
    ...l.Cognito,
    identityPoolId: i
  }), o && (l.Cognito.passwordFormat = {
    requireLowercase: o.require_lowercase,
    requireNumbers: o.require_numbers,
    requireUppercase: o.require_uppercase,
    requireSpecialCharacters: o.require_symbols,
    minLength: o.min_length ?? 6
  }), r && (l.Cognito.mfa = {
    status: Os(r),
    smsEnabled: s == null ? void 0 : s.includes("SMS"),
    totpEnabled: s == null ? void 0 : s.includes("TOTP")
  }), a && (l.Cognito.allowGuestAccess = a), c && (l.Cognito.loginWith = {
    oauth: {
      domain: c.domain,
      redirectSignIn: c.redirect_sign_in_uri,
      redirectSignOut: c.redirect_sign_out_uri,
      responseType: c.response_type === "token" ? "token" : "code",
      scopes: c.scopes,
      providers: xs(c.identity_providers)
    }
  }), u && (l.Cognito.loginWith = {
    ...l.Cognito.loginWith,
    email: u.includes("email"),
    phone: u.includes("phone_number"),
    // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
    username: u.includes("username")
  }), d && (l.Cognito.userAttributes = d.reduce((h, f) => ({ ...h, [f]: { required: !0 } }), {})), l;
}
function ws(e) {
  if (!(e != null && e.amazon_pinpoint))
    return;
  const { amazon_pinpoint: t } = e;
  return {
    Pinpoint: {
      appId: t.app_id,
      region: t.aws_region
    }
  };
}
function As(e) {
  if (!e)
    return;
  const { aws_region: t, geofence_collections: n, maps: i, search_indices: o } = e;
  return {
    LocationService: {
      region: t,
      searchIndices: o,
      geofenceCollections: n,
      maps: i
    }
  };
}
function Ns(e) {
  if (!e)
    return;
  const { aws_region: t, default_authorization_type: n, url: i, api_key: o, model_introspection: r } = e;
  return {
    GraphQL: {
      endpoint: i,
      defaultAuthMode: bs(n),
      region: t,
      apiKey: o,
      modelIntrospection: r
    }
  };
}
function Cs(e) {
  if (!e)
    return;
  const { aws_region: t, channels: n, amazon_pinpoint_app_id: i } = e, o = n.includes("IN_APP_MESSAGING"), r = n.includes("APNS") || n.includes("FCM");
  if (!(o || r))
    return;
  const s = {};
  return o && (s.InAppMessaging = {
    Pinpoint: {
      appId: i,
      region: t
    }
  }), r && (s.PushNotification = {
    Pinpoint: {
      appId: i,
      region: t
    }
  }), s;
}
function Rs(e) {
  const t = {};
  return e.storage && (t.Storage = Ts(e.storage)), e.auth && (t.Auth = vs(e.auth)), e.analytics && (t.Analytics = ws(e.analytics)), e.geo && (t.Geo = As(e.geo)), e.data && (t.API = Ns(e.data)), e.notifications && (t.Notifications = Cs(e.notifications)), t;
}
const _s = {
  AMAZON_COGNITO_USER_POOLS: "userPool",
  API_KEY: "apiKey",
  AWS_IAM: "iam",
  AWS_LAMBDA: "lambda",
  OPENID_CONNECT: "oidc"
};
function bs(e) {
  return _s[e];
}
const Si = {
  GOOGLE: "Google",
  LOGIN_WITH_AMAZON: "Amazon",
  FACEBOOK: "Facebook",
  SIGN_IN_WITH_APPLE: "Apple"
};
function xs(e = []) {
  return e.reduce((t, n) => (Si[n] !== void 0 && t.push(Si[n]), t), []);
}
function Os(e) {
  return e === "OPTIONAL" ? "optional" : e === "REQUIRED" ? "on" : "off";
}
const Ds = (e) => Object.keys(e).some((t) => t.startsWith("aws_")) ? Es(e) : Is(e) ? Rs(e) : e;
function Ii({ expiresAt: e, clockDrift: t }) {
  return Date.now() + t > e;
}
class ks {
  /**
   * Configure Auth category
   *
   * @internal
   *
   * @param authResourcesConfig - Resources configurations required by Auth providers.
   * @param authOptions - Client options used by library
   *
   * @returns void
   */
  configure(t, n) {
    this.authConfig = t, this.authOptions = n;
  }
  /**
   * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
   * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
   * with `{ forceRefresh: true }` input.
   *
   * @param options - Options configuring the fetch behavior.
   *
   * @returns Promise of current auth session {@link AuthSession}.
   */
  async fetchAuthSession(t = {}) {
    var r, s, a, c, u, d;
    let n, i;
    const o = await this.getTokens(t);
    return o ? (i = (s = (r = o.accessToken) == null ? void 0 : r.payload) == null ? void 0 : s.sub, n = await ((c = (a = this.authOptions) == null ? void 0 : a.credentialsProvider) == null ? void 0 : c.getCredentialsAndIdentityId({
      authConfig: this.authConfig,
      tokens: o,
      authenticated: !0,
      forceRefresh: t.forceRefresh
    }))) : n = await ((d = (u = this.authOptions) == null ? void 0 : u.credentialsProvider) == null ? void 0 : d.getCredentialsAndIdentityId({
      authConfig: this.authConfig,
      authenticated: !1,
      forceRefresh: t.forceRefresh
    })), {
      tokens: o,
      credentials: n == null ? void 0 : n.credentials,
      identityId: n == null ? void 0 : n.identityId,
      userSub: i
    };
  }
  async clearCredentials() {
    var t, n;
    await ((n = (t = this.authOptions) == null ? void 0 : t.credentialsProvider) == null ? void 0 : n.clearCredentialsAndIdentityId());
  }
  async getTokens(t) {
    var n, i;
    return await ((i = (n = this.authOptions) == null ? void 0 : n.tokenProvider) == null ? void 0 : i.getTokens(t)) ?? void 0;
  }
}
var V;
(function(e) {
  e.WebUnknown = "0", e.React = "1", e.NextJs = "2", e.Angular = "3", e.VueJs = "4", e.Nuxt = "5", e.Svelte = "6", e.ServerSideUnknown = "100", e.ReactSSR = "101", e.NextJsSSR = "102", e.AngularSSR = "103", e.VueJsSSR = "104", e.NuxtSSR = "105", e.SvelteSSR = "106", e.ReactNative = "201", e.Expo = "202";
})(V || (V = {}));
var Bt;
(function(e) {
  e.API = "api", e.Auth = "auth", e.Analytics = "analytics", e.DataStore = "datastore", e.Geo = "geo", e.InAppMessaging = "inappmessaging", e.Interactions = "interactions", e.Predictions = "predictions", e.PubSub = "pubsub", e.PushNotification = "pushnotification", e.Storage = "storage";
})(Bt || (Bt = {}));
var Ti;
(function(e) {
  e.Record = "1", e.IdentifyUser = "2";
})(Ti || (Ti = {}));
var Tn;
(function(e) {
  e.GraphQl = "1", e.Get = "2", e.Post = "3", e.Put = "4", e.Patch = "5", e.Del = "6", e.Head = "7";
})(Tn || (Tn = {}));
var ue;
(function(e) {
  e.SignUp = "1", e.ConfirmSignUp = "2", e.ResendSignUpCode = "3", e.SignIn = "4", e.FetchMFAPreference = "6", e.UpdateMFAPreference = "7", e.SetUpTOTP = "10", e.VerifyTOTPSetup = "11", e.ConfirmSignIn = "12", e.DeleteUserAttributes = "15", e.DeleteUser = "16", e.UpdateUserAttributes = "17", e.FetchUserAttributes = "18", e.ConfirmUserAttribute = "22", e.SignOut = "26", e.UpdatePassword = "27", e.ResetPassword = "28", e.ConfirmResetPassword = "29", e.FederatedSignIn = "30", e.RememberDevice = "32", e.ForgetDevice = "33", e.FetchDevices = "34", e.SendUserAttributeVerificationCode = "35", e.SignInWithRedirect = "36";
})(ue || (ue = {}));
var vi;
(function(e) {
  e.Subscribe = "1", e.GraphQl = "2";
})(vi || (vi = {}));
var wi;
(function(e) {
  e.SearchByText = "0", e.SearchByCoordinates = "1", e.SearchForSuggestions = "2", e.SearchByPlaceId = "3", e.SaveGeofences = "4", e.GetGeofence = "5", e.ListGeofences = "6", e.DeleteGeofences = "7";
})(wi || (wi = {}));
var Ai;
(function(e) {
  e.SyncMessages = "1", e.IdentifyUser = "2", e.NotifyMessageInteraction = "3";
})(Ai || (Ai = {}));
var Ni;
(function(e) {
  e.None = "0";
})(Ni || (Ni = {}));
var Ci;
(function(e) {
  e.Convert = "1", e.Identify = "2", e.Interpret = "3";
})(Ci || (Ci = {}));
var Ri;
(function(e) {
  e.Subscribe = "1";
})(Ri || (Ri = {}));
var _i;
(function(e) {
  e.InitializePushNotifications = "1", e.IdentifyUser = "2";
})(_i || (_i = {}));
var bi;
(function(e) {
  e.UploadData = "1", e.DownloadData = "2", e.List = "3", e.Copy = "4", e.Remove = "5", e.GetProperties = "6", e.GetUrl = "7";
})(bi || (bi = {}));
const Qt = () => typeof global < "u", Qe = () => typeof window < "u", Vo = () => typeof document < "u", Kn = () => typeof process < "u", ft = (e, t) => !!Object.keys(e).find((n) => n.startsWith(t));
function Ps() {
  const e = (i) => i.startsWith("_react") || i.startsWith("__react"), t = (i) => Object.keys(i).find(e), n = () => Array.from(document.querySelectorAll("[id]"));
  return Vo() && n().some(t);
}
function Ms() {
  return Kn() && typeof process.env < "u" && !!Object.keys(process.env).find((e) => e.includes("react"));
}
function Fs() {
  return Qe() && ft(window, "__VUE");
}
function Ls() {
  return Qt() && ft(global, "__VUE");
}
function Us() {
  return Qe() && ft(window, "__SVELTE");
}
function Ks() {
  return Kn() && typeof process.env < "u" && !!Object.keys(process.env).find((e) => e.includes("svelte"));
}
function Bs() {
  return Qe() && window.next && typeof window.next == "object";
}
function $s() {
  return Qt() && (ft(global, "__next") || ft(global, "__NEXT"));
}
function qs() {
  return Qe() && (window.__NUXT__ !== void 0 || window.$nuxt !== void 0);
}
function Vs() {
  return Qt() && typeof global.__NUXT_PATHS__ < "u";
}
function js() {
  const e = !!(Vo() && document.querySelector("[ng-version]")), t = !!(Qe() && typeof window.ng < "u");
  return e || t;
}
function Hs() {
  var e;
  return Kn() && typeof process.env == "object" && ((e = process.env.npm_lifecycle_script) == null ? void 0 : e.startsWith("ng ")) || !1;
}
function Ws() {
  return typeof navigator < "u" && typeof navigator.product < "u" && navigator.product === "ReactNative";
}
function Gs() {
  return Qt() && typeof global.expo < "u";
}
function zs() {
  return Qe();
}
const Qs = [
  // First, detect mobile
  { platform: V.Expo, detectionMethod: Gs },
  { platform: V.ReactNative, detectionMethod: Ws },
  // Next, detect web frameworks
  { platform: V.NextJs, detectionMethod: Bs },
  { platform: V.Nuxt, detectionMethod: qs },
  { platform: V.Angular, detectionMethod: js },
  { platform: V.React, detectionMethod: Ps },
  { platform: V.VueJs, detectionMethod: Fs },
  { platform: V.Svelte, detectionMethod: Us },
  { platform: V.WebUnknown, detectionMethod: zs },
  // Last, detect ssr frameworks
  { platform: V.NextJsSSR, detectionMethod: $s },
  { platform: V.NuxtSSR, detectionMethod: Vs },
  { platform: V.ReactSSR, detectionMethod: Ms },
  { platform: V.VueJsSSR, detectionMethod: Ls },
  { platform: V.AngularSSR, detectionMethod: Hs },
  { platform: V.SvelteSSR, detectionMethod: Ks }
];
function Ys() {
  var e;
  return ((e = Qs.find((t) => t.detectionMethod())) == null ? void 0 : e.platform) || V.ServerSideUnknown;
}
const Js = () => {
  if (typeof self > "u")
    return !1;
  const e = self;
  return typeof e.WorkerGlobalScope < "u" && self instanceof e.WorkerGlobalScope;
};
class qe {
  networkMonitor(t) {
    const n = Js() ? self : typeof window < "u" && window;
    return n ? new pt((i) => {
      i.next({ online: n.navigator.onLine });
      const o = () => {
        i.next({ online: !0 });
      }, r = () => {
        i.next({ online: !1 });
      };
      return n.addEventListener("online", o), n.addEventListener("offline", r), qe._observers.push(i), () => {
        n.removeEventListener("online", o), n.removeEventListener("offline", r), qe._observers = qe._observers.filter((s) => s !== i);
      };
    }) : os([{ online: !0 }]);
  }
  // expose observers to simulate offline mode for integration testing
  static _observerOverride(t) {
    for (const n of this._observers) {
      if (n.closed) {
        this._observers = this._observers.filter((i) => i !== n);
        continue;
      }
      n != null && n.next && n.next(t);
    }
  }
}
qe._observers = [];
const Bn = () => typeof window < "u" && typeof window.document < "u";
class Xs {
  constructor() {
    this.oAuthListener = void 0, this.resourcesConfig = {}, this.libraryOptions = {}, this.Auth = new ks();
  }
  /**
   * Configures Amplify for use with your back-end resources.
   *
   * @remarks
   * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
   * provided values will be used after configuration.
   *
   * @remarks
   * `configure` can be used to specify additional library options where available for supported categories.
   *
   * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
   * @param libraryOptions - Additional options for customizing the behavior of the library.
   */
  configure(t, n) {
    const i = Ds(t);
    this.resourcesConfig = i, n && (this.libraryOptions = n), this.resourcesConfig = $o(this.resourcesConfig), this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth), ce.dispatch("core", {
      event: "configure",
      data: this.resourcesConfig
    }, "Configure", ae), this.notifyOAuthListener();
  }
  /**
   * Provides access to the current back-end resource configuration for the Library.
   *
   * @returns Returns the immutable back-end resource configuration.
   */
  getConfig() {
    return this.resourcesConfig;
  }
  /** @internal */
  [qo](t) {
    var n, i, o;
    (i = (n = this.resourcesConfig.Auth) == null ? void 0 : n.Cognito.loginWith) != null && i.oauth ? t((o = this.resourcesConfig.Auth) == null ? void 0 : o.Cognito) : this.oAuthListener = t;
  }
  notifyOAuthListener() {
    var t, n, i;
    !((n = (t = this.resourcesConfig.Auth) == null ? void 0 : t.Cognito.loginWith) != null && n.oauth) || !this.oAuthListener || (this.oAuthListener((i = this.resourcesConfig.Auth) == null ? void 0 : i.Cognito), this.oAuthListener = void 0);
  }
}
const J = new Xs(), jo = (e, t) => e.Auth.fetchAuthSession(t), xi = (e) => jo(J, e);
function Ho() {
  return J.Auth.clearCredentials();
}
const Yt = (e) => {
  const { headers: t, statusCode: n } = e;
  return {
    ...Zs(e) ? e.$metadata : {},
    httpStatusCode: n,
    requestId: t["x-amzn-requestid"] ?? t["x-amzn-request-id"] ?? t["x-amz-request-id"],
    extendedRequestId: t["x-amz-id-2"],
    cfId: t["x-amz-cf-id"]
  };
}, Zs = (e) => typeof (e == null ? void 0 : e.$metadata) == "object", Ye = async (e) => {
  if (!e || e.statusCode < 300)
    return;
  const t = await Jt(e), i = ((s) => {
    const [a] = s.toString().split(/[,:]+/);
    return a.includes("#") ? a.split("#")[1] : a;
  })(e.headers["x-amzn-errortype"] ?? t.code ?? t.__type ?? "UnknownError"), o = t.message ?? t.Message ?? "Unknown error", r = new Error(o);
  return Object.assign(r, {
    name: i,
    $metadata: Yt(e)
  });
}, Jt = async (e) => {
  if (!e.body)
    throw new Error("Missing response payload");
  const t = await e.body.json();
  return Object.assign(t, {
    $metadata: Yt(e)
  });
}, Se = (e, t, n, i) => async (o, r) => {
  const s = {
    ...i,
    ...o
  }, a = await s.endpointResolver(s, r), c = await t(r, a), u = await e(c, {
    ...s
  });
  return n(u);
}, Wo = {
  id: "aws",
  outputs: {
    dnsSuffix: "amazonaws.com"
  },
  regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
  regions: ["aws-global"]
}, ea = {
  partitions: [
    Wo,
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn"
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: ["aws-cn-global"]
    }
  ]
}, Go = (e) => {
  const { partitions: t } = ea;
  for (const { regions: n, outputs: i, regionRegex: o } of t) {
    const r = new RegExp(o);
    if (n.includes(e) || r.test(e))
      return i.dnsSuffix;
  }
  return Wo.outputs.dnsSuffix;
}, ta = 3, zo = ({ maxAttempts: e = ta, retryDecider: t, computeDelay: n, abortSignal: i }) => {
  if (e < 1)
    throw new Error("maxAttempts must be greater than 0");
  return (o, r) => async function(a) {
    let c, u = r.attemptsCount ?? 0, d;
    const l = () => {
      if (d)
        return Oi(d, u), d;
      throw Oi(c, u), c;
    };
    for (; !(i != null && i.aborted) && u < e; ) {
      try {
        d = await o(a), c = void 0;
      } catch (h) {
        c = h, d = void 0;
      }
      if (u = (r.attemptsCount ?? 0) > u ? r.attemptsCount ?? 0 : u + 1, r.attemptsCount = u, await t(d, c)) {
        if (!(i != null && i.aborted) && u < e) {
          const h = n(u);
          await na(h, i);
        }
        continue;
      } else
        return l();
    }
    if (i != null && i.aborted)
      throw new Error("Request aborted.");
    return l();
  };
}, na = (e, t) => {
  if (t != null && t.aborted)
    return Promise.resolve();
  let n, i;
  const o = new Promise((r) => {
    i = r, n = setTimeout(r, e);
  });
  return t == null || t.addEventListener("abort", function r(s) {
    clearTimeout(n), t == null || t.removeEventListener("abort", r), i();
  }), o;
}, Oi = (e, t) => {
  Object.prototype.toString.call(e) === "[object Object]" && (e.$metadata = {
    ...e.$metadata ?? {},
    attempts: t
  });
}, Qo = ({ userAgentHeader: e = "x-amz-user-agent", userAgentValue: t = "" }) => (n) => async function(o) {
  if (t.trim().length === 0)
    return await n(o);
  {
    const r = e.toLowerCase();
    return o.headers[r] = o.headers[r] ? `${o.headers[r]} ${t}` : t, await n(o);
  }
}, Xt = (e, t) => (n, i) => {
  const o = {};
  let r = (s) => e(s, i);
  for (let s = t.length - 1; s >= 0; s--) {
    const a = t[s];
    r = a(i)(r, o);
  }
  return r(n);
}, mn = (e) => {
  let t;
  return () => (t || (t = e()), t);
}, ia = (e) => !["HEAD", "GET", "DELETE"].includes(e.toUpperCase()), Yo = async ({ url: e, method: t, headers: n, body: i }, { abortSignal: o, cache: r, withCrossDomainCredentials: s }) => {
  var l;
  let a;
  try {
    a = await fetch(e, {
      method: t,
      headers: n,
      body: ia(t) ? i : void 0,
      signal: o,
      cache: r,
      credentials: s ? "include" : "same-origin"
    });
  } catch (h) {
    throw h instanceof TypeError ? new Error("Network error") : h;
  }
  const c = {};
  (l = a.headers) == null || l.forEach((h, f) => {
    c[f.toLowerCase()] = h;
  });
  const u = {
    statusCode: a.status,
    headers: c,
    body: null
  }, d = Object.assign(a.body ?? {}, {
    text: mn(() => a.text()),
    blob: mn(() => a.blob()),
    json: mn(() => a.json())
  });
  return {
    ...u,
    body: d
  };
}, $n = Xt(Yo, [Qo, zo]), Jo = 5 * 60 * 1e3;
function Xo(e = Jo) {
  return (i) => {
    const o = 2 ** i * 100 + 100 * Math.random();
    return o > e ? !1 : o;
  };
}
const Di = 5 * 60 * 1e3, qn = (e) => {
  const n = Xo(Di)(e);
  return n === !1 ? Di : n;
}, oa = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch",
  "BadRequestException"
  // API Gateway
], ra = (e) => !!e && oa.includes(e), Vn = (e) => async (t, n) => {
  const i = n ?? await e(t) ?? void 0, o = (i == null ? void 0 : i.code) || (i == null ? void 0 : i.name), r = t == null ? void 0 : t.statusCode;
  return ua(n) || ca(r, o) || ra(o) || da(r, o);
}, sa = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException"
], aa = [
  "TimeoutError",
  "RequestTimeout",
  "RequestTimeoutException"
], ca = (e, t) => e === 429 || !!t && sa.includes(t), ua = (e) => (e == null ? void 0 : e.name) === "Network error", da = (e, t) => !!e && [500, 502, 503, 504].includes(e) || !!t && aa.includes(t), de = URL, la = "6.4.4";
let lt;
const _t = [];
let $t = !1;
const ha = 10, pa = 10, fa = 1e3, Zo = () => {
  var e;
  if (!lt) {
    if (lt = Ys(), $t)
      for (; _t.length; )
        (e = _t.pop()) == null || e();
    else
      _t.forEach((t) => {
        t();
      });
    ki(V.ServerSideUnknown, ha), ki(V.WebUnknown, pa);
  }
  return lt;
}, ma = (e) => {
  $t || _t.push(e);
};
function ya() {
  lt = void 0;
}
function ki(e, t) {
  lt === e && !$t && setTimeout(() => {
    ya(), $t = !0, setTimeout(Zo, fa);
  }, t);
}
const Ea = {}, ga = (e, t) => {
  var n, i;
  return (i = (n = Ea[e]) == null ? void 0 : n[t]) == null ? void 0 : i.additionalDetails;
}, Sa = "aws-amplify", Ia = ({ category: e, action: t } = {}) => {
  const n = [[Sa, la]];
  if (e && n.push([e, t]), n.push(["framework", Zo()]), e && t) {
    const i = ga(e, t);
    i && i.forEach((o) => {
      n.push(o);
    });
  }
  return n;
}, Je = (e) => Ia(e).map(([i, o]) => i && o ? `${i}/${o}` : i).join(" "), Ta = "cognito-identity", va = ({ region: e }) => ({
  url: new de(`https://cognito-identity.${e}.${Go(e)}`)
}), wa = () => (e) => async function(n) {
  return n.headers["cache-control"] = "no-store", e(n);
}, er = Xt($n, [wa]), jn = {
  service: Ta,
  endpointResolver: va,
  retryDecider: Vn(Ye),
  computeDelay: qn,
  userAgentValue: Je(),
  cache: "no-store"
};
ma(() => {
  jn.userAgentValue = Je();
});
const tr = (e) => ({
  "content-type": "application/x-amz-json-1.1",
  "x-amz-target": `AWSCognitoIdentityService.${e}`
}), nr = ({ url: e }, t, n) => ({
  headers: t,
  url: e,
  body: n,
  method: "POST"
}), Aa = (e, t) => {
  const n = tr("GetId"), i = JSON.stringify(e);
  return nr(t, n, i);
}, Na = async (e) => {
  if (e.statusCode >= 300)
    throw await Ye(e);
  return {
    IdentityId: (await Jt(e)).IdentityId,
    $metadata: Yt(e)
  };
}, Ca = Se(er, Aa, Na, jn), Ra = (e, t) => {
  const n = tr("GetCredentialsForIdentity"), i = JSON.stringify(e);
  return nr(t, n, i);
}, _a = async (e) => {
  if (e.statusCode >= 300)
    throw await Ye(e);
  {
    const t = await Jt(e);
    return {
      IdentityId: t.IdentityId,
      Credentials: ba(t.Credentials),
      $metadata: Yt(e)
    };
  }
}, ba = ({ AccessKeyId: e, SecretKey: t, SessionToken: n, Expiration: i } = {}) => ({
  AccessKeyId: e,
  SecretKey: t,
  SessionToken: n,
  Expiration: i && new Date(i * 1e3)
}), Pi = Se(er, Ra, _a, jn);
class At extends Y {
  constructor() {
    super({
      name: Kt.PlatformNotSupported,
      message: "Function not supported on current platform"
    });
  }
}
class ir {
  constructor(t) {
    this.storage = t;
  }
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  async setItem(t, n) {
    if (!this.storage)
      throw new At();
    this.storage.setItem(t, n);
  }
  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
  async getItem(t) {
    if (!this.storage)
      throw new At();
    return this.storage.getItem(t);
  }
  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */
  async removeItem(t) {
    if (!this.storage)
      throw new At();
    this.storage.removeItem(t);
  }
  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */
  async clear() {
    if (!this.storage)
      throw new At();
    this.storage.clear();
  }
}
class or {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  get length() {
    return this.storage.size;
  }
  key(t) {
    return t > this.length - 1 ? null : Array.from(this.storage.keys())[t];
  }
  setItem(t, n) {
    this.storage.set(t, n);
  }
  getItem(t) {
    return this.storage.get(t) ?? null;
  }
  removeItem(t) {
    this.storage.delete(t);
  }
  clear() {
    this.storage.clear();
  }
}
const xa = () => typeof window < "u" && window.localStorage ? window.localStorage : new or(), Oa = () => typeof window < "u" && window.sessionStorage ? window.sessionStorage : new or();
class Da extends ir {
  constructor() {
    super(xa());
  }
}
class ka extends ir {
  constructor() {
    super(Oa());
  }
}
class pp {
  constructor(t = {}) {
    const { path: n, domain: i, expires: o, sameSite: r, secure: s } = t;
    if (this.domain = i, this.path = n || "/", this.expires = Object.prototype.hasOwnProperty.call(t, "expires") ? o : 365, this.secure = Object.prototype.hasOwnProperty.call(t, "secure") ? s : !0, Object.prototype.hasOwnProperty.call(t, "sameSite")) {
      if (!r || !["strict", "lax", "none"].includes(r))
        throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
      if (r === "none" && !this.secure)
        throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
      this.sameSite = r;
    }
  }
  async setItem(t, n) {
    vt.set(t, n, this.getData());
  }
  async getItem(t) {
    return vt.get(t) ?? null;
  }
  async removeItem(t) {
    vt.remove(t, this.getData());
  }
  async clear() {
    const t = vt.get(), n = Object.keys(t).map((i) => this.removeItem(i));
    await Promise.all(n);
  }
  getData() {
    return {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure,
      ...this.sameSite && { sameSite: this.sameSite }
    };
  }
}
const Zt = new Da(), fp = new ka(), Pa = as, rr = (e) => Object.keys(e).map((t) => t.toLowerCase()).sort().join(";"), Ma = "X-Amz-Date", Fa = "X-Amz-Security-Token", La = "authorization", Ua = "host", Ka = Ma.toLowerCase(), Ba = Fa.toLowerCase(), sr = "aws4_request", ar = "AWS4-HMAC-SHA256", $a = "AWS4", qa = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855", Va = "UNSIGNED-PAYLOAD", ja = (e, t, n) => `${e}/${t}/${n}/${sr}`, Ha = (e) => {
  const t = e.toISOString().replace(/[:-]|\.\d{3}/g, "");
  return {
    longDate: t,
    shortDate: t.slice(0, 8)
  };
}, Wa = ({ credentials: e, signingDate: t = /* @__PURE__ */ new Date(), signingRegion: n, signingService: i, uriEscapePath: o = !0 }) => {
  const { accessKeyId: r, secretAccessKey: s, sessionToken: a } = e, { longDate: c, shortDate: u } = Ha(t), d = ja(u, n, i);
  return {
    accessKeyId: r,
    credentialScope: d,
    longDate: c,
    secretAccessKey: s,
    sessionToken: a,
    shortDate: u,
    signingRegion: n,
    signingService: i,
    uriEscapePath: o
  };
}, ut = (e, t) => {
  const n = new je(e ?? void 0);
  return n.update(t), n.digestSync();
}, vn = (e, t) => {
  const n = ut(e, t);
  return is(n);
}, Ga = (e) => Object.entries(e).map(([t, n]) => ({
  key: t.toLowerCase(),
  value: (n == null ? void 0 : n.trim().replace(/\s+/g, " ")) ?? ""
})).sort((t, n) => t.key < n.key ? -1 : 1).map((t) => `${t.key}:${t.value}
`).join(""), za = (e) => Array.from(e).sort(([t, n], [i, o]) => t === i ? n < o ? -1 : 1 : t < i ? -1 : 1).map(([t, n]) => `${Mi(t)}=${Mi(n)}`).join("&"), Mi = (e) => encodeURIComponent(e).replace(/[!'()*]/g, Qa), Qa = (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`, Ya = (e, t = !0) => e ? t ? encodeURIComponent(e).replace(/%2F/g, "/") : e : "/", Ja = (e) => e == null ? qa : Xa(e) ? vn(null, e) : Va, Xa = (e) => typeof e == "string" || ArrayBuffer.isView(e) || Za(e), Za = (e) => typeof ArrayBuffer == "function" && e instanceof ArrayBuffer || Object.prototype.toString.call(e) === "[object ArrayBuffer]", ec = ({ body: e, headers: t, method: n, url: i }, o = !0) => [
  n,
  Ya(i.pathname, o),
  za(i.searchParams),
  Ga(t),
  rr(t),
  Ja(e)
].join(`
`), tc = (e, t, n, i) => {
  const o = `${$a}${e}`, r = ut(o, t), s = ut(r, n), a = ut(s, i);
  return ut(a, sr);
}, nc = (e, t, n) => [ar, e, t, n].join(`
`), ic = (e, { credentialScope: t, longDate: n, secretAccessKey: i, shortDate: o, signingRegion: r, signingService: s, uriEscapePath: a }) => {
  const c = ec(e, a), u = vn(null, c), d = nc(n, t, u);
  return vn(tc(i, o, r, s), d);
}, cr = (e, t) => {
  const n = Wa(t), { accessKeyId: i, credentialScope: o, longDate: r, sessionToken: s } = n, a = { ...e.headers };
  a[Ua] = e.url.host, a[Ka] = r, s && (a[Ba] = s);
  const c = { ...e, headers: a }, u = ic(c, n), d = `Credential=${i}/${o}`, l = `SignedHeaders=${rr(a)}`, h = `Signature=${u}`;
  return a[La] = `${ar} ${d}, ${l}, ${h}`, c;
}, ur = (e) => new Date(Date.now() + e), oc = 5 * 60 * 1e3, rc = (e, t) => Math.abs(ur(t).getTime() - e) >= oc, sc = (e, t) => rc(e, t) ? e - Date.now() : t, ac = ({ credentials: e, region: t, service: n, uriEscapePath: i = !0 }) => {
  let o;
  return (r) => async function(a) {
    o = o ?? 0;
    const c = {
      credentials: typeof e == "function" ? await e() : e,
      signingDate: ur(o),
      signingRegion: t,
      signingService: n,
      uriEscapePath: i
    }, u = await cr(a, c), d = await r(u), l = cc(d);
    return l && (o = sc(Date.parse(l), o)), d;
  };
}, cc = ({ headers: e } = {}) => (e == null ? void 0 : e.date) ?? (e == null ? void 0 : e.Date) ?? (e == null ? void 0 : e["x-amz-date"]), uc = Xt(Yo, [
  Qo,
  zo,
  ac
]), dc = (e) => {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let n = "";
  for (let i = 0; i < e; i++)
    n += t.charAt(Math.floor(Math.random() * t.length));
  return n;
};
class lc extends Error {
  constructor() {
    super(...arguments), this.nonRetryable = !0;
  }
}
const hc = (e, t, n = Jo, i) => fs(e, t, Xo(n), i);
function pc(e) {
  return (e.match(/.{2}/g) || []).map((n) => String.fromCharCode(parseInt(n, 16))).join("");
}
function fc(e) {
  return e.split("").map((t) => t.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}
const mc = (e) => {
  let t;
  return async (...n) => t || (t = new Promise((i, o) => {
    e(...n).then((r) => {
      i(r);
    }).catch((r) => {
      o(r);
    }).finally(() => {
      t = void 0;
    });
  }), t);
}, yc = async () => {
  const { userAgentData: e } = navigator;
  if (!e)
    return navigator.userAgent;
  const { platform: t = "", platformVersion: n = "", model: i = "", architecture: o = "", fullVersionList: r = [] } = await e.getHighEntropyValues([
    "platform",
    "platformVersion",
    "architecture",
    "model",
    "fullVersionList"
  ]), s = r.map((c) => `${c.brand}/${c.version}`).join(";");
  return [
    t,
    n,
    o,
    i,
    t,
    s
  ].filter((c) => c).join(" ");
};
class qt extends Y {
  /**
   * The unwrapped HTTP response causing the given API error.
   */
  get response() {
    return this._response ? Ec(this._response) : void 0;
  }
  constructor(t) {
    super(t), this.constructor = qt, Object.setPrototypeOf(this, qt.prototype), t.response && (this._response = t.response);
  }
}
const Ec = (e) => ({
  ...e,
  headers: { ...e.headers }
});
function gc(e) {
  return Array.from(e, (t) => String.fromCodePoint(t)).join("");
}
const be = {
  convert(e, { urlSafe: t } = { urlSafe: !1 }) {
    const n = typeof e == "string" ? e : gc(e), i = ls()(n);
    return t ? i.replace(/\+/g, "-").replace(/\//g, "_") : i;
  }
};
function Sc() {
  return Uo().getRandomValues(new Uint32Array(1))[0];
}
function Ic(e) {
  const { words: t } = e, { sigBytes: n } = e, i = [];
  for (let o = 0; o < n; o++) {
    const r = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
    i.push((r >>> 4).toString(16)), i.push((r & 15).toString(16));
  }
  return i.join("");
}
class Hn {
  constructor(t, n) {
    this.words = [];
    let i = t;
    i = this.words = i || [], n !== void 0 ? this.sigBytes = n : this.sigBytes = i.length * 4;
  }
  random(t) {
    const n = [];
    for (let i = 0; i < t; i += 4)
      n.push(Sc());
    return new Hn(n, t);
  }
  toString() {
    return Ic(this);
  }
}
class x extends Y {
  constructor(t) {
    super(t), this.constructor = x, Object.setPrototypeOf(this, x.prototype);
  }
}
function Xe(e) {
  if (!e || e.name === "Error" || e instanceof TypeError)
    throw new x({
      name: Kt.Unknown,
      message: "An unknown error has occurred.",
      underlyingError: e
    });
}
const dr = "cognito-idp", Tc = ({ region: e }) => {
  var o;
  const t = (o = J.getConfig().Auth) == null ? void 0 : o.Cognito, n = t == null ? void 0 : t.userPoolEndpoint, i = new de(`https://${dr}.${e}.${Go(e)}`);
  return {
    url: n ? new de(n) : i
  };
}, vc = () => (e, t) => async function(i) {
  return i.headers["cache-control"] = "no-store", e(i);
}, ke = Xt($n, [vc]), Pe = {
  service: dr,
  endpointResolver: Tc,
  retryDecider: Vn(Ye),
  computeDelay: qn,
  userAgentValue: Je(),
  cache: "no-store"
}, wc = (e) => ({
  "content-type": "application/x-amz-json-1.1",
  "x-amz-target": `AWSCognitoIdentityProviderService.${e}`
}), Ac = ({ url: e }, t, n) => ({
  headers: t,
  url: e,
  body: n,
  method: "POST"
}), Me = (e) => (t, n) => {
  const i = wc(e), o = JSON.stringify(t);
  return Ac(n, i, o);
}, Fe = () => async (e) => {
  if (e.statusCode >= 300) {
    const t = await Ye(e);
    throw Xe(t), new x({ name: t.name, message: t.message });
  } else
    return await Jt(e);
}, It = Se(ke, Me("InitiateAuth"), Fe(), Pe), Nc = Se(ke, Me("RevokeToken"), Fe(), Pe), Wn = Se(ke, Me("RespondToAuthChallenge"), Fe(), Pe), Cc = Se(ke, Me("AssociateSoftwareToken"), Fe(), Pe), Rc = Se(ke, Me("GetUser"), Fe(), Pe), _c = Se(ke, Me("ConfirmDevice"), Fe(), Pe), bc = Se(ke, Me("GlobalSignOut"), Fe(), Pe);
var P;
(function(e) {
  e.EmptySignInUsername = "EmptySignInUsername", e.EmptySignInPassword = "EmptySignInPassword", e.CustomAuthSignInPassword = "CustomAuthSignInPassword", e.EmptySignUpUsername = "EmptySignUpUsername", e.EmptySignUpPassword = "EmptySignUpPassword", e.EmptyConfirmSignUpUsername = "EmptyConfirmSignUpUsername", e.EmptyConfirmSignUpCode = "EmptyConfirmSignUpCode", e.EmptyResendSignUpCodeUsername = "EmptyresendSignUpCodeUsername", e.EmptyChallengeResponse = "EmptyChallengeResponse", e.EmptyConfirmResetPasswordUsername = "EmptyConfirmResetPasswordUsername", e.EmptyConfirmResetPasswordNewPassword = "EmptyConfirmResetPasswordNewPassword", e.EmptyConfirmResetPasswordConfirmationCode = "EmptyConfirmResetPasswordConfirmationCode", e.EmptyResetPasswordUsername = "EmptyResetPasswordUsername", e.EmptyVerifyTOTPSetupCode = "EmptyVerifyTOTPSetupCode", e.EmptyConfirmUserAttributeCode = "EmptyConfirmUserAttributeCode", e.IncorrectMFAMethod = "IncorrectMFAMethod", e.EmptyUpdatePassword = "EmptyUpdatePassword";
})(P || (P = {}));
const xc = {
  [P.EmptyChallengeResponse]: {
    message: "challengeResponse is required to confirmSignIn"
  },
  [P.EmptyConfirmResetPasswordUsername]: {
    message: "username is required to confirmResetPassword"
  },
  [P.EmptyConfirmSignUpCode]: {
    message: "code is required to confirmSignUp"
  },
  [P.EmptyConfirmSignUpUsername]: {
    message: "username is required to confirmSignUp"
  },
  [P.EmptyConfirmResetPasswordConfirmationCode]: {
    message: "confirmationCode is required to confirmResetPassword"
  },
  [P.EmptyConfirmResetPasswordNewPassword]: {
    message: "newPassword is required to confirmResetPassword"
  },
  [P.EmptyResendSignUpCodeUsername]: {
    message: "username is required to confirmSignUp"
  },
  [P.EmptyResetPasswordUsername]: {
    message: "username is required to resetPassword"
  },
  [P.EmptySignInPassword]: {
    message: "password is required to signIn"
  },
  [P.EmptySignInUsername]: {
    message: "username is required to signIn"
  },
  [P.EmptySignUpPassword]: {
    message: "password is required to signUp"
  },
  [P.EmptySignUpUsername]: {
    message: "username is required to signUp"
  },
  [P.CustomAuthSignInPassword]: {
    message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
    recoverySuggestion: "Do not include a password in your signIn call."
  },
  [P.IncorrectMFAMethod]: {
    message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
    recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
  },
  [P.EmptyVerifyTOTPSetupCode]: {
    message: "code is required to verifyTotpSetup"
  },
  [P.EmptyUpdatePassword]: {
    message: "oldPassword and newPassword are required to changePassword"
  },
  [P.EmptyConfirmUserAttributeCode]: {
    message: "confirmation code is required to confirmUserAttribute"
  }
};
var j;
(function(e) {
  e.DEFAULT_MSG = "Authentication Error", e.EMPTY_EMAIL = "Email cannot be empty", e.EMPTY_PHONE = "Phone number cannot be empty", e.EMPTY_USERNAME = "Username cannot be empty", e.INVALID_USERNAME = "The username should either be a string or one of the sign in types", e.EMPTY_PASSWORD = "Password cannot be empty", e.EMPTY_CODE = "Confirmation code cannot be empty", e.SIGN_UP_ERROR = "Error creating account", e.NO_MFA = "No valid MFA method provided", e.INVALID_MFA = "Invalid MFA type", e.EMPTY_CHALLENGE = "Challenge response cannot be empty", e.NO_USER_SESSION = "Failed to get the session because the user is empty", e.NETWORK_ERROR = "Network Error", e.DEVICE_CONFIG = "Device tracking has not been configured in this User Pool", e.AUTOSIGNIN_ERROR = "Please use your credentials to sign in", e.OAUTH_ERROR = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})(j || (j = {}));
var mt;
(function(e) {
  e.SignInException = "SignInException", e.OAuthSignInError = "OAuthSignInException";
})(mt || (mt = {}));
function Ae(e, t) {
  const { message: n, recoverySuggestion: i } = xc[t];
  if (!e)
    throw new x({ name: t, message: n, recoverySuggestion: i });
}
function te(e) {
  const t = e == null ? void 0 : e.split("_")[0];
  if (!e || e.indexOf("_") < 0 || !t || typeof t != "string")
    throw new x({
      name: "InvalidUserPoolId",
      message: "Invalid user pool id provided."
    });
  return t;
}
function wn(e) {
  if (!e || !e.includes(":"))
    throw new x({
      name: "InvalidIdentityPoolIdException",
      message: "Invalid identity pool id provided.",
      recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
  return e.split(":")[0];
}
function Oc(e) {
  const t = {};
  return e == null || e.forEach((n) => {
    n.Name && (t[n.Name] = n.Value);
  }), t;
}
var Fi;
(function(e) {
  e.ConcurrentModificationException = "ConcurrentModificationException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException";
})(Fi || (Fi = {}));
var Li;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Li || (Li = {}));
var Ui;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UsernameExistsException = "UsernameExistsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Ui || (Ui = {}));
var Ki;
(function(e) {
  e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyFailedAttemptsException = "TooManyFailedAttemptsException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Ki || (Ki = {}));
var Bi;
(function(e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyFailedAttemptsException = "TooManyFailedAttemptsException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(Bi || (Bi = {}));
var $i;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})($i || ($i = {}));
var qi;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(qi || (qi = {}));
var Vi;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Vi || (Vi = {}));
var ji;
(function(e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(ji || (ji = {}));
var Hi;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Hi || (Hi = {}));
var Wi;
(function(e) {
  e.ExternalServiceException = "ExternalServiceException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceConflictException = "ResourceConflictException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException";
})(Wi || (Wi = {}));
var Gi;
(function(e) {
  e.ExternalServiceException = "ExternalServiceException", e.InternalErrorException = "InternalErrorException", e.InvalidIdentityPoolConfigurationException = "InvalidIdentityPoolConfigurationException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceConflictException = "ResourceConflictException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException";
})(Gi || (Gi = {}));
var zi;
(function(e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(zi || (zi = {}));
var Qi;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException";
})(Qi || (Qi = {}));
var Vt;
(function(e) {
  e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Vt || (Vt = {}));
var Yi;
(function(e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotFoundException = "UserNotFoundException";
})(Yi || (Yi = {}));
var Ji;
(function(e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.MFAMethodNotFoundException = "MFAMethodNotFoundException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Ji || (Ji = {}));
var Xi;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(Xi || (Xi = {}));
var Zi;
(function(e) {
  e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidPasswordException = "InvalidPasswordException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.NotAuthorizedException = "NotAuthorizedException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UsernameExistsException = "UsernameExistsException";
})(Zi || (Zi = {}));
var eo;
(function(e) {
  e.AliasExistsException = "AliasExistsException", e.CodeDeliveryFailureException = "CodeDeliveryFailureException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException", e.InvalidLambdaResponseException = "InvalidLambdaResponseException", e.InvalidParameterException = "InvalidParameterException", e.InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException", e.InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UnexpectedLambdaException = "UnexpectedLambdaException", e.UserLambdaValidationException = "UserLambdaValidationException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(eo || (eo = {}));
var to;
(function(e) {
  e.CodeMismatchException = "CodeMismatchException", e.EnableSoftwareTokenMFAException = "EnableSoftwareTokenMFAException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.SoftwareTokenMFANotFoundException = "SoftwareTokenMFANotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(to || (to = {}));
var no;
(function(e) {
  e.AliasExistsException = "AliasExistsException", e.CodeMismatchException = "CodeMismatchException", e.ExpiredCodeException = "ExpiredCodeException", e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.LimitExceededException = "LimitExceededException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(no || (no = {}));
var io;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(io || (io = {}));
var oo;
(function(e) {
  e.ForbiddenException = "ForbiddenException", e.InternalErrorException = "InternalErrorException", e.InvalidParameterException = "InvalidParameterException", e.InvalidUserPoolConfigurationException = "InvalidUserPoolConfigurationException", e.NotAuthorizedException = "NotAuthorizedException", e.PasswordResetRequiredException = "PasswordResetRequiredException", e.ResourceNotFoundException = "ResourceNotFoundException", e.TooManyRequestsException = "TooManyRequestsException", e.UserNotConfirmedException = "UserNotConfirmedException", e.UserNotFoundException = "UserNotFoundException";
})(oo || (oo = {}));
const en = "UserUnAuthenticatedException", Dc = "UserAlreadyAuthenticatedException", kc = "DeviceMetadataNotFoundException", Pc = "InvalidRedirectException", Mc = new x({
  name: Pc,
  message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
  recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
}), Fc = "InvalidOriginException", Lc = new x({
  name: Fc,
  message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
  recoverySuggestion: "Please call signInWithRedirect from the same origin."
}), Uc = "OAuthSignOutException", Kc = "TokenRefreshException", Bc = "UnexpectedSignInInterruptionException";
function Gn(e) {
  if (!e || !e.accessToken)
    throw new x({
      name: en,
      message: "User needs to be authenticated to call this API.",
      recoverySuggestion: "Sign in before calling this API again."
    });
}
function $c(e) {
  if (!e || !e.idToken)
    throw new x({
      name: en,
      message: "User needs to be authenticated to call this API.",
      recoverySuggestion: "Sign in before calling this API again."
    });
}
const qc = new x({
  name: Kc,
  message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
  recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
}), Vc = new x({
  name: en,
  message: "User needs to be authenticated to call this API.",
  recoverySuggestion: "Sign in before calling this API again."
});
function lr(e) {
  if (Wc(e))
    throw qc;
  if (!Hc(e))
    throw Vc;
}
function hr(e) {
  if (!e || !e.deviceKey || !e.deviceGroupKey || !e.randomPassword)
    throw new x({
      name: kc,
      message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
      recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const jc = {
  inflightOAuth: "inflightOAuth",
  oauthSignIn: "oauthSignIn",
  oauthPKCE: "oauthPKCE",
  oauthState: "oauthState"
};
function pr(e) {
  return (e == null ? void 0 : e.accessToken) || (e == null ? void 0 : e.idToken);
}
function Hc(e) {
  return pr(e) && (e == null ? void 0 : e.refreshToken);
}
function Wc(e) {
  return pr(e) && !(e != null && e.refreshToken);
}
const Gc = async (e) => {
  var a, c;
  const t = (a = e.getConfig().Auth) == null ? void 0 : a.Cognito;
  L(t);
  const n = await e.Auth.getTokens({ forceRefresh: !1 });
  Gn(n);
  const { "cognito:username": i, sub: o } = ((c = n.idToken) == null ? void 0 : c.payload) ?? {}, r = {
    username: i,
    userId: o
  }, s = zc(n);
  return s && (r.signInDetails = s), r;
};
function zc(e) {
  return e == null ? void 0 : e.signInDetails;
}
const fr = async () => Gc(J), Ie = (e, t) => Je({
  category: Bt.Auth,
  action: e,
  ...t
}), Qc = (e, t) => {
  switch (t.type) {
    case "SET_SIGN_IN_SESSION":
      return {
        ...e,
        signInSession: t.value
      };
    case "SET_SIGN_IN_STATE":
      return {
        ...t.value
      };
    case "SET_CHALLENGE_NAME":
      return {
        ...e,
        challengeName: t.value
      };
    case "SET_USERNAME":
      return {
        ...e,
        username: t.value
      };
    case "SET_INITIAL_STATE":
      return mr();
    default:
      return e;
  }
};
function mr() {
  return {
    username: void 0,
    challengeName: void 0,
    signInSession: void 0
  };
}
const Yc = (e) => {
  let t = e(mr(), { type: "SET_INITIAL_STATE" });
  return {
    getState: () => t,
    dispatch: (n) => {
      t = e(t, n);
    }
  };
}, He = Yc(Qc);
function tn(e) {
  He.dispatch({
    type: "SET_SIGN_IN_STATE",
    value: e
  });
}
function Ne() {
  He.dispatch({ type: "SET_INITIAL_STATE" });
}
const bt = {
  convert(e) {
    return new TextEncoder().encode(e);
  }
};
function I(e, t) {
  e != null && this.fromString(e, t);
}
function z() {
  return new I(null, null);
}
let we;
const Jc = 244837814094590, ro = (Jc & 16777215) === 15715070;
function Xc(e, t, n, i, o, r) {
  for (; --r >= 0; ) {
    const s = t * this[e++] + n[i] + o;
    o = Math.floor(s / 67108864), n[i++] = s & 67108863;
  }
  return o;
}
function Zc(e, t, n, i, o, r) {
  const s = t & 32767, a = t >> 15;
  for (; --r >= 0; ) {
    let c = this[e] & 32767;
    const u = this[e++] >> 15, d = a * c + u * s;
    c = s * c + ((d & 32767) << 15) + n[i] + (o & 1073741823), o = (c >>> 30) + (d >>> 15) + a * u + (o >>> 30), n[i++] = c & 1073741823;
  }
  return o;
}
function eu(e, t, n, i, o, r) {
  const s = t & 16383, a = t >> 14;
  for (; --r >= 0; ) {
    let c = this[e] & 16383;
    const u = this[e++] >> 14, d = a * c + u * s;
    c = s * c + ((d & 16383) << 14) + n[i] + o, o = (c >> 28) + (d >> 14) + a * u, n[i++] = c & 268435455;
  }
  return o;
}
const so = typeof navigator < "u";
so && ro && navigator.appName === "Microsoft Internet Explorer" ? (I.prototype.am = Zc, we = 30) : so && ro && navigator.appName !== "Netscape" ? (I.prototype.am = Xc, we = 26) : (I.prototype.am = eu, we = 28);
I.prototype.DB = we;
I.prototype.DM = (1 << we) - 1;
I.prototype.DV = 1 << we;
const zn = 52;
I.prototype.FV = Math.pow(2, zn);
I.prototype.F1 = zn - we;
I.prototype.F2 = 2 * we - zn;
const tu = "0123456789abcdefghijklmnopqrstuvwxyz", nn = [];
let Ze, ne;
Ze = "0".charCodeAt(0);
for (ne = 0; ne <= 9; ++ne)
  nn[Ze++] = ne;
Ze = "a".charCodeAt(0);
for (ne = 10; ne < 36; ++ne)
  nn[Ze++] = ne;
Ze = "A".charCodeAt(0);
for (ne = 10; ne < 36; ++ne)
  nn[Ze++] = ne;
function ao(e) {
  return tu.charAt(e);
}
function nu(e, t) {
  const n = nn[e.charCodeAt(t)];
  return n ?? -1;
}
function iu(e) {
  for (let t = this.t - 1; t >= 0; --t)
    e[t] = this[t];
  e.t = this.t, e.s = this.s;
}
function ou(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
}
function Qn(e) {
  const t = z();
  return t.fromInt(e), t;
}
function ru(e, t) {
  let n;
  if (t === 16)
    n = 4;
  else if (t === 8)
    n = 3;
  else if (t === 2)
    n = 1;
  else if (t === 32)
    n = 5;
  else if (t === 4)
    n = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0, this.s = 0;
  let i = e.length, o = !1, r = 0;
  for (; --i >= 0; ) {
    const s = nu(e, i);
    if (s < 0) {
      e.charAt(i) === "-" && (o = !0);
      continue;
    }
    o = !1, r === 0 ? this[this.t++] = s : r + n > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - r) - 1) << r, this[this.t++] = s >> this.DB - r) : this[this.t - 1] |= s << r, r += n, r >= this.DB && (r -= this.DB);
  }
  this.clamp(), o && I.ZERO.subTo(this, this);
}
function su() {
  const e = this.s & this.DM;
  for (; this.t > 0 && this[this.t - 1] == e; )
    --this.t;
}
function au(e) {
  if (this.s < 0)
    return "-" + this.negate().toString(e);
  let t;
  if (e == 16)
    t = 4;
  else if (e === 8)
    t = 3;
  else if (e === 2)
    t = 1;
  else if (e === 32)
    t = 5;
  else if (e === 4)
    t = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  const n = (1 << t) - 1;
  let i, o = !1, r = "", s = this.t, a = this.DB - s * this.DB % t;
  if (s-- > 0)
    for (a < this.DB && (i = this[s] >> a) > 0 && (o = !0, r = ao(i)); s >= 0; )
      a < t ? (i = (this[s] & (1 << a) - 1) << t - a, i |= this[--s] >> (a += this.DB - t)) : (i = this[s] >> (a -= t) & n, a <= 0 && (a += this.DB, --s)), i > 0 && (o = !0), o && (r += ao(i));
  return o ? r : "0";
}
function cu() {
  const e = z();
  return I.ZERO.subTo(this, e), e;
}
function uu() {
  return this.s < 0 ? this.negate() : this;
}
function du(e) {
  let t = this.s - e.s;
  if (t != 0)
    return t;
  let n = this.t;
  if (t = n - e.t, t != 0)
    return this.s < 0 ? -t : t;
  for (; --n >= 0; )
    if ((t = this[n] - e[n]) != 0)
      return t;
  return 0;
}
function Yn(e) {
  let t = 1, n;
  return (n = e >>> 16) !== 0 && (e = n, t += 16), (n = e >> 8) !== 0 && (e = n, t += 8), (n = e >> 4) !== 0 && (e = n, t += 4), (n = e >> 2) !== 0 && (e = n, t += 2), (n = e >> 1) !== 0 && (e = n, t += 1), t;
}
function lu() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + Yn(this[this.t - 1] ^ this.s & this.DM);
}
function hu(e, t) {
  let n;
  for (n = this.t - 1; n >= 0; --n)
    t[n + e] = this[n];
  for (n = e - 1; n >= 0; --n)
    t[n] = 0;
  t.t = this.t + e, t.s = this.s;
}
function pu(e, t) {
  for (let n = e; n < this.t; ++n)
    t[n - e] = this[n];
  t.t = Math.max(this.t - e, 0), t.s = this.s;
}
function fu(e, t) {
  const n = e % this.DB, i = this.DB - n, o = (1 << i) - 1, r = Math.floor(e / this.DB);
  let s = this.s << n & this.DM, a;
  for (a = this.t - 1; a >= 0; --a)
    t[a + r + 1] = this[a] >> i | s, s = (this[a] & o) << n;
  for (a = r - 1; a >= 0; --a)
    t[a] = 0;
  t[r] = s, t.t = this.t + r + 1, t.s = this.s, t.clamp();
}
function mu(e, t) {
  t.s = this.s;
  const n = Math.floor(e / this.DB);
  if (n >= this.t) {
    t.t = 0;
    return;
  }
  const i = e % this.DB, o = this.DB - i, r = (1 << i) - 1;
  t[0] = this[n] >> i;
  for (let s = n + 1; s < this.t; ++s)
    t[s - n - 1] |= (this[s] & r) << o, t[s - n] = this[s] >> i;
  i > 0 && (t[this.t - n - 1] |= (this.s & r) << o), t.t = this.t - n, t.clamp();
}
function yu(e, t) {
  let n = 0, i = 0;
  const o = Math.min(e.t, this.t);
  for (; n < o; )
    i += this[n] - e[n], t[n++] = i & this.DM, i >>= this.DB;
  if (e.t < this.t) {
    for (i -= e.s; n < this.t; )
      i += this[n], t[n++] = i & this.DM, i >>= this.DB;
    i += this.s;
  } else {
    for (i += this.s; n < e.t; )
      i -= e[n], t[n++] = i & this.DM, i >>= this.DB;
    i -= e.s;
  }
  t.s = i < 0 ? -1 : 0, i < -1 ? t[n++] = this.DV + i : i > 0 && (t[n++] = i), t.t = n, t.clamp();
}
function Eu(e, t) {
  const n = this.abs(), i = e.abs();
  let o = n.t;
  for (t.t = o + i.t; --o >= 0; )
    t[o] = 0;
  for (o = 0; o < i.t; ++o)
    t[o + n.t] = n.am(0, i[o], t, o, 0, n.t);
  t.s = 0, t.clamp(), this.s !== e.s && I.ZERO.subTo(t, t);
}
function gu(e) {
  const t = this.abs();
  let n = e.t = 2 * t.t;
  for (; --n >= 0; )
    e[n] = 0;
  for (n = 0; n < t.t - 1; ++n) {
    const i = t.am(n, t[n], e, 2 * n, 0, 1);
    (e[n + t.t] += t.am(n + 1, 2 * t[n], e, 2 * n + 1, i, t.t - n - 1)) >= t.DV && (e[n + t.t] -= t.DV, e[n + t.t + 1] = 1);
  }
  e.t > 0 && (e[e.t - 1] += t.am(n, t[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
}
function Su(e, t, n) {
  const i = e.abs();
  if (i.t <= 0)
    return;
  const o = this.abs();
  if (o.t < i.t) {
    t != null && t.fromInt(0), n != null && this.copyTo(n);
    return;
  }
  n === null && (n = z());
  const r = z(), s = this.s, a = e.s, c = this.DB - Yn(i[i.t - 1]);
  c > 0 ? (i.lShiftTo(c, r), o.lShiftTo(c, n)) : (i.copyTo(r), o.copyTo(n));
  const u = r.t, d = r[u - 1];
  if (d === 0)
    return;
  const l = d * (1 << this.F1) + (u > 1 ? r[u - 2] >> this.F2 : 0), h = this.FV / l, f = (1 << this.F1) / l, p = 1 << this.F2;
  let m = n.t, g = m - u;
  const E = t === null ? z() : t;
  for (r.dlShiftTo(g, E), n.compareTo(E) >= 0 && (n[n.t++] = 1, n.subTo(E, n)), I.ONE.dlShiftTo(u, E), E.subTo(r, r); r.t < u; )
    r[r.t++] = 0;
  for (; --g >= 0; ) {
    let S = n[--m] === d ? this.DM : Math.floor(n[m] * h + (n[m - 1] + p) * f);
    if ((n[m] += r.am(0, S, n, g, 0, u)) < S)
      for (r.dlShiftTo(g, E), n.subTo(E, n); n[m] < --S; )
        n.subTo(E, n);
  }
  t !== null && (n.drShiftTo(u, t), s !== a && I.ZERO.subTo(t, t)), n.t = u, n.clamp(), c > 0 && n.rShiftTo(c, n), s < 0 && I.ZERO.subTo(n, n);
}
function Iu(e) {
  const t = z();
  return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(I.ZERO) > 0 && e.subTo(t, t), t;
}
function Tu() {
  if (this.t < 1)
    return 0;
  const e = this[0];
  if (!(e & 1))
    return 0;
  let t = e & 3;
  return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function vu(e) {
  return this.compareTo(e) === 0;
}
function wu(e, t) {
  let n = 0, i = 0;
  const o = Math.min(e.t, this.t);
  for (; n < o; )
    i += this[n] + e[n], t[n++] = i & this.DM, i >>= this.DB;
  if (e.t < this.t) {
    for (i += e.s; n < this.t; )
      i += this[n], t[n++] = i & this.DM, i >>= this.DB;
    i += this.s;
  } else {
    for (i += this.s; n < e.t; )
      i += e[n], t[n++] = i & this.DM, i >>= this.DB;
    i += e.s;
  }
  t.s = i < 0 ? -1 : 0, i > 0 ? t[n++] = i : i < -1 && (t[n++] = this.DV + i), t.t = n, t.clamp();
}
function Au(e) {
  const t = z();
  return this.addTo(e, t), t;
}
function Nu(e) {
  const t = z();
  return this.subTo(e, t), t;
}
function Cu(e) {
  const t = z();
  return this.multiplyTo(e, t), t;
}
function Ru(e) {
  const t = z();
  return this.divRemTo(e, t, null), t;
}
function et(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function _u(e) {
  const t = z();
  return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(I.ZERO) > 0 && this.m.subTo(t, t), t;
}
function bu(e) {
  const t = z();
  return e.copyTo(t), this.reduce(t), t;
}
function xu(e) {
  for (; e.t <= this.mt2; )
    e[e.t++] = 0;
  for (let t = 0; t < this.m.t; ++t) {
    let n = e[t] & 32767;
    const i = n * this.mpl + ((n * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (n = t + this.m.t, e[n] += this.m.am(0, i, e, t, 0, this.m.t); e[n] >= e.DV; )
      e[n] -= e.DV, e[++n]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function Ou(e, t) {
  e.squareTo(t), this.reduce(t);
}
function Du(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
et.prototype.convert = _u;
et.prototype.revert = bu;
et.prototype.reduce = xu;
et.prototype.mulTo = Du;
et.prototype.sqrTo = Ou;
function ku(e, t, n) {
  let i = e.bitLength(), o, r = Qn(1);
  const s = new et(t);
  if (i <= 0)
    return r;
  i < 18 ? o = 1 : i < 48 ? o = 3 : i < 144 ? o = 4 : i < 768 ? o = 5 : o = 6;
  const a = [];
  let c = 3;
  const u = o - 1, d = (1 << o) - 1;
  if (a[1] = s.convert(this), o > 1) {
    const E = z();
    for (s.sqrTo(a[1], E); c <= d; )
      a[c] = z(), s.mulTo(E, a[c - 2], a[c]), c += 2;
  }
  let l = e.t - 1, h, f = !0, p = z(), m;
  for (i = Yn(e[l]) - 1; l >= 0; ) {
    for (i >= u ? h = e[l] >> i - u & d : (h = (e[l] & (1 << i + 1) - 1) << u - i, l > 0 && (h |= e[l - 1] >> this.DB + i - u)), c = o; !(h & 1); )
      h >>= 1, --c;
    if ((i -= c) < 0 && (i += this.DB, --l), f)
      a[h].copyTo(r), f = !1;
    else {
      for (; c > 1; )
        s.sqrTo(r, p), s.sqrTo(p, r), c -= 2;
      c > 0 ? s.sqrTo(r, p) : (m = r, r = p, p = m), s.mulTo(p, a[h], r);
    }
    for (; l >= 0 && !(e[l] & 1 << i); )
      s.sqrTo(r, p), m = r, r = p, p = m, --i < 0 && (i = this.DB - 1, --l);
  }
  const g = s.revert(r);
  return n(null, g), g;
}
I.prototype.copyTo = iu;
I.prototype.fromInt = ou;
I.prototype.fromString = ru;
I.prototype.clamp = su;
I.prototype.dlShiftTo = hu;
I.prototype.drShiftTo = pu;
I.prototype.lShiftTo = fu;
I.prototype.rShiftTo = mu;
I.prototype.subTo = yu;
I.prototype.multiplyTo = Eu;
I.prototype.squareTo = gu;
I.prototype.divRemTo = Su;
I.prototype.invDigit = Tu;
I.prototype.addTo = wu;
I.prototype.toString = au;
I.prototype.negate = cu;
I.prototype.abs = uu;
I.prototype.compareTo = du;
I.prototype.bitLength = lu;
I.prototype.mod = Iu;
I.prototype.equals = vu;
I.prototype.add = Au;
I.prototype.subtract = Nu;
I.prototype.multiply = Cu;
I.prototype.divide = Ru;
I.prototype.modPow = ku;
I.ZERO = Qn(0);
I.ONE = Qn(1);
const Pu = async ({ a: e, g: t, k: n, x: i, B: o, N: r, U: s }) => new Promise((a, c) => {
  t.modPow(i, r, (u, d) => {
    if (u) {
      c(u);
      return;
    }
    o.subtract(n.multiply(d)).modPow(e.add(s.multiply(i)), r, (l, h) => {
      if (l) {
        c(l);
        return;
      }
      a(h.mod(r));
    });
  });
}), Mu = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF", yr = {}, An = {};
for (let e = 0; e < 256; e++) {
  let t = e.toString(16).toLowerCase();
  t.length === 1 && (t = `0${t}`), yr[e] = t, An[t] = e;
}
const We = (e) => {
  if (e.length % 2 !== 0)
    throw new Error("Hex encoded strings must have an even number length");
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < e.length; n += 2) {
    const i = e.slice(n, n + 2).toLowerCase();
    if (i in An)
      t[n / 2] = An[i];
    else
      throw new Error(`Cannot decode unrecognized sequence ${i} as hexadecimal`);
  }
  return t;
}, Jn = (e) => {
  let t = "";
  for (let n = 0; n < e.byteLength; n++)
    t += yr[e[n]];
  return t;
}, Nn = (e) => {
  const t = new je();
  t.update(e);
  const n = t.digestSync(), i = Jn(n);
  return new Array(64 - i.length).join("0") + i;
}, xt = (e) => Nn(We(e)), Fu = /^[89a-f]/i, ye = (e) => {
  if (!(e instanceof I))
    throw new Error("Not a BigInteger");
  const t = e.compareTo(I.ZERO) < 0;
  let n = e.abs().toString(16);
  if (n = n.length % 2 !== 0 ? `0${n}` : n, n = Fu.test(n) ? `00${n}` : n, t) {
    const i = n.split("").map((r) => {
      const s = ~parseInt(r, 16) & 15;
      return "0123456789ABCDEF".charAt(s);
    }).join("");
    n = new I(i, 16).add(I.ONE).toString(16), n.toUpperCase().startsWith("FF8") && (n = n.substring(2));
  }
  return n;
}, Lu = ({ A: e, B: t }) => {
  const n = new I(xt(ye(e) + ye(t)), 16);
  if (n.equals(I.ZERO))
    throw new Error("U cannot be zero.");
  return n;
}, Uu = (e, t, n) => {
  const i = new je(t);
  i.update(e);
  const o = i.digestSync(), r = new je(o);
  return r.update(n), r.digestSync().slice(0, 16);
}, Xn = (e) => {
  const t = new Hn().random(e).toString();
  return We(t);
}, Ku = () => be.convert(Xn(40));
class Bu {
  constructor({ userPoolName: t, a: n, g: i, A: o, N: r }) {
    this.encoder = bt, this.userPoolName = t, this.a = n, this.g = i, this.A = o, this.N = r, this.k = new I(xt(`${ye(r)}${ye(i)}`), 16);
  }
  /**
   * @returns {string} Generated random value included in password hash.
   */
  getRandomPassword() {
    if (!this.randomPassword)
      throw new x({
        name: "EmptyBigIntegerRandomPassword",
        message: "random password is empty"
      });
    return this.randomPassword;
  }
  /**
   * @returns {string} Generated random value included in devices hash.
   */
  getSaltToHashDevices() {
    if (!this.saltToHashDevices)
      throw new x({
        name: "EmptyBigIntegersaltToHashDevices",
        message: "saltToHashDevices is empty"
      });
    return this.saltToHashDevices;
  }
  /**
   * @returns {string} Value used to verify devices.
   */
  getVerifierDevices() {
    if (!this.verifierDevices)
      throw new x({
        name: "EmptyBigIntegerVerifierDevices",
        message: "verifyDevices is empty"
      });
    return this.verifierDevices;
  }
  /**
   * Generate salts and compute verifier.
   *
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   *
   * @returns {Promise<void>}
   */
  async generateHashDevice(t, n) {
    this.randomPassword = Ku();
    const i = `${t}${n}:${this.randomPassword}`, o = Nn(i), r = Jn(Xn(16));
    return this.saltToHashDevices = ye(new I(r, 16)), new Promise((s, a) => {
      this.g.modPow(new I(xt(this.saltToHashDevices + o), 16), this.N, (c, u) => {
        if (c) {
          a(c);
          return;
        }
        this.verifierDevices = ye(u), s();
      });
    });
  }
  /**
   * Calculates the final HKDF key based on computed S value, computed U value and the key
   *
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {AuthBigInteger} B Server B value.
   * @param {AuthBigInteger} salt Generated salt.
   */
  async getPasswordAuthenticationKey({ username: t, password: n, serverBValue: i, salt: o }) {
    if (i.mod(this.N).equals(I.ZERO))
      throw new Error("B cannot be zero.");
    const r = Lu({
      A: this.A,
      B: i
    }), s = `${this.userPoolName}${t}:${n}`, a = Nn(s), c = new I(xt(ye(o) + a), 16), u = await Pu({
      a: this.a,
      g: this.g,
      k: this.k,
      x: c,
      B: i,
      N: this.N,
      U: r
    }), d = this.encoder.convert("Caldera Derived Key"), l = this.encoder.convert(String.fromCharCode(1)), h = new Uint8Array(d.byteLength + l.byteLength);
    return h.set(d, 0), h.set(l, d.byteLength), Uu(We(ye(u)), We(ye(r)), h);
  }
}
const $u = async ({ a: e, g: t, N: n }) => new Promise((i, o) => {
  t.modPow(e, n, (r, s) => {
    if (r) {
      o(r);
      return;
    }
    if (s.mod(n).equals(I.ZERO)) {
      o(new Error("Illegal parameter. A mod N cannot be 0."));
      return;
    }
    i(s);
  });
}), on = async (e) => {
  const t = new I(Mu, 16), n = new I("2", 16), i = qu(), o = await $u({ a: i, g: n, N: t });
  return new Bu({ userPoolName: e, a: i, g: n, A: o, N: t });
}, qu = () => {
  const e = Jn(Xn(128));
  return new I(e, 16);
}, Vu = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], ju = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], Er = () => {
  const e = /* @__PURE__ */ new Date(), t = ju[e.getUTCDay()], n = Vu[e.getUTCMonth()], i = e.getUTCDate();
  let o = e.getUTCHours();
  o < 10 && (o = `0${o}`);
  let r = e.getUTCMinutes();
  r < 10 && (r = `0${r}`);
  let s = e.getUTCSeconds();
  s < 10 && (s = `0${s}`);
  const a = e.getUTCFullYear();
  return `${t} ${n} ${i} ${o}:${r}:${s} UTC ${a}`;
}, gr = ({ userPoolName: e, username: t, challengeParameters: n, dateNow: i, hkdf: o }) => {
  const r = bt.convert(e), s = bt.convert(t), a = Hu(n.SECRET_BLOCK), c = bt.convert(i), u = new Uint8Array(r.byteLength + s.byteLength + a.byteLength + c.byteLength);
  u.set(r, 0), u.set(s, r.byteLength), u.set(a, r.byteLength + s.byteLength), u.set(c, r.byteLength + s.byteLength + a.byteLength);
  const d = new je(o);
  d.update(u);
  const l = d.digestSync();
  return be.convert(l);
}, Hu = (e) => {
  const t = "=".repeat((4 - e.length % 4) % 4), n = (e + t).replace(/-/g, "+").replace(/_/g, "/"), i = Ko.convert(n), o = new Uint8Array(i.length);
  for (let r = 0; r < i.length; ++r)
    o[r] = i.charCodeAt(r);
  return o;
};
function Le({ username: e, userPoolId: t, userPoolClientId: n }) {
  if (typeof window > "u")
    return;
  const i = window.AmazonCognitoAdvancedSecurityData;
  if (typeof i > "u")
    return;
  const o = i.getData(e, t, n);
  return o ? {
    EncodedData: o
  } : {};
}
const co = "userAttributes.";
async function Wu(e, t, n, i, o) {
  var f, p;
  const { userPoolClientId: r, userPoolId: s } = i, a = {
    USERNAME: e,
    PASSWORD: t
  }, c = await o.getDeviceMetadata(e);
  c && c.deviceKey && (a.DEVICE_KEY = c.deviceKey);
  const u = Le({
    username: e,
    userPoolId: s,
    userPoolClientId: r
  }), d = {
    AuthFlow: "USER_PASSWORD_AUTH",
    AuthParameters: a,
    ClientMetadata: n,
    ClientId: r,
    UserContextData: u
  }, l = await It({
    region: te(s),
    userAgentValue: Ie(ue.SignIn)
  }, d), h = ((f = l.ChallengeParameters) == null ? void 0 : f.USERNAME) ?? ((p = l.ChallengeParameters) == null ? void 0 : p.USER_ID_FOR_SRP) ?? e;
  return un(h), l.ChallengeName === "DEVICE_SRP_AUTH" ? Zn({
    username: h,
    config: i,
    clientMetadata: n,
    session: l.Session,
    tokenOrchestrator: o
  }) : l;
}
async function Gu(e, t, n, i, o) {
  const { userPoolId: r, userPoolClientId: s } = i, a = (r == null ? void 0 : r.split("_")[1]) || "", c = await on(a), u = {
    USERNAME: e,
    SRP_A: c.A.toString(16)
  }, d = Le({
    username: e,
    userPoolId: r,
    userPoolClientId: s
  }), l = {
    AuthFlow: "USER_SRP_AUTH",
    AuthParameters: u,
    ClientMetadata: n,
    ClientId: s,
    UserContextData: d
  }, h = await It({
    region: te(r),
    userAgentValue: Ie(ue.SignIn)
  }, l), { ChallengeParameters: f, Session: p } = h, m = (f == null ? void 0 : f.USERNAME) ?? e;
  return un(m), cn(Sr, [
    t,
    f,
    n,
    p,
    c,
    i,
    o
  ], m, o);
}
async function zu(e, t, n, i) {
  var h;
  const { userPoolClientId: o, userPoolId: r } = n, s = {
    USERNAME: e
  }, a = await i.getDeviceMetadata(e);
  a && a.deviceKey && (s.DEVICE_KEY = a.deviceKey);
  const c = Le({
    username: e,
    userPoolId: r,
    userPoolClientId: o
  }), u = {
    AuthFlow: "CUSTOM_AUTH",
    AuthParameters: s,
    ClientMetadata: t,
    ClientId: o,
    UserContextData: c
  }, d = await It({
    region: te(r),
    userAgentValue: Ie(ue.SignIn)
  }, u), l = ((h = d.ChallengeParameters) == null ? void 0 : h.USERNAME) ?? e;
  return un(l), d.ChallengeName === "DEVICE_SRP_AUTH" ? Zn({
    username: l,
    config: n,
    clientMetadata: t,
    session: d.Session,
    tokenOrchestrator: i
  }) : d;
}
async function Qu(e, t, n, i, o) {
  L(i);
  const { userPoolId: r, userPoolClientId: s } = i, a = (r == null ? void 0 : r.split("_")[1]) || "", c = await on(a), u = {
    USERNAME: e,
    SRP_A: c.A.toString(16),
    CHALLENGE_NAME: "SRP_A"
  }, d = Le({
    username: e,
    userPoolId: r,
    userPoolClientId: s
  }), l = {
    AuthFlow: "CUSTOM_AUTH",
    AuthParameters: u,
    ClientMetadata: n,
    ClientId: s,
    UserContextData: d
  }, { ChallengeParameters: h, Session: f } = await It({
    region: te(r),
    userAgentValue: Ie(ue.SignIn)
  }, l), p = (h == null ? void 0 : h.USERNAME) ?? e;
  return un(p), cn(Sr, [
    t,
    h,
    n,
    f,
    c,
    i,
    o
  ], p, o);
}
async function Zn({ username: e, config: t, clientMetadata: n, session: i, tokenOrchestrator: o }) {
  const { userPoolId: r } = t, s = t.userPoolClientId, a = await (o == null ? void 0 : o.getDeviceMetadata(e));
  hr(a);
  const c = await on(a.deviceGroupKey), u = {
    USERNAME: e,
    SRP_A: c.A.toString(16),
    DEVICE_KEY: a.deviceKey
  }, d = {
    ChallengeName: "DEVICE_SRP_AUTH",
    ClientId: s,
    ChallengeResponses: u,
    ClientMetadata: n,
    Session: i
  }, { ChallengeParameters: l, Session: h } = await Wn({ region: te(r) }, d);
  return Yu(e, l, n, h, c, t, o);
}
async function Yu(e, t, n, i, o, { userPoolId: r, userPoolClientId: s }, a) {
  const c = await (a == null ? void 0 : a.getDeviceMetadata(e));
  hr(c);
  const u = new I(t == null ? void 0 : t.SRP_B, 16), d = new I(t == null ? void 0 : t.SALT, 16), { deviceKey: l } = c, { deviceGroupKey: h } = c, f = await o.getPasswordAuthenticationKey({
    username: c.deviceKey,
    password: c.randomPassword,
    serverBValue: u,
    salt: d
  }), p = Er(), m = {
    USERNAME: (t == null ? void 0 : t.USERNAME) ?? e,
    PASSWORD_CLAIM_SECRET_BLOCK: t == null ? void 0 : t.SECRET_BLOCK,
    TIMESTAMP: p,
    PASSWORD_CLAIM_SIGNATURE: gr({
      username: l,
      userPoolName: h,
      challengeParameters: t,
      dateNow: p,
      hkdf: f
    }),
    DEVICE_KEY: l
  }, g = Le({
    username: e,
    userPoolId: r,
    userPoolClientId: s
  }), E = {
    ChallengeName: "DEVICE_PASSWORD_VERIFIER",
    ClientId: s,
    ChallengeResponses: m,
    Session: i,
    ClientMetadata: n,
    UserContextData: g
  };
  return Wn({ region: te(r) }, E);
}
async function Sr(e, t, n, i, o, r, s) {
  const { userPoolId: a, userPoolClientId: c } = r, u = (a == null ? void 0 : a.split("_")[1]) || "", d = new I(t == null ? void 0 : t.SRP_B, 16), l = new I(t == null ? void 0 : t.SALT, 16), h = t == null ? void 0 : t.USER_ID_FOR_SRP;
  if (!h)
    throw new x({
      name: "EmptyUserIdForSRPException",
      message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
  const f = await o.getPasswordAuthenticationKey({
    username: h,
    password: e,
    serverBValue: d,
    salt: l
  }), p = Er(), m = {
    USERNAME: h,
    PASSWORD_CLAIM_SECRET_BLOCK: t == null ? void 0 : t.SECRET_BLOCK,
    TIMESTAMP: p,
    PASSWORD_CLAIM_SIGNATURE: gr({
      username: h,
      userPoolName: u,
      challengeParameters: t,
      dateNow: p,
      hkdf: f
    })
  }, g = await s.getDeviceMetadata(h);
  g && g.deviceKey && (m.DEVICE_KEY = g.deviceKey);
  const E = Le({
    username: h,
    userPoolId: a,
    userPoolClientId: c
  }), S = {
    ChallengeName: "PASSWORD_VERIFIER",
    ChallengeResponses: m,
    ClientMetadata: n,
    Session: i,
    ClientId: c,
    UserContextData: E
  }, v = await Wn({ region: te(a) }, S);
  return v.ChallengeName === "DEVICE_SRP_AUTH" ? Zn({
    username: h,
    config: r,
    clientMetadata: n,
    session: v.Session,
    tokenOrchestrator: s
  }) : v;
}
async function rn(e) {
  var o;
  const { challengeName: t, challengeParameters: n } = e, i = (o = J.getConfig().Auth) == null ? void 0 : o.Cognito;
  switch (L(i), t) {
    case "CUSTOM_CHALLENGE":
      return {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
          additionalInfo: n
        }
      };
    case "MFA_SETUP": {
      const { signInSession: r, username: s } = He.getState();
      if (!ed(n, "TOTP"))
        throw new x({
          name: mt.SignInException,
          message: `Cannot initiate MFA setup from available types: ${Cn(Rn(n.MFAS_CAN_SETUP))}`
        });
      const { Session: a, SecretCode: c } = await Cc({ region: te(i.userPoolId) }, {
        Session: r
      });
      return He.dispatch({
        type: "SET_SIGN_IN_SESSION",
        value: a
      }), {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
          totpSetupDetails: Ju(c, s)
        }
      };
    }
    case "NEW_PASSWORD_REQUIRED":
      return {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
          missingAttributes: Xu(n.requiredAttributes)
        }
      };
    case "SELECT_MFA_TYPE":
      return {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
          allowedMFATypes: Cn(Rn(n.MFAS_CAN_CHOOSE))
        }
      };
    case "SMS_MFA":
      return {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
          codeDeliveryDetails: {
            deliveryMedium: n.CODE_DELIVERY_DELIVERY_MEDIUM,
            destination: n.CODE_DELIVERY_DESTINATION
          }
        }
      };
    case "SOFTWARE_TOKEN_MFA":
      return {
        isSignedIn: !1,
        nextStep: {
          signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
        }
      };
  }
  throw new x({
    name: mt.SignInException,
    message: `An error occurred during the sign in process. ${t} challengeName returned by the underlying service was not addressed.`
  });
}
function Ju(e, t) {
  return {
    sharedSecret: e,
    getSetupUri: (n, i) => {
      const o = `otpauth://totp/${n}:${i ?? t}?secret=${e}&issuer=${n}`;
      return new de(o);
    }
  };
}
function sn(e) {
  if (e === Vt.PasswordResetRequiredException)
    return {
      isSignedIn: !1,
      nextStep: { signInStep: "RESET_PASSWORD" }
    };
  if (e === Vt.UserNotConfirmedException)
    return {
      isSignedIn: !1,
      nextStep: { signInStep: "CONFIRM_SIGN_UP" }
    };
}
function Xu(e) {
  return e ? JSON.parse(e).map((n) => n.includes(co) ? n.replace(co, "") : n) : [];
}
function Zu(e) {
  if (e === "SMS_MFA")
    return "SMS";
  if (e === "SOFTWARE_TOKEN_MFA")
    return "TOTP";
}
function Cn(e) {
  if (e)
    return e.map(Zu).filter(Boolean);
}
function Rn(e) {
  return e ? JSON.parse(e) : [];
}
function ed(e, t) {
  const { MFAS_CAN_SETUP: n } = e, i = Cn(Rn(n));
  return i ? i.includes(t) : !1;
}
async function Ir() {
  let e;
  try {
    e = await fr();
  } catch {
  }
  if (e && e.userId && e.username)
    throw new x({
      name: Dc,
      message: "There is already a signed in user.",
      recoverySuggestion: "Call signOut before calling signIn again."
    });
}
async function an(e, t, n) {
  if (!t)
    return;
  const i = e.split("_")[1] || "", o = await on(i), r = t == null ? void 0 : t.DeviceKey, s = t == null ? void 0 : t.DeviceGroupKey;
  try {
    await o.generateHashDevice(s ?? "", r ?? "");
  } catch {
    return;
  }
  const a = {
    Salt: be.convert(We(o.getSaltToHashDevices())),
    PasswordVerifier: be.convert(We(o.getVerifierDevices()))
  }, c = o.getRandomPassword();
  try {
    return await _c({ region: te(e) }, {
      AccessToken: n,
      DeviceName: await yc(),
      DeviceKey: t == null ? void 0 : t.DeviceKey,
      DeviceSecretVerifierConfig: a
    }), {
      deviceKey: r,
      deviceGroupKey: s,
      randomPassword: c
    };
  } catch {
    return;
  }
}
async function cn(e, t, n, i) {
  try {
    return await e(...t);
  } catch (o) {
    if (o instanceof x && o.name === "ResourceNotFoundException" && o.message.includes("Device does not exist."))
      return await i.clearDeviceMetadata(n), e(...t);
    throw o;
  }
}
function un(e) {
  const { dispatch: t } = He;
  t({ type: "SET_USERNAME", value: e });
}
function dn(e) {
  return He.getState().username ?? e;
}
const td = async ({ tokens: e, authConfig: t, username: n }) => {
  var h, f;
  L(t == null ? void 0 : t.Cognito);
  const i = te(t.Cognito.userPoolId);
  lr(e);
  const o = e.refreshToken, r = {
    REFRESH_TOKEN: o
  };
  (h = e.deviceMetadata) != null && h.deviceKey && (r.DEVICE_KEY = e.deviceMetadata.deviceKey);
  const s = Le({
    username: n,
    userPoolId: t.Cognito.userPoolId,
    userPoolClientId: t.Cognito.userPoolClientId
  }), { AuthenticationResult: a } = await It({ region: i }, {
    ClientId: (f = t == null ? void 0 : t.Cognito) == null ? void 0 : f.userPoolClientId,
    AuthFlow: "REFRESH_TOKEN_AUTH",
    AuthParameters: r,
    UserContextData: s
  }), c = Ee((a == null ? void 0 : a.AccessToken) ?? ""), u = a != null && a.IdToken ? Ee(a.IdToken) : void 0, { iat: d } = c.payload;
  if (!d)
    throw new x({
      name: "iatNotFoundException",
      message: "iat not found in access token"
    });
  const l = d * 1e3 - (/* @__PURE__ */ new Date()).getTime();
  return {
    accessToken: c,
    idToken: u,
    clockDrift: l,
    refreshToken: o,
    username: n
  };
}, nd = mc(td), id = {
  accessToken: "accessToken",
  idToken: "idToken",
  oidcProvider: "oidcProvider",
  clockDrift: "clockDrift",
  refreshToken: "refreshToken",
  deviceKey: "deviceKey",
  randomPasswordKey: "randomPasswordKey",
  deviceGroupKey: "deviceGroupKey",
  signInDetails: "signInDetails"
};
var jt;
(function(e) {
  e.InvalidAuthTokens = "InvalidAuthTokens";
})(jt || (jt = {}));
const od = {
  [jt.InvalidAuthTokens]: {
    message: "Invalid tokens.",
    recoverySuggestion: "Make sure the tokens are valid."
  }
}, rd = Lo(od);
class sd {
  constructor() {
    this.name = "CognitoIdentityServiceProvider";
  }
  getKeyValueStorage() {
    if (!this.keyValueStorage)
      throw new x({
        name: "KeyValueStorageNotFoundException",
        message: "KeyValueStorage was not found in TokenStore"
      });
    return this.keyValueStorage;
  }
  setKeyValueStorage(t) {
    this.keyValueStorage = t;
  }
  setAuthConfig(t) {
    this.authConfig = t;
  }
  async loadTokens() {
    try {
      const t = await this.getAuthKeys(), n = await this.getKeyValueStorage().getItem(t.accessToken);
      if (!n)
        throw new x({
          name: "NoSessionFoundException",
          message: "Auth session was not found. Make sure to call signIn."
        });
      const i = Ee(n), o = await this.getKeyValueStorage().getItem(t.idToken), r = o ? Ee(o) : void 0, s = await this.getKeyValueStorage().getItem(t.refreshToken) ?? void 0, a = await this.getKeyValueStorage().getItem(t.clockDrift) ?? "0", c = Number.parseInt(a), u = await this.getKeyValueStorage().getItem(t.signInDetails), d = {
        accessToken: i,
        idToken: r,
        refreshToken: s,
        deviceMetadata: await this.getDeviceMetadata() ?? void 0,
        clockDrift: c,
        username: await this.getLastAuthUser()
      };
      return u && (d.signInDetails = JSON.parse(u)), d;
    } catch {
      return null;
    }
  }
  async storeTokens(t) {
    rd(t !== void 0, jt.InvalidAuthTokens), await this.clearTokens();
    const n = t.username;
    await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), n);
    const i = await this.getAuthKeys();
    await this.getKeyValueStorage().setItem(i.accessToken, t.accessToken.toString()), t.idToken && await this.getKeyValueStorage().setItem(i.idToken, t.idToken.toString()), t.refreshToken && await this.getKeyValueStorage().setItem(i.refreshToken, t.refreshToken), t.deviceMetadata && (t.deviceMetadata.deviceKey && await this.getKeyValueStorage().setItem(i.deviceKey, t.deviceMetadata.deviceKey), t.deviceMetadata.deviceGroupKey && await this.getKeyValueStorage().setItem(i.deviceGroupKey, t.deviceMetadata.deviceGroupKey), await this.getKeyValueStorage().setItem(i.randomPasswordKey, t.deviceMetadata.randomPassword)), t.signInDetails && await this.getKeyValueStorage().setItem(i.signInDetails, JSON.stringify(t.signInDetails)), await this.getKeyValueStorage().setItem(i.clockDrift, `${t.clockDrift}`);
  }
  async clearTokens() {
    const t = await this.getAuthKeys();
    await Promise.all([
      this.getKeyValueStorage().removeItem(t.accessToken),
      this.getKeyValueStorage().removeItem(t.idToken),
      this.getKeyValueStorage().removeItem(t.clockDrift),
      this.getKeyValueStorage().removeItem(t.refreshToken),
      this.getKeyValueStorage().removeItem(t.signInDetails),
      this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
    ]);
  }
  async getDeviceMetadata(t) {
    const n = await this.getAuthKeys(t), i = await this.getKeyValueStorage().getItem(n.deviceKey), o = await this.getKeyValueStorage().getItem(n.deviceGroupKey), r = await this.getKeyValueStorage().getItem(n.randomPasswordKey);
    return r && o && i ? {
      deviceKey: i,
      deviceGroupKey: o,
      randomPassword: r
    } : null;
  }
  async clearDeviceMetadata(t) {
    const n = await this.getAuthKeys(t);
    await Promise.all([
      this.getKeyValueStorage().removeItem(n.deviceKey),
      this.getKeyValueStorage().removeItem(n.deviceGroupKey),
      this.getKeyValueStorage().removeItem(n.randomPasswordKey)
    ]);
  }
  async getAuthKeys(t) {
    var i;
    L((i = this.authConfig) == null ? void 0 : i.Cognito);
    const n = t ?? await this.getLastAuthUser();
    return ad(this.name, `${this.authConfig.Cognito.userPoolClientId}.${n}`);
  }
  getLastAuthUserKey() {
    var n;
    L((n = this.authConfig) == null ? void 0 : n.Cognito);
    const t = this.authConfig.Cognito.userPoolClientId;
    return `${this.name}.${t}.LastAuthUser`;
  }
  async getLastAuthUser() {
    return await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
  }
}
const ad = (e, t) => ei(id)(`${e}`, t);
function ei(e) {
  const t = Object.values({ ...e });
  return (n, i) => t.reduce((o, r) => ({
    ...o,
    [r]: `${n}.${i}.${r}`
  }), {});
}
const uo = "amplify-signin-with-hostedUI", he = "CognitoIdentityServiceProvider";
class Tr {
  constructor(t) {
    this.keyValueStorage = t;
  }
  async clearOAuthInflightData() {
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId);
    await Promise.all([
      this.keyValueStorage.removeItem(t.inflightOAuth),
      this.keyValueStorage.removeItem(t.oauthPKCE),
      this.keyValueStorage.removeItem(t.oauthState)
    ]);
  }
  async clearOAuthData() {
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId);
    return await this.clearOAuthInflightData(), await this.keyValueStorage.removeItem(uo), this.keyValueStorage.removeItem(t.oauthSignIn);
  }
  loadOAuthState() {
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.getItem(t.oauthState);
  }
  storeOAuthState(t) {
    L(this.cognitoConfig);
    const n = pe(he, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.setItem(n.oauthState, t);
  }
  loadPKCE() {
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.getItem(t.oauthPKCE);
  }
  storePKCE(t) {
    L(this.cognitoConfig);
    const n = pe(he, this.cognitoConfig.userPoolClientId);
    return this.keyValueStorage.setItem(n.oauthPKCE, t);
  }
  setAuthConfig(t) {
    this.cognitoConfig = t;
  }
  async loadOAuthInFlight() {
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId);
    return await this.keyValueStorage.getItem(t.inflightOAuth) === "true";
  }
  async storeOAuthInFlight(t) {
    L(this.cognitoConfig);
    const n = pe(he, this.cognitoConfig.userPoolClientId);
    await this.keyValueStorage.setItem(n.inflightOAuth, `${t}`);
  }
  async loadOAuthSignIn() {
    var r;
    L(this.cognitoConfig);
    const t = pe(he, this.cognitoConfig.userPoolClientId), n = await this.keyValueStorage.getItem(uo), [i, o] = ((r = await this.keyValueStorage.getItem(t.oauthSignIn)) == null ? void 0 : r.split(",")) ?? [];
    return {
      isOAuthSignIn: i === "true" || n === "true",
      preferPrivateSession: o === "true"
    };
  }
  async storeOAuthSignIn(t, n = !1) {
    L(this.cognitoConfig);
    const i = pe(he, this.cognitoConfig.userPoolClientId);
    await this.keyValueStorage.setItem(i.oauthSignIn, `${t},${n}`);
  }
}
const pe = (e, t) => ei(jc)(e, t), Q = new Tr(Zt), _n = [], cd = (e) => {
  _n.push(e);
}, vr = () => {
  var e;
  for (; _n.length; )
    (e = _n.pop()) == null || e();
};
class ud {
  constructor() {
    this.waitForInflightOAuth = Bn() ? async () => {
      if (await Q.loadOAuthInFlight())
        return this.inflightPromise ? this.inflightPromise : (this.inflightPromise = new Promise((t, n) => {
          cd(t);
        }), this.inflightPromise);
    } : async () => {
    };
  }
  setAuthConfig(t) {
    Q.setAuthConfig(t.Cognito), this.authConfig = t;
  }
  setTokenRefresher(t) {
    this.tokenRefresher = t;
  }
  setAuthTokenStore(t) {
    this.tokenStore = t;
  }
  getTokenStore() {
    if (!this.tokenStore)
      throw new x({
        name: "EmptyTokenStoreException",
        message: "TokenStore not set"
      });
    return this.tokenStore;
  }
  getTokenRefresher() {
    if (!this.tokenRefresher)
      throw new x({
        name: "EmptyTokenRefresherException",
        message: "TokenRefresher not set"
      });
    return this.tokenRefresher;
  }
  async getTokens(t) {
    var s, a, c, u, d;
    let n;
    try {
      L((s = this.authConfig) == null ? void 0 : s.Cognito);
    } catch {
      return null;
    }
    await this.waitForInflightOAuth(), this.inflightPromise = void 0, n = await this.getTokenStore().loadTokens();
    const i = await this.getTokenStore().getLastAuthUser();
    if (n === null)
      return null;
    const o = !!(n != null && n.idToken) && Ii({
      expiresAt: (((c = (a = n.idToken) == null ? void 0 : a.payload) == null ? void 0 : c.exp) ?? 0) * 1e3,
      clockDrift: n.clockDrift ?? 0
    }), r = Ii({
      expiresAt: (((d = (u = n.accessToken) == null ? void 0 : u.payload) == null ? void 0 : d.exp) ?? 0) * 1e3,
      clockDrift: n.clockDrift ?? 0
    });
    return (t != null && t.forceRefresh || o || r) && (n = await this.refreshTokens({
      tokens: n,
      username: i
    }), n === null) ? null : {
      accessToken: n == null ? void 0 : n.accessToken,
      idToken: n == null ? void 0 : n.idToken,
      signInDetails: n == null ? void 0 : n.signInDetails
    };
  }
  async refreshTokens({ tokens: t, username: n }) {
    try {
      const { signInDetails: i } = t, o = await this.getTokenRefresher()({
        tokens: t,
        authConfig: this.authConfig,
        username: n
      });
      return o.signInDetails = i, await this.setTokens({ tokens: o }), ce.dispatch("auth", { event: "tokenRefresh" }, "Auth", ae), o;
    } catch (i) {
      return this.handleErrors(i);
    }
  }
  handleErrors(t) {
    if (Xe(t), t.message !== "Network error" && this.clearTokens(), ce.dispatch("auth", {
      event: "tokenRefresh_failure",
      data: { error: t }
    }, "Auth", ae), t.name.startsWith("NotAuthorizedException"))
      return null;
    throw t;
  }
  async setTokens({ tokens: t }) {
    return this.getTokenStore().storeTokens(t);
  }
  async clearTokens() {
    return this.getTokenStore().clearTokens();
  }
  getDeviceMetadata(t) {
    return this.getTokenStore().getDeviceMetadata(t);
  }
  clearDeviceMetadata(t) {
    return this.getTokenStore().clearDeviceMetadata(t);
  }
}
class dd {
  constructor() {
    this.authTokenStore = new sd(), this.authTokenStore.setKeyValueStorage(Zt), this.tokenOrchestrator = new ud(), this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore), this.tokenOrchestrator.setTokenRefresher(nd);
  }
  getTokens({ forceRefresh: t } = { forceRefresh: !1 }) {
    return this.tokenOrchestrator.getTokens({ forceRefresh: t });
  }
  setKeyValueStorage(t) {
    this.authTokenStore.setKeyValueStorage(t);
  }
  setAuthConfig(t) {
    this.authTokenStore.setAuthConfig(t), this.tokenOrchestrator.setAuthConfig(t);
  }
}
const ld = new dd(), { tokenOrchestrator: le } = ld;
async function tt(e) {
  if (e.AccessToken) {
    const t = Ee(e.AccessToken), n = (t.payload.iat || 0) * 1e3, i = (/* @__PURE__ */ new Date()).getTime(), o = n > 0 ? n - i : 0;
    let r, s, a;
    e.RefreshToken && (s = e.RefreshToken), e.IdToken && (r = Ee(e.IdToken)), e != null && e.NewDeviceMetadata && (a = e.NewDeviceMetadata);
    const c = {
      accessToken: t,
      idToken: r,
      refreshToken: s,
      clockDrift: o,
      deviceMetadata: a,
      username: e.username
    };
    e != null && e.signInDetails && (c.signInDetails = e.signInDetails), await le.setTokens({
      tokens: c
    });
  } else
    throw new Y({
      message: "Invalid tokens",
      name: "InvalidTokens",
      recoverySuggestion: "Check Cognito UserPool settings"
    });
}
const hd = "Unable to get user session following successful sign-in.", Tt = async () => {
  try {
    ce.dispatch("auth", {
      event: "signedIn",
      data: await fr()
    }, "Auth", ae);
  } catch (e) {
    throw e.name === en ? new x({
      name: Bc,
      message: hd,
      recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
    }) : e;
  }
};
async function pd(e) {
  var a;
  const t = (a = J.getConfig().Auth) == null ? void 0 : a.Cognito;
  L(t);
  const { username: n, password: i, options: o } = e, r = {
    loginId: n,
    authFlowType: "CUSTOM_WITHOUT_SRP"
  }, s = o == null ? void 0 : o.clientMetadata;
  Ae(!!n, P.EmptySignInUsername), Ae(!i, P.CustomAuthSignInPassword);
  try {
    const { ChallengeName: c, ChallengeParameters: u, AuthenticationResult: d, Session: l } = await cn(zu, [n, s, t, le], n, le), h = dn(n);
    return tn({
      signInSession: l,
      username: h,
      challengeName: c,
      signInDetails: r
    }), d ? (Ne(), await tt({
      username: h,
      ...d,
      NewDeviceMetadata: await an(t.userPoolId, d.NewDeviceMetadata, d.AccessToken),
      signInDetails: r
    }), await Tt(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : rn({
      challengeName: c,
      challengeParameters: u
    });
  } catch (c) {
    Ne(), Xe(c);
    const u = sn(c.name);
    if (u)
      return u;
    throw c;
  }
}
async function fd(e) {
  var a;
  const { username: t, password: n, options: i } = e, o = {
    loginId: t,
    authFlowType: "CUSTOM_WITH_SRP"
  }, r = (a = J.getConfig().Auth) == null ? void 0 : a.Cognito;
  L(r);
  const s = i == null ? void 0 : i.clientMetadata;
  Ae(!!t, P.EmptySignInUsername), Ae(!!n, P.EmptySignInPassword);
  try {
    const { ChallengeName: c, ChallengeParameters: u, AuthenticationResult: d, Session: l } = await Qu(t, n, s, r, le), h = dn(t);
    return tn({
      signInSession: l,
      username: h,
      challengeName: c,
      signInDetails: o
    }), d ? (await tt({
      username: h,
      ...d,
      NewDeviceMetadata: await an(r.userPoolId, d.NewDeviceMetadata, d.AccessToken),
      signInDetails: o
    }), Ne(), await Tt(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : rn({
      challengeName: c,
      challengeParameters: u
    });
  } catch (c) {
    Ne(), Xe(c);
    const u = sn(c.name);
    if (u)
      return u;
    throw c;
  }
}
async function lo(e) {
  var s, a;
  const { username: t, password: n } = e, i = (s = J.getConfig().Auth) == null ? void 0 : s.Cognito, o = {
    loginId: t,
    authFlowType: "USER_SRP_AUTH"
  };
  L(i);
  const r = (a = e.options) == null ? void 0 : a.clientMetadata;
  Ae(!!t, P.EmptySignInUsername), Ae(!!n, P.EmptySignInPassword);
  try {
    const { ChallengeName: c, ChallengeParameters: u, AuthenticationResult: d, Session: l } = await Gu(t, n, r, i, le), h = dn(t);
    return tn({
      signInSession: l,
      username: h,
      challengeName: c,
      signInDetails: o
    }), d ? (Ne(), await tt({
      username: h,
      ...d,
      NewDeviceMetadata: await an(i.userPoolId, d.NewDeviceMetadata, d.AccessToken),
      signInDetails: o
    }), await Tt(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : rn({
      challengeName: c,
      challengeParameters: u
    });
  } catch (c) {
    Ne(), Xe(c);
    const u = sn(c.name);
    if (u)
      return u;
    throw c;
  }
}
async function md(e) {
  var a;
  const { username: t, password: n, options: i } = e, o = (a = J.getConfig().Auth) == null ? void 0 : a.Cognito, r = {
    loginId: t,
    authFlowType: "USER_PASSWORD_AUTH"
  };
  L(o);
  const s = i == null ? void 0 : i.clientMetadata;
  Ae(!!t, P.EmptySignInUsername), Ae(!!n, P.EmptySignInPassword);
  try {
    const { ChallengeName: c, ChallengeParameters: u, AuthenticationResult: d, Session: l } = await cn(Wu, [t, n, s, o, le], t, le), h = dn(t);
    return tn({
      signInSession: l,
      username: h,
      challengeName: c,
      signInDetails: r
    }), d ? (await tt({
      ...d,
      username: h,
      NewDeviceMetadata: await an(o.userPoolId, d.NewDeviceMetadata, d.AccessToken),
      signInDetails: r
    }), Ne(), await Tt(), {
      isSignedIn: !0,
      nextStep: { signInStep: "DONE" }
    }) : rn({
      challengeName: c,
      challengeParameters: u
    });
  } catch (c) {
    Ne(), Xe(c);
    const u = sn(c.name);
    if (u)
      return u;
    throw c;
  }
}
async function mp(e) {
  var n;
  const t = (n = e.options) == null ? void 0 : n.authFlowType;
  switch (await Ir(), t) {
    case "USER_SRP_AUTH":
      return lo(e);
    case "USER_PASSWORD_AUTH":
      return md(e);
    case "CUSTOM_WITHOUT_SRP":
      return pd(e);
    case "CUSTOM_WITH_SRP":
      return fd(e);
    default:
      return lo(e);
  }
}
new W("AuthError");
const yd = {
  oauthSignInError: {
    message: j.OAUTH_ERROR,
    log: "Make sure Cognito Hosted UI has been configured correctly"
  },
  noConfig: {
    message: j.DEFAULT_MSG,
    log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
  },
  missingAuthConfig: {
    message: j.DEFAULT_MSG,
    log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
  },
  emptyUsername: {
    message: j.EMPTY_USERNAME
  },
  // TODO: should include a list of valid sign-in types
  invalidUsername: {
    message: j.INVALID_USERNAME
  },
  emptyPassword: {
    message: j.EMPTY_PASSWORD
  },
  emptyCode: {
    message: j.EMPTY_CODE
  },
  signUpError: {
    message: j.SIGN_UP_ERROR,
    log: "The first parameter should either be non-null string or object"
  },
  noMFA: {
    message: j.NO_MFA
  },
  invalidMFA: {
    message: j.INVALID_MFA
  },
  emptyChallengeResponse: {
    message: j.EMPTY_CHALLENGE
  },
  noUserSession: {
    message: j.NO_USER_SESSION
  },
  deviceConfig: {
    message: j.DEVICE_CONFIG
  },
  networkError: {
    message: j.NETWORK_ERROR
  },
  autoSignInError: {
    message: j.AUTOSIGNIN_ERROR
  },
  default: {
    message: j.DEFAULT_MSG
  }
}, xe = (e, t) => new x({
  message: e ?? "An error has occurred during the oauth process.",
  name: mt.OAuthSignInError,
  recoverySuggestion: t ?? yd.oauthSignInError.log
});
var bn;
(function(e) {
  e.NoConfig = "noConfig", e.MissingAuthConfig = "missingAuthConfig", e.EmptyUsername = "emptyUsername", e.InvalidUsername = "invalidUsername", e.EmptyPassword = "emptyPassword", e.EmptyCode = "emptyCode", e.SignUpError = "signUpError", e.NoMFA = "noMFA", e.InvalidMFA = "invalidMFA", e.EmptyChallengeResponse = "emptyChallengeResponse", e.NoUserSession = "noUserSession", e.Default = "default", e.DeviceConfig = "deviceConfig", e.NetworkError = "networkError", e.AutoSignInError = "autoSignInError", e.OAuthSignInError = "oauthSignInError";
})(bn || (bn = {}));
const Ed = "`signInWithRedirect` has been canceled.", gd = "An error occurred while validating the state.", Sd = "Try to initiate an OAuth flow from Amplify", wr = async (e) => {
  const t = await Q.loadOAuthState(), n = e === t ? t : void 0;
  if (!n)
    throw new x({
      name: bn.OAuthSignInError,
      message: e === null ? Ed : gd,
      recoverySuggestion: e === null ? void 0 : Sd
    });
  return n;
}, Ar = async ({ currentUrl: e, userAgentValue: t, clientId: n, redirectUri: i, responseType: o, domain: r, preferPrivateSession: s }) => {
  const a = new de(e), c = a.searchParams.get("error"), u = a.searchParams.get("error_description");
  if (c)
    throw xe(u ?? c);
  return o === "code" ? Id({
    currentUrl: e,
    userAgentValue: t,
    clientId: n,
    redirectUri: i,
    domain: r,
    preferPrivateSession: s
  }) : Td({
    currentUrl: e,
    redirectUri: i,
    preferPrivateSession: s
  });
}, Id = async ({ currentUrl: e, userAgentValue: t, clientId: n, redirectUri: i, domain: o, preferPrivateSession: r }) => {
  const s = new de(e), a = s.searchParams.get("code"), c = s.searchParams.get("state");
  if (!a || !c)
    throw xe("User cancelled OAuth flow.");
  const u = await wr(c), d = "https://" + o + "/oauth2/token", l = await Q.loadPKCE(), h = {
    grant_type: "authorization_code",
    code: a,
    client_id: n,
    redirect_uri: i,
    ...l ? { code_verifier: l } : {}
  }, f = Object.entries(h).map(([w, _]) => `${encodeURIComponent(w)}=${encodeURIComponent(_)}`).join("&"), { access_token: p, refresh_token: m, id_token: g, error: E, error_message: S, token_type: v, expires_in: N } = await (await fetch(d, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      [Fo]: t
    },
    body: f
  })).json();
  if (E)
    throw xe(S ?? E);
  const A = (p && Ee(p).payload.username) ?? "username";
  return await tt({
    username: A,
    AccessToken: p,
    IdToken: g,
    RefreshToken: m,
    TokenType: v,
    ExpiresIn: N
  }), Nr({
    redirectUri: i,
    state: u,
    preferPrivateSession: r
  });
}, Td = async ({ currentUrl: e, redirectUri: t, preferPrivateSession: n }) => {
  const i = new de(e), { id_token: o, access_token: r, state: s, token_type: a, expires_in: c, error_description: u, error: d } = (i.hash ?? "#").substring(1).split("&").map((f) => f.split("=")).reduce((f, [p, m]) => ({ ...f, [p]: m }), {
    id_token: void 0,
    access_token: void 0,
    state: void 0,
    token_type: void 0,
    expires_in: void 0,
    error_description: void 0,
    error: void 0
  });
  if (d)
    throw xe(u ?? d);
  if (!r)
    throw xe("No access token returned from OAuth flow.");
  const l = await wr(s), h = (r && Ee(r).payload.username) ?? "username";
  return await tt({
    username: h,
    AccessToken: r,
    IdToken: o,
    TokenType: a,
    ExpiresIn: c
  }), Nr({
    redirectUri: t,
    state: l,
    preferPrivateSession: n
  });
}, Nr = async ({ redirectUri: e, state: t, preferPrivateSession: n }) => {
  await Q.clearOAuthData(), await Q.storeOAuthSignIn(!0, n), vr(), vd(t) && ce.dispatch("auth", {
    event: "customOAuthState",
    data: pc(wd(t))
  }, "Auth", ae), ce.dispatch("auth", { event: "signInWithRedirect" }, "Auth", ae), await Tt(), Ad(e);
}, vd = (e) => /-/.test(e), wd = (e) => e.split("-").splice(1).join("-"), Ad = (e) => {
  typeof window < "u" && typeof window.history < "u" && window.history.replaceState(window.history.state, "", e);
};
function ti(e) {
  const t = (e == null ? void 0 : e.find(Nd)) ?? (e == null ? void 0 : e.find(Cd)), n = (e == null ? void 0 : e.find(_d)) ?? (e == null ? void 0 : e.find(Rd));
  if (t)
    return t;
  throw n ? Lc : Mc;
}
const Nd = (e) => e.startsWith(String(window.location.origin + window.location.pathname)), Cd = (e) => e.includes(String(window.location.hostname)), Rd = (e) => e.startsWith("http://"), _d = (e) => e.startsWith("https://"), ni = async (e) => {
  vr(), await Q.clearOAuthInflightData(), ce.dispatch("auth", { event: "signInWithRedirect_failure", data: { error: e } }, "Auth", ae);
}, bd = async (e) => {
  try {
    L(e), zt(e), Q.setAuthConfig(e);
  } catch {
    return;
  }
  if (await Q.loadOAuthInFlight())
    try {
      const t = window.location.href, { loginWith: n, userPoolClientId: i } = e, { domain: o, redirectSignIn: r, responseType: s } = n.oauth, a = ti(r);
      await Ar({
        currentUrl: t,
        clientId: i,
        domain: o,
        redirectUri: a,
        responseType: s,
        userAgentValue: Ie(ue.SignInWithRedirect)
      });
    } catch (t) {
      await ni(t);
    }
};
Bn() && J[qo](bd);
const xd = {
  Google: "Google",
  Facebook: "Facebook",
  Amazon: "LoginWithAmazon",
  Apple: "SignInWithApple"
}, Cr = async (e) => {
  window != null && window.location && (window.location.href = e.replace("http://", "https://"));
}, ho = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", Od = (e) => {
  const t = new Uint8Array(e);
  Uo().getRandomValues(t);
  let n = "", i;
  for (const o of t)
    n += ho.charAt(o % ho.length);
  return {
    value: n,
    method: "S256",
    toCodeChallenge() {
      return i || (i = Dd(n), i);
    }
  };
};
function Dd(e) {
  const t = new je();
  return t.update(e), kd(be.convert(t.digestSync(), { urlSafe: !0 }));
}
function kd(e) {
  return e.replace(/=/g, "");
}
const Pd = () => dc(32), Md = (e) => {
  async function t(n) {
    if (n.persisted && await e.loadOAuthInFlight()) {
      const o = xe("User cancelled OAuth flow.");
      await ni(o);
    }
    window.removeEventListener("pageshow", t);
  }
  window.addEventListener("pageshow", t);
};
async function yp(e) {
  var i, o, r;
  const t = (i = J.getConfig().Auth) == null ? void 0 : i.Cognito;
  L(t), zt(t), Q.setAuthConfig(t), await Ir();
  let n = "COGNITO";
  return typeof (e == null ? void 0 : e.provider) == "string" ? n = xd[e.provider] : (o = e == null ? void 0 : e.provider) != null && o.custom && (n = e.provider.custom), Fd({
    oauthConfig: t.loginWith.oauth,
    clientId: t.userPoolClientId,
    provider: n,
    customState: e == null ? void 0 : e.customState,
    preferPrivateSession: (r = e == null ? void 0 : e.options) == null ? void 0 : r.preferPrivateSession
  });
}
const Fd = async ({ oauthConfig: e, provider: t, clientId: n, customState: i, preferPrivateSession: o }) => {
  const { domain: r, redirectSignIn: s, responseType: a, scopes: c } = e, u = Pd(), d = i ? `${u}-${fc(i)}` : u, { value: l, method: h, toCodeChallenge: f } = Od(128), p = ti(e.redirectSignIn);
  Bn() && Q.storeOAuthInFlight(!0), Q.storeOAuthState(d), Q.storePKCE(l);
  const m = Object.entries({
    redirect_uri: p,
    response_type: a,
    client_id: n,
    identity_provider: t,
    scope: c.join(" "),
    state: d,
    ...a === "code" && {
      code_challenge: f(),
      code_challenge_method: h
    }
  }).map(([N, A]) => `${encodeURIComponent(N)}=${encodeURIComponent(A)}`).join("&"), g = `https://${r}/oauth2/authorize?${m}`;
  Md(Q);
  const { type: E, error: S, url: v } = await Cr(g) ?? {};
  try {
    if (E === "error")
      throw xe(String(S));
    E === "success" && v && await Ar({
      currentUrl: v,
      clientId: n,
      domain: r,
      redirectUri: p,
      responseType: a,
      userAgentValue: Ie(ue.SignInWithRedirect),
      preferPrivateSession: o
    });
  } catch (N) {
    throw await ni(N), N;
  }
}, Ld = async (e) => {
  var o;
  const t = (o = e.getConfig().Auth) == null ? void 0 : o.Cognito;
  L(t);
  const { tokens: n } = await jo(e, {
    forceRefresh: !1
  });
  Gn(n);
  const { UserAttributes: i } = await Rc({
    region: te(t.userPoolId),
    userAgentValue: Ie(ue.FetchUserAttributes)
  }, {
    AccessToken: n.accessToken.toString()
  });
  return Oc(i);
}, Ep = () => Ld(J), Ud = async (e) => {
  await e.clearOAuthData(), le.clearTokens(), await Ho(), ce.dispatch("auth", { event: "signedOut" }, "Auth", ae);
}, Kd = async (e, t = !1) => {
  zt(e);
  const { loginWith: n, userPoolClientId: i } = e, { domain: o, redirectSignOut: r } = n.oauth, s = ti(r), a = `https://${o}/logout?${Object.entries({
    client_id: i,
    logout_uri: encodeURIComponent(s)
  }).map(([c, u]) => `${c}=${u}`).join("&")}`;
  return Cr(a);
}, Bd = async (e, t) => {
  const { isOAuthSignIn: n } = await t.loadOAuthSignIn();
  if (await Ud(t), n)
    return Kd(e);
}, Rr = new W("Auth");
async function gp(e) {
  var i;
  const t = (i = J.getConfig().Auth) == null ? void 0 : i.Cognito;
  L(t), e != null && e.global ? await qd(t) : await $d(t);
  let n;
  try {
    zt(t), n = !0;
  } catch {
    n = !1;
  }
  if (n) {
    const o = new Tr(Zt);
    o.setAuthConfig(t);
    const { type: r } = await Bd(t, o) ?? {};
    if (r === "error")
      throw new x({
        name: Uc,
        message: "An error occurred when attempting to log out from OAuth provider."
      });
  } else
    le.clearTokens(), await Ho(), ce.dispatch("auth", { event: "signedOut" }, "Auth", ae);
}
async function $d(e) {
  try {
    const t = await le.getTokenStore().loadTokens();
    lr(t), Vd(t.accessToken) && await Nc({
      region: te(e.userPoolId),
      userAgentValue: Ie(ue.SignOut)
    }, {
      ClientId: e.userPoolClientId,
      Token: t.refreshToken
    });
  } catch {
    Rr.debug("Client signOut error caught but will proceed with token removal");
  }
}
async function qd(e) {
  try {
    const t = await le.getTokenStore().loadTokens();
    Gn(t), await bc({
      region: te(e.userPoolId),
      userAgentValue: Ie(ue.SignOut)
    }, {
      AccessToken: t.accessToken.toString()
    });
  } catch {
    Rr.debug("Global signOut error caught but will proceed with token removal");
  }
}
const Vd = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.payload) != null && t.origin_jti);
}, jd = {
  identityId: "identityId"
}, Hd = new W("DefaultIdentityIdStore");
class Wd {
  setAuthConfig(t) {
    Rt(t.Cognito), this.authConfig = t, this._authKeys = Gd("Cognito", t.Cognito.identityPoolId);
  }
  constructor(t) {
    this._authKeys = {}, this.keyValueStorage = t;
  }
  async loadIdentityId() {
    var t;
    Rt((t = this.authConfig) == null ? void 0 : t.Cognito);
    try {
      if (this._primaryIdentityId)
        return {
          id: this._primaryIdentityId,
          type: "primary"
        };
      {
        const n = await this.keyValueStorage.getItem(this._authKeys.identityId);
        return n ? {
          id: n,
          type: "guest"
        } : null;
      }
    } catch (n) {
      return Hd.log("Error getting stored IdentityId.", n), null;
    }
  }
  async storeIdentityId(t) {
    var n;
    Rt((n = this.authConfig) == null ? void 0 : n.Cognito), t.type === "guest" ? (this.keyValueStorage.setItem(this._authKeys.identityId, t.id), this._primaryIdentityId = void 0) : (this._primaryIdentityId = t.id, this.keyValueStorage.removeItem(this._authKeys.identityId));
  }
  async clearIdentityId() {
    this._primaryIdentityId = void 0, await this.keyValueStorage.removeItem(this._authKeys.identityId);
  }
}
const Gd = (e, t) => ei(jd)(`com.amplify.${e}`, t);
function _r(e) {
  const t = Ee(e).payload.iss, n = {};
  if (!t)
    throw new x({
      name: "InvalidIdTokenException",
      message: "Invalid Idtoken."
    });
  const i = t.replace(/(^\w+:|^)\/\//, "");
  return n[i] = e, n;
}
const zd = new W("CognitoIdentityIdProvider");
async function Qd({ tokens: e, authConfig: t, identityIdStore: n }) {
  n.setAuthConfig({ Cognito: t });
  let i = await n.loadIdentityId();
  if (e) {
    if (i && i.type === "primary")
      return i.id;
    {
      const o = e.idToken ? _r(e.idToken.toString()) : {}, r = await po(o, t);
      i && i.id === r && zd.debug(`The guest identity ${i.id} has become the primary identity.`), i = {
        id: r,
        type: "primary"
      };
    }
  } else {
    if (i && i.type === "guest")
      return i.id;
    i = {
      id: await po({}, t),
      type: "guest"
    };
  }
  return n.storeIdentityId(i), i.id;
}
async function po(e, t) {
  const n = t == null ? void 0 : t.identityPoolId, i = wn(n), o = (
    // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await Ca({
      region: i
    }, {
      IdentityPoolId: n,
      Logins: e
    })).IdentityId
  );
  if (!o)
    throw new x({
      name: "GetIdResponseException",
      message: "Received undefined response from getId operation",
      recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
  return o;
}
const Nt = new W("CognitoCredentialsProvider"), fo = 50 * 60 * 1e3;
class Yd {
  constructor(t) {
    this._nextCredentialsRefresh = 0, this._identityIdStore = t;
  }
  async clearCredentialsAndIdentityId() {
    Nt.debug("Clearing out credentials and identityId"), this._credentialsAndIdentityId = void 0, await this._identityIdStore.clearIdentityId();
  }
  async clearCredentials() {
    Nt.debug("Clearing out in-memory credentials"), this._credentialsAndIdentityId = void 0;
  }
  async getCredentialsAndIdentityId(t) {
    const n = t.authenticated, { tokens: i } = t, { authConfig: o } = t;
    try {
      Rt(o == null ? void 0 : o.Cognito);
    } catch {
      return;
    }
    if (!n && !o.Cognito.allowGuestAccess)
      return;
    const { forceRefresh: r } = t, s = this.hasTokenChanged(i), a = await Qd({
      tokens: i,
      authConfig: o.Cognito,
      identityIdStore: this._identityIdStore
    });
    return (r || s) && this.clearCredentials(), n ? ($c(i), this.credsForOIDCTokens(o.Cognito, i, a)) : this.getGuestCredentials(a, o.Cognito);
  }
  async getGuestCredentials(t, n) {
    if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === !1)
      return Nt.info("returning stored credentials as they neither past TTL nor expired."), this._credentialsAndIdentityId;
    this.clearCredentials();
    const i = wn(n.identityPoolId), o = await Pi({ region: i }, {
      IdentityId: t
    });
    if (o.Credentials && o.Credentials.AccessKeyId && o.Credentials.SecretKey) {
      this._nextCredentialsRefresh = (/* @__PURE__ */ new Date()).getTime() + fo;
      const r = {
        credentials: {
          accessKeyId: o.Credentials.AccessKeyId,
          secretAccessKey: o.Credentials.SecretKey,
          sessionToken: o.Credentials.SessionToken,
          expiration: o.Credentials.Expiration
        },
        identityId: t
      }, s = o.IdentityId;
      return s && (r.identityId = s, this._identityIdStore.storeIdentityId({
        id: s,
        type: "guest"
      })), this._credentialsAndIdentityId = {
        ...r,
        isAuthenticatedCreds: !1
      }, r;
    } else
      throw new x({
        name: "CredentialsNotFoundException",
        message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
      });
  }
  async credsForOIDCTokens(t, n, i) {
    var a;
    if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === !0)
      return Nt.debug("returning stored credentials as they neither past TTL nor expired."), this._credentialsAndIdentityId;
    this.clearCredentials();
    const o = n.idToken ? _r(n.idToken.toString()) : {}, r = wn(t.identityPoolId), s = await Pi({ region: r }, {
      IdentityId: i,
      Logins: o
    });
    if (s.Credentials && s.Credentials.AccessKeyId && s.Credentials.SecretKey) {
      const c = {
        credentials: {
          accessKeyId: s.Credentials.AccessKeyId,
          secretAccessKey: s.Credentials.SecretKey,
          sessionToken: s.Credentials.SessionToken,
          expiration: s.Credentials.Expiration
        },
        identityId: i
      };
      this._credentialsAndIdentityId = {
        ...c,
        isAuthenticatedCreds: !0,
        associatedIdToken: (a = n.idToken) == null ? void 0 : a.toString()
      }, this._nextCredentialsRefresh = (/* @__PURE__ */ new Date()).getTime() + fo;
      const u = s.IdentityId;
      return u && (c.identityId = u, this._identityIdStore.storeIdentityId({
        id: u,
        type: "primary"
      })), c;
    } else
      throw new x({
        name: "CredentialsException",
        message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
      });
  }
  isPastTTL() {
    return this._nextCredentialsRefresh === void 0 ? !0 : this._nextCredentialsRefresh <= Date.now();
  }
  hasTokenChanged(t) {
    var n, i;
    return !!t && !!((n = this._credentialsAndIdentityId) != null && n.associatedIdToken) && ((i = t.idToken) == null ? void 0 : i.toString()) !== this._credentialsAndIdentityId.associatedIdToken;
  }
}
const Sp = new Yd(new Wd(Zt));
function Ot(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ot = function(n) {
    return typeof n;
  } : Ot = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ot(e);
}
function Jd(e) {
  return Ot(e) == "object" && e !== null;
}
var br = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";
function xn(e, t) {
  for (var n = /\r\n|[\n\r]/g, i = 1, o = t + 1, r; (r = n.exec(e.body)) && r.index < t; )
    i += 1, o = t + 1 - (r.index + r[0].length);
  return {
    line: i,
    column: o
  };
}
function Xd(e) {
  return xr(e.source, xn(e.source, e.start));
}
function xr(e, t) {
  var n = e.locationOffset.column - 1, i = Dt(n) + e.body, o = t.line - 1, r = e.locationOffset.line - 1, s = t.line + r, a = t.line === 1 ? n : 0, c = t.column + a, u = "".concat(e.name, ":").concat(s, ":").concat(c, `
`), d = i.split(/\r\n|[\n\r]/g), l = d[o];
  if (l.length > 120) {
    for (var h = Math.floor(c / 80), f = c % 80, p = [], m = 0; m < l.length; m += 80)
      p.push(l.slice(m, m + 80));
    return u + mo([["".concat(s), p[0]]].concat(p.slice(1, h + 1).map(function(g) {
      return ["", g];
    }), [[" ", Dt(f - 1) + "^"], ["", p[h + 1]]]));
  }
  return u + mo([
    // Lines specified like this: ["prefix", "string"],
    ["".concat(s - 1), d[o - 1]],
    ["".concat(s), l],
    ["", Dt(c - 1) + "^"],
    ["".concat(s + 1), d[o + 1]]
  ]);
}
function mo(e) {
  var t = e.filter(function(i) {
    i[0];
    var o = i[1];
    return o !== void 0;
  }), n = Math.max.apply(Math, t.map(function(i) {
    var o = i[0];
    return o.length;
  }));
  return t.map(function(i) {
    var o = i[0], r = i[1];
    return Zd(n, o) + (r ? " | " + r : " |");
  }).join(`
`);
}
function Dt(e) {
  return Array(e + 1).join(" ");
}
function Zd(e, t) {
  return Dt(e - t.length) + t;
}
function kt(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? kt = function(n) {
    return typeof n;
  } : kt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, kt(e);
}
function yo(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function el(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yo(Object(n), !0).forEach(function(i) {
      tl(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yo(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function tl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Eo(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function il(e, t, n) {
  return t && Eo(e.prototype, t), n && Eo(e, n), e;
}
function ol(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && yt(e, t);
}
function rl(e) {
  var t = Dr();
  return function() {
    var i = Et(e), o;
    if (t) {
      var r = Et(this).constructor;
      o = Reflect.construct(i, arguments, r);
    } else
      o = i.apply(this, arguments);
    return Or(this, o);
  };
}
function Or(e, t) {
  return t && (kt(t) === "object" || typeof t == "function") ? t : dt(e);
}
function dt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function On(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return On = function(i) {
    if (i === null || !sl(i))
      return i;
    if (typeof i != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(i))
        return t.get(i);
      t.set(i, o);
    }
    function o() {
      return Pt(i, arguments, Et(this).constructor);
    }
    return o.prototype = Object.create(i.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), yt(o, i);
  }, On(e);
}
function Pt(e, t, n) {
  return Dr() ? Pt = Reflect.construct : Pt = function(o, r, s) {
    var a = [null];
    a.push.apply(a, r);
    var c = Function.bind.apply(o, a), u = new c();
    return s && yt(u, s.prototype), u;
  }, Pt.apply(null, arguments);
}
function Dr() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function sl(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function yt(e, t) {
  return yt = Object.setPrototypeOf || function(i, o) {
    return i.__proto__ = o, i;
  }, yt(e, t);
}
function Et(e) {
  return Et = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Et(e);
}
var ht = /* @__PURE__ */ function(e) {
  ol(n, e);
  var t = rl(n);
  function n(i, o, r, s, a, c, u) {
    var d, l, h, f;
    nl(this, n), f = t.call(this, i), f.name = "GraphQLError", f.originalError = c ?? void 0, f.nodes = go(Array.isArray(o) ? o : o ? [o] : void 0);
    for (var p = [], m = 0, g = (E = f.nodes) !== null && E !== void 0 ? E : []; m < g.length; m++) {
      var E, S = g[m], v = S.loc;
      v != null && p.push(v);
    }
    p = go(p), f.source = r ?? ((d = p) === null || d === void 0 ? void 0 : d[0].source), f.positions = s ?? ((l = p) === null || l === void 0 ? void 0 : l.map(function(A) {
      return A.start;
    })), f.locations = s && r ? s.map(function(A) {
      return xn(r, A);
    }) : (h = p) === null || h === void 0 ? void 0 : h.map(function(A) {
      return xn(A.source, A.start);
    }), f.path = a ?? void 0;
    var N = c == null ? void 0 : c.extensions;
    return u == null && Jd(N) ? f.extensions = el({}, N) : f.extensions = u ?? {}, Object.defineProperties(dt(f), {
      message: {
        enumerable: !0
      },
      locations: {
        enumerable: f.locations != null
      },
      path: {
        enumerable: f.path != null
      },
      extensions: {
        enumerable: f.extensions != null && Object.keys(f.extensions).length > 0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? (Object.defineProperty(dt(f), "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }), Or(f)) : (Error.captureStackTrace ? Error.captureStackTrace(dt(f), n) : Object.defineProperty(dt(f), "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    }), f);
  }
  return il(n, [{
    key: "toString",
    value: function() {
      return al(this);
    }
    // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  }, {
    key: br,
    get: function() {
      return "Object";
    }
  }]), n;
}(/* @__PURE__ */ On(Error));
function go(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function al(e) {
  var t = e.message;
  if (e.nodes)
    for (var n = 0, i = e.nodes; n < i.length; n++) {
      var o = i[n];
      o.loc && (t += `

` + Xd(o.loc));
    }
  else if (e.source && e.locations)
    for (var r = 0, s = e.locations; r < s.length; r++) {
      var a = s[r];
      t += `

` + xr(e.source, a);
    }
  return t;
}
function ee(e, t, n) {
  return new ht("Syntax Error: ".concat(n), void 0, e, [t]);
}
var R = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function cl(e, t) {
  var n = !!e;
  if (!n)
    throw new Error(t ?? "Unexpected invariant triggered.");
}
var ul = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
const Dn = ul;
function kr(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || cl(0), e.prototype.inspect = t, Dn && (e.prototype[Dn] = t);
}
var Pr = /* @__PURE__ */ function() {
  function e(n, i, o) {
    this.start = n.start, this.end = i.end, this.startToken = n, this.endToken = i, this.source = o;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
}();
kr(Pr);
var $ = /* @__PURE__ */ function() {
  function e(n, i, o, r, s, a, c) {
    this.kind = n, this.start = i, this.end = o, this.line = r, this.column = s, this.value = c, this.prev = a, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
}();
kr($);
function So(e) {
  return e != null && typeof e.kind == "string";
}
var y = Object.freeze({
  SOF: "<SOF>",
  EOF: "<EOF>",
  BANG: "!",
  DOLLAR: "$",
  AMP: "&",
  PAREN_L: "(",
  PAREN_R: ")",
  SPREAD: "...",
  COLON: ":",
  EQUALS: "=",
  AT: "@",
  BRACKET_L: "[",
  BRACKET_R: "]",
  BRACE_L: "{",
  PIPE: "|",
  BRACE_R: "}",
  NAME: "Name",
  INT: "Int",
  FLOAT: "Float",
  STRING: "String",
  BLOCK_STRING: "BlockString",
  COMMENT: "Comment"
});
function Mt(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mt = function(n) {
    return typeof n;
  } : Mt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Mt(e);
}
var dl = 10, Mr = 2;
function ii(e) {
  return ln(e, []);
}
function ln(e, t) {
  switch (Mt(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : ll(e, t);
    default:
      return String(e);
  }
}
function ll(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var n = [].concat(t, [e]), i = fl(e);
  if (i !== void 0) {
    var o = i.call(e);
    if (o !== e)
      return typeof o == "string" ? o : ln(o, n);
  } else if (Array.isArray(e))
    return pl(e, n);
  return hl(e, n);
}
function hl(e, t) {
  var n = Object.keys(e);
  if (n.length === 0)
    return "{}";
  if (t.length > Mr)
    return "[" + ml(e) + "]";
  var i = n.map(function(o) {
    var r = ln(e[o], t);
    return o + ": " + r;
  });
  return "{ " + i.join(", ") + " }";
}
function pl(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > Mr)
    return "[Array]";
  for (var n = Math.min(dl, e.length), i = e.length - n, o = [], r = 0; r < n; ++r)
    o.push(ln(e[r], t));
  return i === 1 ? o.push("... 1 more item") : i > 1 && o.push("... ".concat(i, " more items")), "[" + o.join(", ") + "]";
}
function fl(e) {
  var t = e[String(Dn)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function ml(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
function yn(e, t) {
  var n = !!e;
  if (!n)
    throw new Error(t);
}
function Ft(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ft = function(n) {
    return typeof n;
  } : Ft = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ft(e);
}
const yl = process.env.NODE_ENV === "production" ? (
  // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
  // eslint-disable-next-line no-shadow
  function(t, n) {
    return t instanceof n;
  }
) : (
  // eslint-disable-next-line no-shadow
  function(t, n) {
    if (t instanceof n)
      return !0;
    if (Ft(t) === "object" && t !== null) {
      var i, o = n.prototype[Symbol.toStringTag], r = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (i = t.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (o === r) {
        var s = ii(t);
        throw new Error("Cannot use ".concat(o, ' "').concat(s, `" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`));
      }
    }
    return !1;
  }
);
function Io(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function El(e, t, n) {
  return t && Io(e.prototype, t), n && Io(e, n), e;
}
var Fr = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof t == "string" || yn(0, "Body must be a string. Received: ".concat(ii(t), ".")), this.body = t, this.name = n, this.locationOffset = i, this.locationOffset.line > 0 || yn(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || yn(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  return El(e, [{
    key: br,
    get: function() {
      return "Source";
    }
  }]), e;
}();
function gl(e) {
  return yl(e, Fr);
}
var Sl = Object.freeze({
  // Request Definitions
  QUERY: "QUERY",
  MUTATION: "MUTATION",
  SUBSCRIPTION: "SUBSCRIPTION",
  FIELD: "FIELD",
  FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
  FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
  INLINE_FRAGMENT: "INLINE_FRAGMENT",
  VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
  // Type System Definitions
  SCHEMA: "SCHEMA",
  SCALAR: "SCALAR",
  OBJECT: "OBJECT",
  FIELD_DEFINITION: "FIELD_DEFINITION",
  ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
  INTERFACE: "INTERFACE",
  UNION: "UNION",
  ENUM: "ENUM",
  ENUM_VALUE: "ENUM_VALUE",
  INPUT_OBJECT: "INPUT_OBJECT",
  INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});
function Il(e) {
  var t = e.split(/\r\n|[\n\r]/g), n = Tl(e);
  if (n !== 0)
    for (var i = 1; i < t.length; i++)
      t[i] = t[i].slice(n);
  for (var o = 0; o < t.length && To(t[o]); )
    ++o;
  for (var r = t.length; r > o && To(t[r - 1]); )
    --r;
  return t.slice(o, r).join(`
`);
}
function To(e) {
  for (var t = 0; t < e.length; ++t)
    if (e[t] !== " " && e[t] !== "	")
      return !1;
  return !0;
}
function Tl(e) {
  for (var t, n = !0, i = !0, o = 0, r = null, s = 0; s < e.length; ++s)
    switch (e.charCodeAt(s)) {
      case 13:
        e.charCodeAt(s + 1) === 10 && ++s;
      case 10:
        n = !1, i = !0, o = 0;
        break;
      case 9:
      case 32:
        ++o;
        break;
      default:
        i && !n && (r === null || o < r) && (r = o), i = !1;
    }
  return (t = r) !== null && t !== void 0 ? t : 0;
}
function vl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = e.indexOf(`
`) === -1, o = e[0] === " " || e[0] === "	", r = e[e.length - 1] === '"', s = e[e.length - 1] === "\\", a = !i || r || s || n, c = "";
  return a && !(i && o) && (c += `
` + t), c += t ? e.replace(/\n/g, `
` + t) : e, a && (c += `
`), '"""' + c.replace(/"""/g, '\\"""') + '"""';
}
var wl = /* @__PURE__ */ function() {
  function e(n) {
    var i = new $(y.SOF, 0, 0, 0, 0, null);
    this.source = n, this.lastToken = i, this.token = i, this.line = 1, this.lineStart = 0;
  }
  var t = e.prototype;
  return t.advance = function() {
    this.lastToken = this.token;
    var i = this.token = this.lookahead();
    return i;
  }, t.lookahead = function() {
    var i = this.token;
    if (i.kind !== y.EOF)
      do {
        var o;
        i = (o = i.next) !== null && o !== void 0 ? o : i.next = Nl(this, i);
      } while (i.kind === y.COMMENT);
    return i;
  }, e;
}();
function Al(e) {
  return e === y.BANG || e === y.DOLLAR || e === y.AMP || e === y.PAREN_L || e === y.PAREN_R || e === y.SPREAD || e === y.COLON || e === y.EQUALS || e === y.AT || e === y.BRACKET_L || e === y.BRACKET_R || e === y.BRACE_L || e === y.PIPE || e === y.BRACE_R;
}
function Oe(e) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(e) ? y.EOF : (
      // Trust JSON for ASCII.
      e < 127 ? JSON.stringify(String.fromCharCode(e)) : (
        // Otherwise print the escaped form.
        '"\\u'.concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"')
      )
    )
  );
}
function Nl(e, t) {
  for (var n = e.source, i = n.body, o = i.length, r = t.end; r < o; ) {
    var s = i.charCodeAt(r), a = e.line, c = 1 + r - e.lineStart;
    switch (s) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++r;
        continue;
      case 10:
        ++r, ++e.line, e.lineStart = r;
        continue;
      case 13:
        i.charCodeAt(r + 1) === 10 ? r += 2 : ++r, ++e.line, e.lineStart = r;
        continue;
      case 33:
        return new $(y.BANG, r, r + 1, a, c, t);
      case 35:
        return Rl(n, r, a, c, t);
      case 36:
        return new $(y.DOLLAR, r, r + 1, a, c, t);
      case 38:
        return new $(y.AMP, r, r + 1, a, c, t);
      case 40:
        return new $(y.PAREN_L, r, r + 1, a, c, t);
      case 41:
        return new $(y.PAREN_R, r, r + 1, a, c, t);
      case 46:
        if (i.charCodeAt(r + 1) === 46 && i.charCodeAt(r + 2) === 46)
          return new $(y.SPREAD, r, r + 3, a, c, t);
        break;
      case 58:
        return new $(y.COLON, r, r + 1, a, c, t);
      case 61:
        return new $(y.EQUALS, r, r + 1, a, c, t);
      case 64:
        return new $(y.AT, r, r + 1, a, c, t);
      case 91:
        return new $(y.BRACKET_L, r, r + 1, a, c, t);
      case 93:
        return new $(y.BRACKET_R, r, r + 1, a, c, t);
      case 123:
        return new $(y.BRACE_L, r, r + 1, a, c, t);
      case 124:
        return new $(y.PIPE, r, r + 1, a, c, t);
      case 125:
        return new $(y.BRACE_R, r, r + 1, a, c, t);
      case 34:
        return i.charCodeAt(r + 1) === 34 && i.charCodeAt(r + 2) === 34 ? xl(n, r, a, c, t, e) : bl(n, r, a, c, t);
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return _l(n, r, s, a, c, t);
      case 65:
      case 66:
      case 67:
      case 68:
      case 69:
      case 70:
      case 71:
      case 72:
      case 73:
      case 74:
      case 75:
      case 76:
      case 77:
      case 78:
      case 79:
      case 80:
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 95:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
      case 106:
      case 107:
      case 108:
      case 109:
      case 110:
      case 111:
      case 112:
      case 113:
      case 114:
      case 115:
      case 116:
      case 117:
      case 118:
      case 119:
      case 120:
      case 121:
      case 122:
        return Dl(n, r, a, c, t);
    }
    throw ee(n, r, Cl(s));
  }
  var u = e.line, d = 1 + r - e.lineStart;
  return new $(y.EOF, o, o, u, d, t);
}
function Cl(e) {
  return e < 32 && e !== 9 && e !== 10 && e !== 13 ? "Cannot contain the invalid character ".concat(Oe(e), ".") : e === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : "Cannot parse the unexpected character ".concat(Oe(e), ".");
}
function Rl(e, t, n, i, o) {
  var r = e.body, s, a = t;
  do
    s = r.charCodeAt(++a);
  while (!isNaN(s) && // SourceCharacter but not LineTerminator
  (s > 31 || s === 9));
  return new $(y.COMMENT, t, a, n, i, o, r.slice(t + 1, a));
}
function _l(e, t, n, i, o, r) {
  var s = e.body, a = n, c = t, u = !1;
  if (a === 45 && (a = s.charCodeAt(++c)), a === 48) {
    if (a = s.charCodeAt(++c), a >= 48 && a <= 57)
      throw ee(e, c, "Invalid number, unexpected digit after 0: ".concat(Oe(a), "."));
  } else
    c = En(e, c, a), a = s.charCodeAt(c);
  if (a === 46 && (u = !0, a = s.charCodeAt(++c), c = En(e, c, a), a = s.charCodeAt(c)), (a === 69 || a === 101) && (u = !0, a = s.charCodeAt(++c), (a === 43 || a === 45) && (a = s.charCodeAt(++c)), c = En(e, c, a), a = s.charCodeAt(c)), a === 46 || kl(a))
    throw ee(e, c, "Invalid number, expected digit but got: ".concat(Oe(a), "."));
  return new $(u ? y.FLOAT : y.INT, t, c, i, o, r, s.slice(t, c));
}
function En(e, t, n) {
  var i = e.body, o = t, r = n;
  if (r >= 48 && r <= 57) {
    do
      r = i.charCodeAt(++o);
    while (r >= 48 && r <= 57);
    return o;
  }
  throw ee(e, o, "Invalid number, expected digit but got: ".concat(Oe(r), "."));
}
function bl(e, t, n, i, o) {
  for (var r = e.body, s = t + 1, a = s, c = 0, u = ""; s < r.length && !isNaN(c = r.charCodeAt(s)) && // not LineTerminator
  c !== 10 && c !== 13; ) {
    if (c === 34)
      return u += r.slice(a, s), new $(y.STRING, t, s + 1, n, i, o, u);
    if (c < 32 && c !== 9)
      throw ee(e, s, "Invalid character within String: ".concat(Oe(c), "."));
    if (++s, c === 92) {
      switch (u += r.slice(a, s - 1), c = r.charCodeAt(s), c) {
        case 34:
          u += '"';
          break;
        case 47:
          u += "/";
          break;
        case 92:
          u += "\\";
          break;
        case 98:
          u += "\b";
          break;
        case 102:
          u += "\f";
          break;
        case 110:
          u += `
`;
          break;
        case 114:
          u += "\r";
          break;
        case 116:
          u += "	";
          break;
        case 117: {
          var d = Ol(r.charCodeAt(s + 1), r.charCodeAt(s + 2), r.charCodeAt(s + 3), r.charCodeAt(s + 4));
          if (d < 0) {
            var l = r.slice(s + 1, s + 5);
            throw ee(e, s, "Invalid character escape sequence: \\u".concat(l, "."));
          }
          u += String.fromCharCode(d), s += 4;
          break;
        }
        default:
          throw ee(e, s, "Invalid character escape sequence: \\".concat(String.fromCharCode(c), "."));
      }
      ++s, a = s;
    }
  }
  throw ee(e, s, "Unterminated string.");
}
function xl(e, t, n, i, o, r) {
  for (var s = e.body, a = t + 3, c = a, u = 0, d = ""; a < s.length && !isNaN(u = s.charCodeAt(a)); ) {
    if (u === 34 && s.charCodeAt(a + 1) === 34 && s.charCodeAt(a + 2) === 34)
      return d += s.slice(c, a), new $(y.BLOCK_STRING, t, a + 3, n, i, o, Il(d));
    if (u < 32 && u !== 9 && u !== 10 && u !== 13)
      throw ee(e, a, "Invalid character within String: ".concat(Oe(u), "."));
    u === 10 ? (++a, ++r.line, r.lineStart = a) : u === 13 ? (s.charCodeAt(a + 1) === 10 ? a += 2 : ++a, ++r.line, r.lineStart = a) : /* Escape Triple-Quote (\""") */ u === 92 && s.charCodeAt(a + 1) === 34 && s.charCodeAt(a + 2) === 34 && s.charCodeAt(a + 3) === 34 ? (d += s.slice(c, a) + '"""', a += 4, c = a) : ++a;
  }
  throw ee(e, a, "Unterminated string.");
}
function Ol(e, t, n, i) {
  return Ct(e) << 12 | Ct(t) << 8 | Ct(n) << 4 | Ct(i);
}
function Ct(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Dl(e, t, n, i, o) {
  for (var r = e.body, s = r.length, a = t + 1, c = 0; a !== s && !isNaN(c = r.charCodeAt(a)) && (c === 95 || // _
  c >= 48 && c <= 57 || // 0-9
  c >= 65 && c <= 90 || // A-Z
  c >= 97 && c <= 122); )
    ++a;
  return new $(y.NAME, t, a, n, i, o, r.slice(t, a));
}
function kl(e) {
  return e === 95 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function gn(e, t) {
  var n = new Pl(e, t);
  return n.parseDocument();
}
var Pl = /* @__PURE__ */ function() {
  function e(n, i) {
    var o = gl(n) ? n : new Fr(n);
    this._lexer = new wl(o), this._options = i;
  }
  var t = e.prototype;
  return t.parseName = function() {
    var i = this.expectToken(y.NAME);
    return {
      kind: R.NAME,
      value: i.value,
      loc: this.loc(i)
    };
  }, t.parseDocument = function() {
    var i = this._lexer.token;
    return {
      kind: R.DOCUMENT,
      definitions: this.many(y.SOF, this.parseDefinition, y.EOF),
      loc: this.loc(i)
    };
  }, t.parseDefinition = function() {
    if (this.peek(y.NAME))
      switch (this._lexer.token.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "schema":
        case "scalar":
        case "type":
        case "interface":
        case "union":
        case "enum":
        case "input":
        case "directive":
          return this.parseTypeSystemDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    else {
      if (this.peek(y.BRACE_L))
        return this.parseOperationDefinition();
      if (this.peekDescription())
        return this.parseTypeSystemDefinition();
    }
    throw this.unexpected();
  }, t.parseOperationDefinition = function() {
    var i = this._lexer.token;
    if (this.peek(y.BRACE_L))
      return {
        kind: R.OPERATION_DEFINITION,
        operation: "query",
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(i)
      };
    var o = this.parseOperationType(), r;
    return this.peek(y.NAME) && (r = this.parseName()), {
      kind: R.OPERATION_DEFINITION,
      operation: o,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(i)
    };
  }, t.parseOperationType = function() {
    var i = this.expectToken(y.NAME);
    switch (i.value) {
      case "query":
        return "query";
      case "mutation":
        return "mutation";
      case "subscription":
        return "subscription";
    }
    throw this.unexpected(i);
  }, t.parseVariableDefinitions = function() {
    return this.optionalMany(y.PAREN_L, this.parseVariableDefinition, y.PAREN_R);
  }, t.parseVariableDefinition = function() {
    var i = this._lexer.token;
    return {
      kind: R.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(y.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(y.EQUALS) ? this.parseValueLiteral(!0) : void 0,
      directives: this.parseDirectives(!0),
      loc: this.loc(i)
    };
  }, t.parseVariable = function() {
    var i = this._lexer.token;
    return this.expectToken(y.DOLLAR), {
      kind: R.VARIABLE,
      name: this.parseName(),
      loc: this.loc(i)
    };
  }, t.parseSelectionSet = function() {
    var i = this._lexer.token;
    return {
      kind: R.SELECTION_SET,
      selections: this.many(y.BRACE_L, this.parseSelection, y.BRACE_R),
      loc: this.loc(i)
    };
  }, t.parseSelection = function() {
    return this.peek(y.SPREAD) ? this.parseFragment() : this.parseField();
  }, t.parseField = function() {
    var i = this._lexer.token, o = this.parseName(), r, s;
    return this.expectOptionalToken(y.COLON) ? (r = o, s = this.parseName()) : s = o, {
      kind: R.FIELD,
      alias: r,
      name: s,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(y.BRACE_L) ? this.parseSelectionSet() : void 0,
      loc: this.loc(i)
    };
  }, t.parseArguments = function(i) {
    var o = i ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(y.PAREN_L, o, y.PAREN_R);
  }, t.parseArgument = function() {
    var i = this._lexer.token, o = this.parseName();
    return this.expectToken(y.COLON), {
      kind: R.ARGUMENT,
      name: o,
      value: this.parseValueLiteral(!1),
      loc: this.loc(i)
    };
  }, t.parseConstArgument = function() {
    var i = this._lexer.token;
    return {
      kind: R.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(y.COLON), this.parseValueLiteral(!0)),
      loc: this.loc(i)
    };
  }, t.parseFragment = function() {
    var i = this._lexer.token;
    this.expectToken(y.SPREAD);
    var o = this.expectOptionalKeyword("on");
    return !o && this.peek(y.NAME) ? {
      kind: R.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1),
      loc: this.loc(i)
    } : {
      kind: R.INLINE_FRAGMENT,
      typeCondition: o ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(i)
    };
  }, t.parseFragmentDefinition = function() {
    var i, o = this._lexer.token;
    return this.expectKeyword("fragment"), ((i = this._options) === null || i === void 0 ? void 0 : i.experimentalFragmentVariables) === !0 ? {
      kind: R.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(o)
    } : {
      kind: R.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(o)
    };
  }, t.parseFragmentName = function() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }, t.parseValueLiteral = function(i) {
    var o = this._lexer.token;
    switch (o.kind) {
      case y.BRACKET_L:
        return this.parseList(i);
      case y.BRACE_L:
        return this.parseObject(i);
      case y.INT:
        return this._lexer.advance(), {
          kind: R.INT,
          value: o.value,
          loc: this.loc(o)
        };
      case y.FLOAT:
        return this._lexer.advance(), {
          kind: R.FLOAT,
          value: o.value,
          loc: this.loc(o)
        };
      case y.STRING:
      case y.BLOCK_STRING:
        return this.parseStringLiteral();
      case y.NAME:
        switch (this._lexer.advance(), o.value) {
          case "true":
            return {
              kind: R.BOOLEAN,
              value: !0,
              loc: this.loc(o)
            };
          case "false":
            return {
              kind: R.BOOLEAN,
              value: !1,
              loc: this.loc(o)
            };
          case "null":
            return {
              kind: R.NULL,
              loc: this.loc(o)
            };
          default:
            return {
              kind: R.ENUM,
              value: o.value,
              loc: this.loc(o)
            };
        }
      case y.DOLLAR:
        if (!i)
          return this.parseVariable();
        break;
    }
    throw this.unexpected();
  }, t.parseStringLiteral = function() {
    var i = this._lexer.token;
    return this._lexer.advance(), {
      kind: R.STRING,
      value: i.value,
      block: i.kind === y.BLOCK_STRING,
      loc: this.loc(i)
    };
  }, t.parseList = function(i) {
    var o = this, r = this._lexer.token, s = function() {
      return o.parseValueLiteral(i);
    };
    return {
      kind: R.LIST,
      values: this.any(y.BRACKET_L, s, y.BRACKET_R),
      loc: this.loc(r)
    };
  }, t.parseObject = function(i) {
    var o = this, r = this._lexer.token, s = function() {
      return o.parseObjectField(i);
    };
    return {
      kind: R.OBJECT,
      fields: this.any(y.BRACE_L, s, y.BRACE_R),
      loc: this.loc(r)
    };
  }, t.parseObjectField = function(i) {
    var o = this._lexer.token, r = this.parseName();
    return this.expectToken(y.COLON), {
      kind: R.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(i),
      loc: this.loc(o)
    };
  }, t.parseDirectives = function(i) {
    for (var o = []; this.peek(y.AT); )
      o.push(this.parseDirective(i));
    return o;
  }, t.parseDirective = function(i) {
    var o = this._lexer.token;
    return this.expectToken(y.AT), {
      kind: R.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(i),
      loc: this.loc(o)
    };
  }, t.parseTypeReference = function() {
    var i = this._lexer.token, o;
    return this.expectOptionalToken(y.BRACKET_L) ? (o = this.parseTypeReference(), this.expectToken(y.BRACKET_R), o = {
      kind: R.LIST_TYPE,
      type: o,
      loc: this.loc(i)
    }) : o = this.parseNamedType(), this.expectOptionalToken(y.BANG) ? {
      kind: R.NON_NULL_TYPE,
      type: o,
      loc: this.loc(i)
    } : o;
  }, t.parseNamedType = function() {
    var i = this._lexer.token;
    return {
      kind: R.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(i)
    };
  }, t.parseTypeSystemDefinition = function() {
    var i = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
    if (i.kind === y.NAME)
      switch (i.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
    throw this.unexpected(i);
  }, t.peekDescription = function() {
    return this.peek(y.STRING) || this.peek(y.BLOCK_STRING);
  }, t.parseDescription = function() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }, t.parseSchemaDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("schema");
    var r = this.parseDirectives(!0), s = this.many(y.BRACE_L, this.parseOperationTypeDefinition, y.BRACE_R);
    return {
      kind: R.SCHEMA_DEFINITION,
      description: o,
      directives: r,
      operationTypes: s,
      loc: this.loc(i)
    };
  }, t.parseOperationTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseOperationType();
    this.expectToken(y.COLON);
    var r = this.parseNamedType();
    return {
      kind: R.OPERATION_TYPE_DEFINITION,
      operation: o,
      type: r,
      loc: this.loc(i)
    };
  }, t.parseScalarTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("scalar");
    var r = this.parseName(), s = this.parseDirectives(!0);
    return {
      kind: R.SCALAR_TYPE_DEFINITION,
      description: o,
      name: r,
      directives: s,
      loc: this.loc(i)
    };
  }, t.parseObjectTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("type");
    var r = this.parseName(), s = this.parseImplementsInterfaces(), a = this.parseDirectives(!0), c = this.parseFieldsDefinition();
    return {
      kind: R.OBJECT_TYPE_DEFINITION,
      description: o,
      name: r,
      interfaces: s,
      directives: a,
      fields: c,
      loc: this.loc(i)
    };
  }, t.parseImplementsInterfaces = function() {
    var i;
    if (!this.expectOptionalKeyword("implements"))
      return [];
    if (((i = this._options) === null || i === void 0 ? void 0 : i.allowLegacySDLImplementsInterfaces) === !0) {
      var o = [];
      this.expectOptionalToken(y.AMP);
      do
        o.push(this.parseNamedType());
      while (this.expectOptionalToken(y.AMP) || this.peek(y.NAME));
      return o;
    }
    return this.delimitedMany(y.AMP, this.parseNamedType);
  }, t.parseFieldsDefinition = function() {
    var i;
    return ((i = this._options) === null || i === void 0 ? void 0 : i.allowLegacySDLEmptyFields) === !0 && this.peek(y.BRACE_L) && this._lexer.lookahead().kind === y.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(y.BRACE_L, this.parseFieldDefinition, y.BRACE_R);
  }, t.parseFieldDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription(), r = this.parseName(), s = this.parseArgumentDefs();
    this.expectToken(y.COLON);
    var a = this.parseTypeReference(), c = this.parseDirectives(!0);
    return {
      kind: R.FIELD_DEFINITION,
      description: o,
      name: r,
      arguments: s,
      type: a,
      directives: c,
      loc: this.loc(i)
    };
  }, t.parseArgumentDefs = function() {
    return this.optionalMany(y.PAREN_L, this.parseInputValueDef, y.PAREN_R);
  }, t.parseInputValueDef = function() {
    var i = this._lexer.token, o = this.parseDescription(), r = this.parseName();
    this.expectToken(y.COLON);
    var s = this.parseTypeReference(), a;
    this.expectOptionalToken(y.EQUALS) && (a = this.parseValueLiteral(!0));
    var c = this.parseDirectives(!0);
    return {
      kind: R.INPUT_VALUE_DEFINITION,
      description: o,
      name: r,
      type: s,
      defaultValue: a,
      directives: c,
      loc: this.loc(i)
    };
  }, t.parseInterfaceTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("interface");
    var r = this.parseName(), s = this.parseImplementsInterfaces(), a = this.parseDirectives(!0), c = this.parseFieldsDefinition();
    return {
      kind: R.INTERFACE_TYPE_DEFINITION,
      description: o,
      name: r,
      interfaces: s,
      directives: a,
      fields: c,
      loc: this.loc(i)
    };
  }, t.parseUnionTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("union");
    var r = this.parseName(), s = this.parseDirectives(!0), a = this.parseUnionMemberTypes();
    return {
      kind: R.UNION_TYPE_DEFINITION,
      description: o,
      name: r,
      directives: s,
      types: a,
      loc: this.loc(i)
    };
  }, t.parseUnionMemberTypes = function() {
    return this.expectOptionalToken(y.EQUALS) ? this.delimitedMany(y.PIPE, this.parseNamedType) : [];
  }, t.parseEnumTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("enum");
    var r = this.parseName(), s = this.parseDirectives(!0), a = this.parseEnumValuesDefinition();
    return {
      kind: R.ENUM_TYPE_DEFINITION,
      description: o,
      name: r,
      directives: s,
      values: a,
      loc: this.loc(i)
    };
  }, t.parseEnumValuesDefinition = function() {
    return this.optionalMany(y.BRACE_L, this.parseEnumValueDefinition, y.BRACE_R);
  }, t.parseEnumValueDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription(), r = this.parseName(), s = this.parseDirectives(!0);
    return {
      kind: R.ENUM_VALUE_DEFINITION,
      description: o,
      name: r,
      directives: s,
      loc: this.loc(i)
    };
  }, t.parseInputObjectTypeDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("input");
    var r = this.parseName(), s = this.parseDirectives(!0), a = this.parseInputFieldsDefinition();
    return {
      kind: R.INPUT_OBJECT_TYPE_DEFINITION,
      description: o,
      name: r,
      directives: s,
      fields: a,
      loc: this.loc(i)
    };
  }, t.parseInputFieldsDefinition = function() {
    return this.optionalMany(y.BRACE_L, this.parseInputValueDef, y.BRACE_R);
  }, t.parseTypeSystemExtension = function() {
    var i = this._lexer.lookahead();
    if (i.kind === y.NAME)
      switch (i.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(i);
  }, t.parseSchemaExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    var o = this.parseDirectives(!0), r = this.optionalMany(y.BRACE_L, this.parseOperationTypeDefinition, y.BRACE_R);
    if (o.length === 0 && r.length === 0)
      throw this.unexpected();
    return {
      kind: R.SCHEMA_EXTENSION,
      directives: o,
      operationTypes: r,
      loc: this.loc(i)
    };
  }, t.parseScalarTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    var o = this.parseName(), r = this.parseDirectives(!0);
    if (r.length === 0)
      throw this.unexpected();
    return {
      kind: R.SCALAR_TYPE_EXTENSION,
      name: o,
      directives: r,
      loc: this.loc(i)
    };
  }, t.parseObjectTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    var o = this.parseName(), r = this.parseImplementsInterfaces(), s = this.parseDirectives(!0), a = this.parseFieldsDefinition();
    if (r.length === 0 && s.length === 0 && a.length === 0)
      throw this.unexpected();
    return {
      kind: R.OBJECT_TYPE_EXTENSION,
      name: o,
      interfaces: r,
      directives: s,
      fields: a,
      loc: this.loc(i)
    };
  }, t.parseInterfaceTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    var o = this.parseName(), r = this.parseImplementsInterfaces(), s = this.parseDirectives(!0), a = this.parseFieldsDefinition();
    if (r.length === 0 && s.length === 0 && a.length === 0)
      throw this.unexpected();
    return {
      kind: R.INTERFACE_TYPE_EXTENSION,
      name: o,
      interfaces: r,
      directives: s,
      fields: a,
      loc: this.loc(i)
    };
  }, t.parseUnionTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    var o = this.parseName(), r = this.parseDirectives(!0), s = this.parseUnionMemberTypes();
    if (r.length === 0 && s.length === 0)
      throw this.unexpected();
    return {
      kind: R.UNION_TYPE_EXTENSION,
      name: o,
      directives: r,
      types: s,
      loc: this.loc(i)
    };
  }, t.parseEnumTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    var o = this.parseName(), r = this.parseDirectives(!0), s = this.parseEnumValuesDefinition();
    if (r.length === 0 && s.length === 0)
      throw this.unexpected();
    return {
      kind: R.ENUM_TYPE_EXTENSION,
      name: o,
      directives: r,
      values: s,
      loc: this.loc(i)
    };
  }, t.parseInputObjectTypeExtension = function() {
    var i = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    var o = this.parseName(), r = this.parseDirectives(!0), s = this.parseInputFieldsDefinition();
    if (r.length === 0 && s.length === 0)
      throw this.unexpected();
    return {
      kind: R.INPUT_OBJECT_TYPE_EXTENSION,
      name: o,
      directives: r,
      fields: s,
      loc: this.loc(i)
    };
  }, t.parseDirectiveDefinition = function() {
    var i = this._lexer.token, o = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(y.AT);
    var r = this.parseName(), s = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    var c = this.parseDirectiveLocations();
    return {
      kind: R.DIRECTIVE_DEFINITION,
      description: o,
      name: r,
      arguments: s,
      repeatable: a,
      locations: c,
      loc: this.loc(i)
    };
  }, t.parseDirectiveLocations = function() {
    return this.delimitedMany(y.PIPE, this.parseDirectiveLocation);
  }, t.parseDirectiveLocation = function() {
    var i = this._lexer.token, o = this.parseName();
    if (Sl[o.value] !== void 0)
      return o;
    throw this.unexpected(i);
  }, t.loc = function(i) {
    var o;
    if (((o = this._options) === null || o === void 0 ? void 0 : o.noLocation) !== !0)
      return new Pr(i, this._lexer.lastToken, this._lexer.source);
  }, t.peek = function(i) {
    return this._lexer.token.kind === i;
  }, t.expectToken = function(i) {
    var o = this._lexer.token;
    if (o.kind === i)
      return this._lexer.advance(), o;
    throw ee(this._lexer.source, o.start, "Expected ".concat(Lr(i), ", found ").concat(Sn(o), "."));
  }, t.expectOptionalToken = function(i) {
    var o = this._lexer.token;
    if (o.kind === i)
      return this._lexer.advance(), o;
  }, t.expectKeyword = function(i) {
    var o = this._lexer.token;
    if (o.kind === y.NAME && o.value === i)
      this._lexer.advance();
    else
      throw ee(this._lexer.source, o.start, 'Expected "'.concat(i, '", found ').concat(Sn(o), "."));
  }, t.expectOptionalKeyword = function(i) {
    var o = this._lexer.token;
    return o.kind === y.NAME && o.value === i ? (this._lexer.advance(), !0) : !1;
  }, t.unexpected = function(i) {
    var o = i ?? this._lexer.token;
    return ee(this._lexer.source, o.start, "Unexpected ".concat(Sn(o), "."));
  }, t.any = function(i, o, r) {
    this.expectToken(i);
    for (var s = []; !this.expectOptionalToken(r); )
      s.push(o.call(this));
    return s;
  }, t.optionalMany = function(i, o, r) {
    if (this.expectOptionalToken(i)) {
      var s = [];
      do
        s.push(o.call(this));
      while (!this.expectOptionalToken(r));
      return s;
    }
    return [];
  }, t.many = function(i, o, r) {
    this.expectToken(i);
    var s = [];
    do
      s.push(o.call(this));
    while (!this.expectOptionalToken(r));
    return s;
  }, t.delimitedMany = function(i, o) {
    this.expectOptionalToken(i);
    var r = [];
    do
      r.push(o.call(this));
    while (this.expectOptionalToken(i));
    return r;
  }, e;
}();
function Sn(e) {
  var t = e.value;
  return Lr(e.kind) + (t != null ? ' "'.concat(t, '"') : "");
}
function Lr(e) {
  return Al(e) ? '"'.concat(e, '"') : e;
}
var Ml = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Fl = Object.freeze({});
function Ll(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ml, i = void 0, o = Array.isArray(e), r = [e], s = -1, a = [], c = void 0, u = void 0, d = void 0, l = [], h = [], f = e;
  do {
    s++;
    var p = s === r.length, m = p && a.length !== 0;
    if (p) {
      if (u = h.length === 0 ? void 0 : l[l.length - 1], c = d, d = h.pop(), m) {
        if (o)
          c = c.slice();
        else {
          for (var g = {}, E = 0, S = Object.keys(c); E < S.length; E++) {
            var v = S[E];
            g[v] = c[v];
          }
          c = g;
        }
        for (var N = 0, A = 0; A < a.length; A++) {
          var w = a[A][0], _ = a[A][1];
          o && (w -= N), o && _ === null ? (c.splice(w, 1), N++) : c[w] = _;
        }
      }
      s = i.index, r = i.keys, a = i.edits, o = i.inArray, i = i.prev;
    } else {
      if (u = d ? o ? s : r[s] : void 0, c = d ? d[u] : f, c == null)
        continue;
      d && l.push(u);
    }
    var D = void 0;
    if (!Array.isArray(c)) {
      if (!So(c))
        throw new Error("Invalid AST Node: ".concat(ii(c), "."));
      var O = Ul(t, c.kind, p);
      if (O) {
        if (D = O.call(t, c, u, d, l, h), D === Fl)
          break;
        if (D === !1) {
          if (!p) {
            l.pop();
            continue;
          }
        } else if (D !== void 0 && (a.push([u, D]), !p))
          if (So(D))
            c = D;
          else {
            l.pop();
            continue;
          }
      }
    }
    if (D === void 0 && m && a.push([u, c]), p)
      l.pop();
    else {
      var U;
      i = {
        inArray: o,
        index: s,
        keys: r,
        edits: a,
        prev: i
      }, o = Array.isArray(c), r = o ? c : (U = n[c.kind]) !== null && U !== void 0 ? U : [], s = -1, a = [], d && h.push(d), d = c;
    }
  } while (i !== void 0);
  return a.length !== 0 && (f = a[a.length - 1][1]), f;
}
function Ul(e, t, n) {
  var i = e[t];
  if (i) {
    if (!n && typeof i == "function")
      return i;
    var o = n ? i.leave : i.enter;
    if (typeof o == "function")
      return o;
  } else {
    var r = n ? e.leave : e.enter;
    if (r) {
      if (typeof r == "function")
        return r;
      var s = r[t];
      if (typeof s == "function")
        return s;
    }
  }
}
function at(e) {
  return Ll(e, {
    leave: Bl
  });
}
var Kl = 80, Bl = {
  Name: function(t) {
    return t.value;
  },
  Variable: function(t) {
    return "$" + t.name;
  },
  // Document
  Document: function(t) {
    return T(t.definitions, `

`) + `
`;
  },
  OperationDefinition: function(t) {
    var n = t.operation, i = t.name, o = B("(", T(t.variableDefinitions, ", "), ")"), r = T(t.directives, " "), s = t.selectionSet;
    return !i && !r && !o && n === "query" ? s : T([n, T([i, o]), r, s], " ");
  },
  VariableDefinition: function(t) {
    var n = t.variable, i = t.type, o = t.defaultValue, r = t.directives;
    return n + ": " + i + B(" = ", o) + B(" ", T(r, " "));
  },
  SelectionSet: function(t) {
    var n = t.selections;
    return oe(n);
  },
  Field: function(t) {
    var n = t.alias, i = t.name, o = t.arguments, r = t.directives, s = t.selectionSet, a = B("", n, ": ") + i, c = a + B("(", T(o, ", "), ")");
    return c.length > Kl && (c = a + B(`(
`, Lt(T(o, `
`)), `
)`)), T([c, T(r, " "), s], " ");
  },
  Argument: function(t) {
    var n = t.name, i = t.value;
    return n + ": " + i;
  },
  // Fragments
  FragmentSpread: function(t) {
    var n = t.name, i = t.directives;
    return "..." + n + B(" ", T(i, " "));
  },
  InlineFragment: function(t) {
    var n = t.typeCondition, i = t.directives, o = t.selectionSet;
    return T(["...", B("on ", n), T(i, " "), o], " ");
  },
  FragmentDefinition: function(t) {
    var n = t.name, i = t.typeCondition, o = t.variableDefinitions, r = t.directives, s = t.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(n).concat(B("(", T(o, ", "), ")"), " ") + "on ".concat(i, " ").concat(B("", T(r, " "), " ")) + s
    );
  },
  // Value
  IntValue: function(t) {
    var n = t.value;
    return n;
  },
  FloatValue: function(t) {
    var n = t.value;
    return n;
  },
  StringValue: function(t, n) {
    var i = t.value, o = t.block;
    return o ? vl(i, n === "description" ? "" : "  ") : JSON.stringify(i);
  },
  BooleanValue: function(t) {
    var n = t.value;
    return n ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(t) {
    var n = t.value;
    return n;
  },
  ListValue: function(t) {
    var n = t.values;
    return "[" + T(n, ", ") + "]";
  },
  ObjectValue: function(t) {
    var n = t.fields;
    return "{" + T(n, ", ") + "}";
  },
  ObjectField: function(t) {
    var n = t.name, i = t.value;
    return n + ": " + i;
  },
  // Directive
  Directive: function(t) {
    var n = t.name, i = t.arguments;
    return "@" + n + B("(", T(i, ", "), ")");
  },
  // Type
  NamedType: function(t) {
    var n = t.name;
    return n;
  },
  ListType: function(t) {
    var n = t.type;
    return "[" + n + "]";
  },
  NonNullType: function(t) {
    var n = t.type;
    return n + "!";
  },
  // Type System Definitions
  SchemaDefinition: ie(function(e) {
    var t = e.directives, n = e.operationTypes;
    return T(["schema", T(t, " "), oe(n)], " ");
  }),
  OperationTypeDefinition: function(t) {
    var n = t.operation, i = t.type;
    return n + ": " + i;
  },
  ScalarTypeDefinition: ie(function(e) {
    var t = e.name, n = e.directives;
    return T(["scalar", t, T(n, " ")], " ");
  }),
  ObjectTypeDefinition: ie(function(e) {
    var t = e.name, n = e.interfaces, i = e.directives, o = e.fields;
    return T(["type", t, B("implements ", T(n, " & ")), T(i, " "), oe(o)], " ");
  }),
  FieldDefinition: ie(function(e) {
    var t = e.name, n = e.arguments, i = e.type, o = e.directives;
    return t + (vo(n) ? B(`(
`, Lt(T(n, `
`)), `
)`) : B("(", T(n, ", "), ")")) + ": " + i + B(" ", T(o, " "));
  }),
  InputValueDefinition: ie(function(e) {
    var t = e.name, n = e.type, i = e.defaultValue, o = e.directives;
    return T([t + ": " + n, B("= ", i), T(o, " ")], " ");
  }),
  InterfaceTypeDefinition: ie(function(e) {
    var t = e.name, n = e.interfaces, i = e.directives, o = e.fields;
    return T(["interface", t, B("implements ", T(n, " & ")), T(i, " "), oe(o)], " ");
  }),
  UnionTypeDefinition: ie(function(e) {
    var t = e.name, n = e.directives, i = e.types;
    return T(["union", t, T(n, " "), i && i.length !== 0 ? "= " + T(i, " | ") : ""], " ");
  }),
  EnumTypeDefinition: ie(function(e) {
    var t = e.name, n = e.directives, i = e.values;
    return T(["enum", t, T(n, " "), oe(i)], " ");
  }),
  EnumValueDefinition: ie(function(e) {
    var t = e.name, n = e.directives;
    return T([t, T(n, " ")], " ");
  }),
  InputObjectTypeDefinition: ie(function(e) {
    var t = e.name, n = e.directives, i = e.fields;
    return T(["input", t, T(n, " "), oe(i)], " ");
  }),
  DirectiveDefinition: ie(function(e) {
    var t = e.name, n = e.arguments, i = e.repeatable, o = e.locations;
    return "directive @" + t + (vo(n) ? B(`(
`, Lt(T(n, `
`)), `
)`) : B("(", T(n, ", "), ")")) + (i ? " repeatable" : "") + " on " + T(o, " | ");
  }),
  SchemaExtension: function(t) {
    var n = t.directives, i = t.operationTypes;
    return T(["extend schema", T(n, " "), oe(i)], " ");
  },
  ScalarTypeExtension: function(t) {
    var n = t.name, i = t.directives;
    return T(["extend scalar", n, T(i, " ")], " ");
  },
  ObjectTypeExtension: function(t) {
    var n = t.name, i = t.interfaces, o = t.directives, r = t.fields;
    return T(["extend type", n, B("implements ", T(i, " & ")), T(o, " "), oe(r)], " ");
  },
  InterfaceTypeExtension: function(t) {
    var n = t.name, i = t.interfaces, o = t.directives, r = t.fields;
    return T(["extend interface", n, B("implements ", T(i, " & ")), T(o, " "), oe(r)], " ");
  },
  UnionTypeExtension: function(t) {
    var n = t.name, i = t.directives, o = t.types;
    return T(["extend union", n, T(i, " "), o && o.length !== 0 ? "= " + T(o, " | ") : ""], " ");
  },
  EnumTypeExtension: function(t) {
    var n = t.name, i = t.directives, o = t.values;
    return T(["extend enum", n, T(i, " "), oe(o)], " ");
  },
  InputObjectTypeExtension: function(t) {
    var n = t.name, i = t.directives, o = t.fields;
    return T(["extend input", n, T(i, " "), oe(o)], " ");
  }
};
function ie(e) {
  return function(t) {
    return T([t.description, e(t)], `
`);
  };
}
function T(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function(i) {
    return i;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function oe(e) {
  return B(`{
`, Lt(T(e, `
`)), `
}`);
}
function B(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function Lt(e) {
  return B("  ", e.replace(/\n/g, `
  `));
}
function $l(e) {
  return e.indexOf(`
`) !== -1;
}
function vo(e) {
  return e != null && e.some($l);
}
class gt extends qt {
  constructor(t) {
    super(t), this.constructor = gt, Object.setPrototypeOf(this, gt.prototype);
  }
}
class St extends gt {
  constructor(t = {}) {
    super({
      name: "CanceledError",
      message: "Request is canceled by user",
      ...t
    }), this.constructor = St, Object.setPrototypeOf(this, St.prototype);
  }
}
const ql = (e) => !!e && e instanceof St;
var kn;
(function(e) {
  e.InvalidApiName = "InvalidApiName";
})(kn || (kn = {}));
kn.InvalidApiName + "";
const Ur = async (e) => {
  var n;
  if (!e)
    return;
  const t = await Ye(Vl(e));
  if (t) {
    const i = await ((n = e.body) == null ? void 0 : n.text());
    return jl(t, {
      statusCode: e.statusCode,
      headers: e.headers,
      body: i
    });
  }
}, Vl = (e) => {
  let t;
  const n = new Proxy(e.body, {
    get(o, r, s) {
      return r === "json" ? async () => {
        t || (t = o.text());
        try {
          return JSON.parse(await t);
        } catch {
          return {};
        }
      } : r === "text" ? async () => (t || (t = o.text()), t) : Reflect.get(o, r, s);
    }
  });
  return new Proxy(e, {
    get(o, r, s) {
      return r === "body" ? n : Reflect.get(o, r, s);
    }
  });
}, jl = (e, t) => {
  const n = new gt({
    name: e == null ? void 0 : e.name,
    message: e.message,
    underlyingError: e,
    response: t
  });
  return Object.assign(n, { $metadata: e.$metadata });
}, Pn = new W("RestApis");
function Hl(e, t) {
  const n = (c) => !!t, i = new AbortController(), o = i.signal, r = t == null ? void 0 : t.signal;
  let s;
  const a = async () => {
    try {
      const c = await (n(e) ? e() : e(o));
      if (c.statusCode >= 300)
        throw await Ur(c);
      return c;
    } catch (c) {
      const u = r ?? o, d = s ?? u.reason;
      if (c.name === "AbortError" || (u == null ? void 0 : u.aborted) === !0) {
        const l = new St({
          ...d && { message: d },
          underlyingError: c,
          recoverySuggestion: "The API request was explicitly canceled. If this is not intended, validate if you called the `cancel()` function on the API request erroneously."
        });
        throw Pn.debug(c), l;
      }
      throw Pn.debug(c), c;
    }
  };
  if (n())
    return a();
  {
    const c = (u) => {
      o.aborted !== !0 && (i.abort(u), u && o.reason !== u && (s = u));
    };
    return { response: a(), cancel: c };
  }
}
const wo = "execute-api", Wl = "us-east-1", Gl = /^.+\.([a-z0-9-]+)\.([a-z0-9-]+)\.amazonaws\.com/, zl = (e, t) => {
  var a, c, u;
  const { service: n = wo, region: i = Wl } = ((u = (c = (a = t == null ? void 0 : t.amplify.getConfig()) == null ? void 0 : a.API) == null ? void 0 : c.REST) == null ? void 0 : u[t == null ? void 0 : t.apiName]) ?? {}, { hostname: o } = e, [, r, s] = Gl.exec(o) ?? [];
  return r === wo ? {
    service: r,
    region: s ?? i
  } : r === "appsync-api" ? {
    service: "appsync",
    region: s ?? i
  } : {
    service: n,
    region: i
  };
}, Ql = (e, t) => {
  const n = {};
  for (const i in e)
    n[i.toLowerCase()] = e[i];
  return t && (n["content-type"] = "application/json; charset=UTF-8", t instanceof FormData && delete n["content-type"]), n;
}, Yl = async (e, t, n) => {
  const { url: i, method: o, headers: r, body: s, withCredentials: a, abortSignal: c } = t, u = s ? s instanceof FormData ? s : JSON.stringify(s ?? "") : void 0, d = Ql(r, s), l = {
    url: i,
    headers: d,
    method: o,
    body: u
  }, h = {
    retryDecider: Vn(Ur),
    computeDelay: qn,
    withCrossDomainCredentials: a,
    abortSignal: c
  }, f = Jl(l, n);
  let p;
  const m = await Xl(e);
  if (f && m) {
    const g = zl(i), E = (n == null ? void 0 : n.service) ?? g.service, S = (n == null ? void 0 : n.region) ?? g.region;
    p = await uc(l, {
      ...h,
      credentials: m,
      region: S,
      service: E
    });
  } else
    p = await $n(l, {
      ...h
    });
  return {
    statusCode: p.statusCode,
    headers: p.headers,
    body: p.body
  };
}, Jl = ({ headers: e }, t) => !e.authorization && !e["x-api-key"] && !!t, Xl = async (e) => {
  try {
    const { credentials: t } = await e.Auth.fetchAuthSession();
    if (t)
      return t;
  } catch {
    Pn.debug("No credentials available, the request will be unsigned.");
  }
  return null;
}, oi = /* @__PURE__ */ new WeakMap(), Zl = (e, { url: t, options: n, abortController: i }) => {
  const o = i ?? new AbortController(), s = Hl(async () => Yl(e, {
    url: t,
    method: "POST",
    ...n,
    abortSignal: o.signal
  }, n == null ? void 0 : n.signingServiceInfo), o).finally(() => {
    oi.delete(s);
  });
  return s;
}, eh = (e, t) => {
  const n = oi.get(e);
  return n ? (n.abort(t), t && n.signal.reason !== t && (n.signal.reason = t), !0) : !1;
}, th = (e, t) => {
  oi.set(e, t);
};
var re;
(function(e) {
  e.CONNECTION_CLOSED = "Connection closed", e.CONNECTION_FAILED = "Connection failed", e.REALTIME_SUBSCRIPTION_INIT_ERROR = "AppSync Realtime subscription init error", e.SUBSCRIPTION_ACK = "Subscription ack", e.TIMEOUT_DISCONNECT = "Timeout disconnect";
})(re || (re = {}));
var H;
(function(e) {
  e.Connected = "Connected", e.ConnectedPendingNetwork = "ConnectedPendingNetwork", e.ConnectionDisrupted = "ConnectionDisrupted", e.ConnectionDisruptedPendingNetwork = "ConnectionDisruptedPendingNetwork", e.Connecting = "Connecting", e.ConnectedPendingDisconnect = "ConnectedPendingDisconnect", e.Disconnected = "Disconnected", e.ConnectedPendingKeepAlive = "ConnectedPendingKeepAlive";
})(H || (H = {}));
const nh = 5e3, ih = [400, 401, 403], oh = "ConnectionStateChange";
var se;
(function(e) {
  e.GQL_CONNECTION_INIT = "connection_init", e.GQL_CONNECTION_ERROR = "connection_error", e.GQL_CONNECTION_ACK = "connection_ack", e.GQL_START = "start", e.GQL_START_ACK = "start_ack", e.GQL_DATA = "data", e.GQL_CONNECTION_KEEP_ALIVE = "ka", e.GQL_STOP = "stop", e.GQL_COMPLETE = "complete", e.GQL_ERROR = "error";
})(se || (se = {}));
var ve;
(function(e) {
  e[e.PENDING = 0] = "PENDING", e[e.CONNECTED = 1] = "CONNECTED", e[e.FAILED = 2] = "FAILED";
})(ve || (ve = {}));
var Z;
(function(e) {
  e[e.CLOSED = 0] = "CLOSED", e[e.READY = 1] = "READY", e[e.CONNECTING = 2] = "CONNECTING";
})(Z || (Z = {}));
const rh = {
  accept: "application/json, text/javascript",
  "content-encoding": "amz-1.0",
  "content-type": "application/json; charset=UTF-8"
}, Ao = 15e3, sh = 15e3, No = 5 * 60 * 1e3, ah = 65 * 1e3, ch = 5 * 1e3, uh = 60 * 1e3, Co = () => new qe().networkMonitor(), G = {
  KEEP_ALIVE_MISSED: { keepAliveState: "unhealthy" },
  KEEP_ALIVE: { keepAliveState: "healthy" },
  CONNECTION_ESTABLISHED: { connectionState: "connected" },
  CONNECTION_FAILED: {
    intendedConnectionState: "disconnected",
    connectionState: "disconnected"
  },
  CLOSING_CONNECTION: { intendedConnectionState: "disconnected" },
  OPENING_CONNECTION: {
    intendedConnectionState: "connected",
    connectionState: "connecting"
  },
  CLOSED: { connectionState: "disconnected" },
  ONLINE: { networkState: "connected" },
  OFFLINE: { networkState: "disconnected" }
};
class dh {
  constructor() {
    this._networkMonitoringSubscription = void 0, this._linkedConnectionState = {
      networkState: "connected",
      connectionState: "disconnected",
      intendedConnectionState: "disconnected",
      keepAliveState: "healthy"
    }, this._initialNetworkStateSubscription = Co().subscribe(({ online: t }) => {
      var n;
      this.record(t ? G.ONLINE : G.OFFLINE), (n = this._initialNetworkStateSubscription) == null || n.unsubscribe();
    }), this._linkedConnectionStateObservable = new pt((t) => {
      t.next(this._linkedConnectionState), this._linkedConnectionStateObserver = t;
    });
  }
  /**
   * Turn network state monitoring on if it isn't on already
   */
  enableNetworkMonitoring() {
    var t;
    (t = this._initialNetworkStateSubscription) == null || t.unsubscribe(), this._networkMonitoringSubscription === void 0 && (this._networkMonitoringSubscription = Co().subscribe(({ online: n }) => {
      this.record(n ? G.ONLINE : G.OFFLINE);
    }));
  }
  /**
   * Turn network state monitoring off if it isn't off already
   */
  disableNetworkMonitoring() {
    var t;
    (t = this._networkMonitoringSubscription) == null || t.unsubscribe(), this._networkMonitoringSubscription = void 0;
  }
  /**
   * Get the observable that allows us to monitor the connection state
   *
   * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
   */
  get connectionStateObservable() {
    let t;
    return this._linkedConnectionStateObservable.pipe(Ln((n) => this.connectionStatesTranslator(n))).pipe(rs((n) => {
      const i = n !== t;
      return t = n, i;
    }));
  }
  /*
   * Updates local connection state and emits the full state to the observer.
   */
  record(t) {
    var i;
    t.intendedConnectionState === "connected" ? this.enableNetworkMonitoring() : t.intendedConnectionState === "disconnected" && this.disableNetworkMonitoring();
    const n = {
      ...this._linkedConnectionState,
      ...t
    };
    this._linkedConnectionState = { ...n }, (i = this._linkedConnectionStateObserver) == null || i.next(this._linkedConnectionState);
  }
  /*
   * Translate the ConnectionState structure into a specific ConnectionState string literal union
   */
  connectionStatesTranslator({ connectionState: t, networkState: n, intendedConnectionState: i, keepAliveState: o }) {
    return t === "connected" && n === "disconnected" ? H.ConnectedPendingNetwork : t === "connected" && i === "disconnected" ? H.ConnectedPendingDisconnect : t === "disconnected" && i === "connected" && n === "disconnected" ? H.ConnectionDisruptedPendingNetwork : t === "disconnected" && i === "connected" ? H.ConnectionDisrupted : t === "connected" && o === "unhealthy" ? H.ConnectedPendingKeepAlive : t === "connecting" ? H.Connecting : t === "disconnected" ? H.Disconnected : H.Connected;
  }
}
var Ge;
(function(e) {
  e.START_RECONNECT = "START_RECONNECT", e.HALT_RECONNECT = "HALT_RECONNECT";
})(Ge || (Ge = {}));
class lh {
  constructor() {
    this.reconnectObservers = [];
  }
  /**
   * Add reconnect observer to the list of observers to alert on reconnect
   */
  addObserver(t) {
    this.reconnectObservers.push(t);
  }
  /**
   * Given a reconnect event, start the appropriate behavior
   */
  record(t) {
    t === Ge.START_RECONNECT && this.reconnectSetTimeoutId === void 0 && this.reconnectIntervalId === void 0 && (this.reconnectSetTimeoutId = setTimeout(() => {
      this._triggerReconnect(), this.reconnectIntervalId = setInterval(() => {
        this._triggerReconnect();
      }, uh);
    }, ch)), t === Ge.HALT_RECONNECT && (this.reconnectIntervalId && (clearInterval(this.reconnectIntervalId), this.reconnectIntervalId = void 0), this.reconnectSetTimeoutId && (clearTimeout(this.reconnectSetTimeoutId), this.reconnectSetTimeoutId = void 0));
  }
  /**
   * Complete all reconnect observers
   */
  close() {
    this.reconnectObservers.forEach((t) => {
      var n;
      (n = t.complete) == null || n.call(t);
    });
  }
  _triggerReconnect() {
    this.reconnectObservers.forEach((t) => {
      var n;
      (n = t.next) == null || n.call(t);
    });
  }
}
const F = new W("AWSAppSyncRealTimeProvider"), Ro = (e) => {
  ce.dispatch("api", e, "PubSub", ae);
}, hh = /^https:\/\/\w{26}\.appsync-api\.\w{2}(?:(?:-\w{2,})+)-\d\.amazonaws.com(?:\.cn)?\/graphql$/i, ph = "/realtime";
class fh {
  constructor() {
    this.socketStatus = Z.CLOSED, this.keepAliveTimeout = No, this.subscriptionObserverMap = /* @__PURE__ */ new Map(), this.promiseArray = [], this.connectionStateMonitor = new dh(), this.reconnectionMonitor = new lh(), this.connectionStateMonitorSubscription = this.connectionStateMonitor.connectionStateObservable.subscribe((t) => {
      Ro({
        event: oh,
        data: {
          provider: this,
          connectionState: t
        },
        message: `Connection state is ${t}`
      }), this.connectionState = t, t === H.ConnectionDisrupted && this.reconnectionMonitor.record(Ge.START_RECONNECT), [
        H.Connected,
        H.ConnectedPendingDisconnect,
        H.ConnectedPendingKeepAlive,
        H.ConnectedPendingNetwork,
        H.ConnectionDisruptedPendingNetwork,
        H.Disconnected
      ].includes(t) && this.reconnectionMonitor.record(Ge.HALT_RECONNECT);
    });
  }
  /**
   * Mark the socket closed and release all active listeners
   */
  close() {
    this.socketStatus = Z.CLOSED, this.connectionStateMonitor.record(G.CONNECTION_FAILED), this.connectionStateMonitorSubscription.unsubscribe(), this.reconnectionMonitor.close();
  }
  getNewWebSocket(t, n) {
    return new WebSocket(t, n);
  }
  getProviderName() {
    return "AWSAppSyncRealTimeProvider";
  }
  // Check if url matches standard domain pattern
  isCustomDomain(t) {
    return t.match(hh) === null;
  }
  subscribe(t, n) {
    const { appSyncGraphqlEndpoint: i, region: o, query: r, variables: s, authenticationType: a, additionalHeaders: c, apiKey: u, authToken: d, libraryConfigHeaders: l } = t || {};
    return new pt((h) => {
      if (!t || !i)
        h.error({
          errors: [
            {
              ...new ht("Subscribe only available for AWS AppSync endpoint")
            }
          ]
        }), h.complete();
      else {
        let f = !1;
        const p = Pa(), m = () => {
          f || (f = !0, this._startSubscriptionWithAWSAppSyncRealTime({
            options: {
              query: r,
              variables: s,
              region: o,
              authenticationType: a,
              appSyncGraphqlEndpoint: i,
              additionalHeaders: c,
              apiKey: u,
              authToken: d,
              libraryConfigHeaders: l
            },
            observer: h,
            subscriptionId: p,
            customUserAgentDetails: n
          }).catch((S) => {
            F.debug(`${re.REALTIME_SUBSCRIPTION_INIT_ERROR}: ${S}`), this.connectionStateMonitor.record(G.CLOSED);
          }).finally(() => {
            f = !1;
          }));
        }, g = new pt((E) => {
          this.reconnectionMonitor.addObserver(E);
        }).subscribe(() => {
          m();
        });
        return m(), async () => {
          g == null || g.unsubscribe();
          try {
            await this._waitForSubscriptionToBeConnected(p);
            const { subscriptionState: E } = this.subscriptionObserverMap.get(p) || {};
            if (!E)
              return;
            if (E === ve.CONNECTED)
              this._sendUnsubscriptionMessage(p);
            else
              throw new Error("Subscription never connected");
          } catch (E) {
            F.debug(`Error while unsubscribing ${E}`);
          } finally {
            this._removeSubscriptionObserver(p);
          }
        };
      }
    });
  }
  async _startSubscriptionWithAWSAppSyncRealTime({ options: t, observer: n, subscriptionId: i, customUserAgentDetails: o }) {
    const { appSyncGraphqlEndpoint: r, authenticationType: s, query: a, variables: c, apiKey: u, region: d, libraryConfigHeaders: l = () => ({}), additionalHeaders: h = {}, authToken: f } = t;
    let p = {};
    typeof h == "function" ? p = await h({
      url: r || "",
      queryString: a || ""
    }) : p = h, f && (p = {
      ...p,
      Authorization: f
    });
    const m = ve.PENDING, g = {
      query: a,
      variables: c
    };
    this.subscriptionObserverMap.set(i, {
      observer: n,
      query: a ?? "",
      variables: c ?? {},
      subscriptionState: m,
      startAckTimeoutId: void 0
    });
    const E = JSON.stringify(g), S = {
      ...await this._awsRealTimeHeaderBasedAuth({
        apiKey: u,
        appSyncGraphqlEndpoint: r,
        authenticationType: s,
        payload: E,
        canonicalUri: "",
        region: d,
        additionalCustomHeaders: p
      }),
      ...await l(),
      ...p,
      [Fo]: Je(o)
    }, v = {
      id: i,
      payload: {
        data: E,
        extensions: {
          authorization: {
            ...S
          }
        }
      },
      type: se.GQL_START
    }, N = JSON.stringify(v);
    try {
      this.connectionStateMonitor.record(G.OPENING_CONNECTION), await this._initializeWebSocketConnection({
        apiKey: u,
        appSyncGraphqlEndpoint: r,
        authenticationType: s,
        region: d,
        additionalCustomHeaders: p
      });
    } catch (_) {
      this._logStartSubscriptionError(i, n, _);
      return;
    }
    const { subscriptionFailedCallback: A, subscriptionReadyCallback: w } = this.subscriptionObserverMap.get(i) ?? {};
    this.subscriptionObserverMap.set(i, {
      observer: n,
      subscriptionState: m,
      query: a ?? "",
      variables: c ?? {},
      subscriptionReadyCallback: w,
      subscriptionFailedCallback: A,
      startAckTimeoutId: setTimeout(() => {
        this._timeoutStartSubscriptionAck(i);
      }, sh)
    }), this.awsRealTimeSocket && this.awsRealTimeSocket.send(N);
  }
  // Log logic for start subscription failures
  _logStartSubscriptionError(t, n, i) {
    F.debug({ err: i });
    const o = String(i.message ?? "");
    if (this.connectionStateMonitor.record(G.CLOSED), this.connectionState !== H.ConnectionDisruptedPendingNetwork) {
      Bo(i) ? n.error({
        errors: [
          {
            ...new ht(`${re.CONNECTION_FAILED}: ${o}`)
          }
        ]
      }) : F.debug(`${re.CONNECTION_FAILED}: ${o}`);
      const { subscriptionFailedCallback: r } = this.subscriptionObserverMap.get(t) || {};
      typeof r == "function" && r();
    }
  }
  // Waiting that subscription has been connected before trying to unsubscribe
  async _waitForSubscriptionToBeConnected(t) {
    const n = this.subscriptionObserverMap.get(t);
    if (n) {
      const { subscriptionState: i } = n;
      if (i === ve.PENDING)
        return new Promise((o, r) => {
          const { observer: s, subscriptionState: a, variables: c, query: u } = n;
          this.subscriptionObserverMap.set(t, {
            observer: s,
            subscriptionState: a,
            variables: c,
            query: u,
            subscriptionReadyCallback: o,
            subscriptionFailedCallback: r
          });
        });
    }
  }
  _sendUnsubscriptionMessage(t) {
    try {
      if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === Z.READY) {
        const n = {
          id: t,
          type: se.GQL_STOP
        }, i = JSON.stringify(n);
        this.awsRealTimeSocket.send(i);
      }
    } catch (n) {
      F.debug({ err: n });
    }
  }
  _removeSubscriptionObserver(t) {
    this.subscriptionObserverMap.delete(t), setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
  }
  _closeSocketIfRequired() {
    if (!(this.subscriptionObserverMap.size > 0)) {
      if (!this.awsRealTimeSocket) {
        this.socketStatus = Z.CLOSED;
        return;
      }
      if (this.connectionStateMonitor.record(G.CLOSING_CONNECTION), this.awsRealTimeSocket.bufferedAmount > 0)
        setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
      else {
        F.debug("closing WebSocket..."), this.keepAliveTimeoutId && clearTimeout(this.keepAliveTimeoutId), this.keepAliveAlertTimeoutId && clearTimeout(this.keepAliveAlertTimeoutId);
        const t = this.awsRealTimeSocket;
        t.onclose = null, t.onerror = null, t.close(1e3), this.awsRealTimeSocket = void 0, this.socketStatus = Z.CLOSED, this.connectionStateMonitor.record(G.CLOSED);
      }
    }
  }
  _handleIncomingSubscriptionMessage(t) {
    if (typeof t.data != "string")
      return;
    F.debug(`subscription message from AWS AppSync RealTime: ${t.data}`);
    const { id: n = "", payload: i, type: o } = JSON.parse(String(t.data)), { observer: r = null, query: s = "", variables: a = {}, startAckTimeoutId: c, subscriptionReadyCallback: u, subscriptionFailedCallback: d } = this.subscriptionObserverMap.get(n) || {};
    if (F.debug({ id: n, observer: r, query: s, variables: a }), o === se.GQL_DATA && i && i.data) {
      r ? r.next(i) : F.debug(`observer not found for id: ${n}`);
      return;
    }
    if (o === se.GQL_START_ACK) {
      F.debug(`subscription ready for ${JSON.stringify({ query: s, variables: a })}`), typeof u == "function" && u(), c && clearTimeout(c), Ro({
        event: re.SUBSCRIPTION_ACK,
        data: { query: s, variables: a },
        message: "Connection established for subscription"
      });
      const l = ve.CONNECTED;
      r && this.subscriptionObserverMap.set(n, {
        observer: r,
        query: s,
        variables: a,
        startAckTimeoutId: void 0,
        subscriptionState: l,
        subscriptionReadyCallback: u,
        subscriptionFailedCallback: d
      }), this.connectionStateMonitor.record(G.CONNECTION_ESTABLISHED);
      return;
    }
    if (o === se.GQL_CONNECTION_KEEP_ALIVE) {
      this.keepAliveTimeoutId && clearTimeout(this.keepAliveTimeoutId), this.keepAliveAlertTimeoutId && clearTimeout(this.keepAliveAlertTimeoutId), this.keepAliveTimeoutId = setTimeout(() => {
        this._errorDisconnect(re.TIMEOUT_DISCONNECT);
      }, this.keepAliveTimeout), this.keepAliveAlertTimeoutId = setTimeout(() => {
        this.connectionStateMonitor.record(G.KEEP_ALIVE_MISSED);
      }, ah), this.connectionStateMonitor.record(G.KEEP_ALIVE);
      return;
    }
    if (o === se.GQL_ERROR) {
      const l = ve.FAILED;
      r && (this.subscriptionObserverMap.set(n, {
        observer: r,
        query: s,
        variables: a,
        startAckTimeoutId: c,
        subscriptionReadyCallback: u,
        subscriptionFailedCallback: d,
        subscriptionState: l
      }), F.debug(`${re.CONNECTION_FAILED}: ${JSON.stringify(i)}`), r.error({
        errors: [
          {
            ...new ht(`${re.CONNECTION_FAILED}: ${JSON.stringify(i)}`)
          }
        ]
      }), c && clearTimeout(c), typeof d == "function" && d());
    }
  }
  _errorDisconnect(t) {
    F.debug(`Disconnect error: ${t}`), this.awsRealTimeSocket && (this.connectionStateMonitor.record(G.CLOSED), this.awsRealTimeSocket.close()), this.socketStatus = Z.CLOSED;
  }
  _timeoutStartSubscriptionAck(t) {
    const n = this.subscriptionObserverMap.get(t);
    if (n) {
      const { observer: i, query: o, variables: r } = n;
      if (!i)
        return;
      this.subscriptionObserverMap.set(t, {
        observer: i,
        query: o,
        variables: r,
        subscriptionState: ve.FAILED
      }), this.connectionStateMonitor.record(G.CLOSED), F.debug("timeoutStartSubscription", JSON.stringify({ query: o, variables: r }));
    }
  }
  _initializeWebSocketConnection({ appSyncGraphqlEndpoint: t, authenticationType: n, apiKey: i, region: o, additionalCustomHeaders: r }) {
    if (this.socketStatus !== Z.READY)
      return new Promise(async (s, a) => {
        if (this.promiseArray.push({ res: s, rej: a }), this.socketStatus === Z.CLOSED)
          try {
            this.socketStatus = Z.CONNECTING;
            const c = "{}", u = await this._awsRealTimeHeaderBasedAuth({
              authenticationType: n,
              payload: c,
              canonicalUri: "/connect",
              apiKey: i,
              appSyncGraphqlEndpoint: t,
              region: o,
              additionalCustomHeaders: r
            }), d = u ? JSON.stringify(u) : "", l = be.convert(d), h = be.convert(c);
            let f = t ?? "";
            this.isCustomDomain(f) ? f = f.concat(ph) : f = f.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
            const p = "wss://";
            f = f.replace("https://", p).replace("http://", p);
            const m = `${f}?header=${l}&payload=${h}`;
            await this._initializeRetryableHandshake(m), this.promiseArray.forEach(({ res: g }) => {
              F.debug("Notifying connection successful"), g();
            }), this.socketStatus = Z.READY, this.promiseArray = [];
          } catch (c) {
            F.debug("Connection exited with", c), this.promiseArray.forEach(({ rej: u }) => {
              u(c);
            }), this.promiseArray = [], this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.awsRealTimeSocket.close(3001), this.awsRealTimeSocket = void 0, this.socketStatus = Z.CLOSED;
          }
      });
  }
  async _initializeRetryableHandshake(t) {
    F.debug("Initializaling retryable Handshake"), await hc(this._initializeHandshake.bind(this), [t], nh);
  }
  async _initializeHandshake(t) {
    F.debug(`Initializing handshake ${t}`);
    try {
      await (() => new Promise((n, i) => {
        const o = this.getNewWebSocket(t, "graphql-ws");
        o.onerror = () => {
          F.debug("WebSocket connection error");
        }, o.onclose = () => {
          i(new Error("Connection handshake error"));
        }, o.onopen = () => {
          this.awsRealTimeSocket = o, n();
        };
      }))(), await (() => new Promise((n, i) => {
        if (this.awsRealTimeSocket) {
          let o = !1;
          this.awsRealTimeSocket.onerror = (a) => {
            F.debug(`WebSocket error ${JSON.stringify(a)}`);
          }, this.awsRealTimeSocket.onclose = (a) => {
            F.debug(`WebSocket closed ${a.reason}`), i(new Error(JSON.stringify(a)));
          }, this.awsRealTimeSocket.onmessage = (a) => {
            if (typeof a.data != "string")
              return;
            F.debug(`subscription message from AWS AppSyncRealTime: ${a.data} `);
            const c = JSON.parse(a.data), { type: u, payload: { connectionTimeoutMs: d = No } = {} } = c;
            if (u === se.GQL_CONNECTION_ACK) {
              o = !0, this.awsRealTimeSocket && (this.keepAliveTimeout = d, this.awsRealTimeSocket.onmessage = this._handleIncomingSubscriptionMessage.bind(this), this.awsRealTimeSocket.onerror = (l) => {
                F.debug(l), this._errorDisconnect(re.CONNECTION_CLOSED);
              }, this.awsRealTimeSocket.onclose = (l) => {
                F.debug(`WebSocket closed ${l.reason}`), this._errorDisconnect(re.CONNECTION_CLOSED);
              }), n("Cool, connected to AWS AppSyncRealTime");
              return;
            }
            if (u === se.GQL_CONNECTION_ERROR) {
              const { payload: { errors: [{ errorType: l = "", errorCode: h = 0 } = {}] = [] } = {} } = c;
              i({ errorType: l, errorCode: h });
            }
          };
          const r = {
            type: se.GQL_CONNECTION_INIT
          };
          this.awsRealTimeSocket.send(JSON.stringify(r));
          const s = (a) => {
            a || (this.connectionStateMonitor.record(G.CONNECTION_FAILED), i(new Error(`Connection timeout: ack from AWSAppSyncRealTime was not received after ${Ao} ms`)));
          };
          setTimeout(() => {
            s(o);
          }, Ao);
        }
      }))();
    } catch (n) {
      const { errorType: i, errorCode: o } = n;
      throw ih.includes(o) ? new lc(i) : i ? new Error(i) : n;
    }
  }
  async _awsRealTimeHeaderBasedAuth({ apiKey: t, authenticationType: n, payload: i, canonicalUri: o, appSyncGraphqlEndpoint: r, region: s, additionalCustomHeaders: a }) {
    const c = {
      apiKey: this._awsRealTimeApiKeyHeader.bind(this),
      iam: this._awsRealTimeIAMHeader.bind(this),
      oidc: this._awsAuthTokenHeader.bind(this),
      userPool: this._awsAuthTokenHeader.bind(this),
      lambda: this._customAuthHeader,
      none: this._customAuthHeader
    };
    if (!n || !c[n]) {
      F.debug(`Authentication type ${n} not supported`);
      return;
    } else {
      const u = c[n], d = r ? new de(r).host : void 0;
      F.debug(`Authenticating with ${JSON.stringify(n)}`);
      let l;
      return n === "apiKey" && (l = t), await u({
        payload: i,
        canonicalUri: o,
        appSyncGraphqlEndpoint: r,
        apiKey: l,
        region: s,
        host: d,
        additionalCustomHeaders: a
      });
    }
  }
  async _awsAuthTokenHeader({ host: t }) {
    var i, o;
    const n = await xi();
    return {
      Authorization: (o = (i = n == null ? void 0 : n.tokens) == null ? void 0 : i.accessToken) == null ? void 0 : o.toString(),
      host: t
    };
  }
  async _awsRealTimeApiKeyHeader({ apiKey: t, host: n }) {
    const o = (/* @__PURE__ */ new Date()).toISOString().replace(/[:-]|\.\d{3}/g, "");
    return {
      host: n,
      "x-amz-date": o,
      "x-api-key": t
    };
  }
  async _awsRealTimeIAMHeader({ payload: t, canonicalUri: n, appSyncGraphqlEndpoint: i, region: o }) {
    const r = {
      region: o,
      service: "appsync"
    }, s = (await xi()).credentials, a = {
      url: `${i}${n}`,
      data: t,
      method: "POST",
      headers: { ...rh }
    };
    return cr({
      headers: a.headers,
      method: a.method,
      url: new de(a.url),
      body: a.data
    }, {
      // TODO: What do we need to do to remove these !'s?
      credentials: s,
      signingRegion: r.region,
      signingService: r.service
    }).headers;
  }
  _customAuthHeader({ host: t, additionalCustomHeaders: n }) {
    if (!(n != null && n.Authorization))
      throw new Error("No auth token specified");
    return {
      Authorization: n.Authorization,
      host: t
    };
  }
}
class fe extends Y {
  constructor(t) {
    super(t), this.constructor = fe, Object.setPrototypeOf(this, fe.prototype);
  }
}
var Ve;
(function(e) {
  e.NoAuthSession = "NoAuthSession", e.NoRegion = "NoRegion", e.NoCustomEndpoint = "NoCustomEndpoint";
})(Ve || (Ve = {}));
const mh = {
  [Ve.NoAuthSession]: {
    message: "Auth session should not be empty."
  },
  // TODO: re-enable when working in all test environments:
  // [APIValidationErrorCode.NoEndpoint]: {
  // 	message: 'Missing endpoint',
  // },
  [Ve.NoRegion]: {
    message: "Missing region."
  },
  [Ve.NoCustomEndpoint]: {
    message: "Custom endpoint region is present without custom endpoint."
  }
};
function yh(e, t) {
  const { message: n, recoverySuggestion: i } = mh[t];
  if (!e)
    throw new fe({ name: t, message: n, recoverySuggestion: i });
}
const Eh = new W("GraphQLAPI resolveConfig"), In = (e) => {
  var c, u;
  const t = e.getConfig();
  (c = t.API) != null && c.GraphQL || Eh.warn("The API configuration is missing. This is likely due to Amplify.configure() not being called prior to generateClient().");
  const { apiKey: n, customEndpoint: i, customEndpointRegion: o, defaultAuthMode: r, endpoint: s, region: a } = ((u = t.API) == null ? void 0 : u.GraphQL) ?? {};
  return yh(!(!i && o), Ve.NoCustomEndpoint), {
    apiKey: n,
    customEndpoint: i,
    customEndpointRegion: o,
    defaultAuthMode: r,
    endpoint: s,
    region: a
  };
}, _o = (e) => {
  var i, o, r, s, a, c;
  const t = (r = (o = (i = e.libraryOptions) == null ? void 0 : i.API) == null ? void 0 : o.GraphQL) == null ? void 0 : r.headers, n = (c = (a = (s = e.libraryOptions) == null ? void 0 : s.API) == null ? void 0 : a.GraphQL) == null ? void 0 : c.withCredentials;
  return { headers: t, withCredentials: n };
};
function bo(e) {
  return e.errors && Array.isArray(e.errors) && e.errors.forEach((t) => {
    gh(t) && (t.message = "Unauthorized", t.recoverySuggestion = `If you're calling an Amplify-generated API, make sure to set the "authMode" in generateClient({ authMode: '...' }) to the backend authorization rule's auth provider ('apiKey', 'userPool', 'iam', 'oidc', 'lambda')`);
  }), e;
}
function gh(e) {
  var t, n, i, o;
  return !!((n = (t = e == null ? void 0 : e.originalError) == null ? void 0 : t.name) != null && n.startsWith("UnauthorizedException") || (i = e.message) != null && i.startsWith("Connection failed:") && ((o = e.message) != null && o.includes("Permission denied")));
}
var De;
(function(e) {
  e.NO_API_KEY = "No api-key configured", e.NO_CURRENT_USER = "No current user", e.NO_CREDENTIALS = "No credentials", e.NO_FEDERATED_JWT = "No federated jwt", e.NO_AUTH_TOKEN = "No auth token specified";
})(De || (De = {}));
const Kr = Symbol("amplify"), Br = Symbol("authMode"), $r = Symbol("authToken"), qr = Symbol("headers");
function ri(e) {
  const t = e;
  return {
    amplify: t[Kr],
    authMode: t[Br],
    authToken: t[$r],
    headers: t[qr]
  };
}
const Sh = {
  name: "NoApiKey",
  // ideal: No API key configured.
  message: De.NO_API_KEY,
  recoverySuggestion: 'The API request was made with `authMode: "apiKey"` but no API Key was passed into `Amplify.configure()`. Review if your API key is passed into the `Amplify.configure()` function.'
}, Ih = {
  name: "NoCredentials",
  // ideal: No auth credentials available.
  message: De.NO_CREDENTIALS,
  recoverySuggestion: 'The API request was made with `authMode: "iam"` but no authentication credentials are available.\n\nIf you intended to make a request using an authenticated role, review if your user is signed in before making the request.\n\nIf you intend to make a request using an unauthenticated role or also known as "guest access", verify if "Auth.Cognito.allowGuestAccess" is set to "true" in the `Amplify.configure()` function.'
}, Th = {
  name: "NoValidAuthTokens",
  // ideal: No valid JWT auth token provided to make the API request..
  message: De.NO_FEDERATED_JWT,
  recoverySuggestion: "If you intended to make an authenticated API request, review if the current user is signed in."
}, vh = {
  name: "NoSignedUser",
  // ideal: Couldn't retrieve authentication credentials to make the API request.
  message: De.NO_CURRENT_USER,
  recoverySuggestion: "Review the underlying exception field for more details. If you intended to make an authenticated API request, review if the current user is signed in."
}, wh = {
  name: "NoAuthorizationHeader",
  // ideal: Authorization header not specified.
  message: De.NO_AUTH_TOKEN,
  recoverySuggestion: 'The API request was made with `authMode: "lambda"` but no `authToken` is set. Review if a valid authToken is passed into the request options or in the `Amplify.configure()` function.'
}, Ah = {
  name: "NoEndpoint",
  message: "No GraphQL endpoint configured in `Amplify.configure()`.",
  recoverySuggestion: "Review if the GraphQL API endpoint is set in the `Amplify.configure()` function."
}, xo = (e) => ({
  data: {},
  errors: [new ht(e.message, null, null, null, null, e)]
});
function Nh(e) {
  if (!e)
    return !1;
  const t = e;
  return Array.isArray(t.errors) && t.errors.length > 0;
}
const Ch = "x-amz-user-agent", Rh = (e) => typeof e != "function";
class Vr {
  constructor() {
    this.appSyncRealTime = new fh(), this._api = {
      post: Zl,
      cancelREST: eh,
      isCancelErrorREST: ql,
      updateRequestToBeCancellable: th
    };
  }
  getModuleName() {
    return "InternalGraphQLAPI";
  }
  async _headerBasedAuth(t, n, i = {}) {
    var s;
    const { apiKey: o } = In(t);
    let r = {};
    switch (n) {
      case "apiKey":
        if (!o)
          throw new fe(Sh);
        r = {
          "X-Api-Key": o
        };
        break;
      case "iam": {
        if ((await t.Auth.fetchAuthSession()).credentials === void 0)
          throw new fe(Ih);
        break;
      }
      case "oidc":
      case "userPool": {
        let a;
        try {
          a = (s = (await t.Auth.fetchAuthSession()).tokens) == null ? void 0 : s.accessToken.toString();
        } catch (c) {
          throw new fe({
            ...vh,
            underlyingError: c
          });
        }
        if (!a)
          throw new fe(Th);
        r = {
          Authorization: a
        };
        break;
      }
      case "lambda":
        if (typeof i == "object" && !i.Authorization)
          throw new fe(wh);
        r = {
          Authorization: i.Authorization
        };
        break;
    }
    return r;
  }
  /**
   * to get the operation type
   * @param operation
   */
  getGraphqlOperationType(t) {
    const i = gn(t).definitions, [{ operation: o }] = i;
    return o;
  }
  /**
   * Executes a GraphQL operation
   *
   * @param options - GraphQL Options
   * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
   * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
   */
  graphql(t, { query: n, variables: i = {}, authMode: o, authToken: r }, s, a) {
    const c = gn(typeof n == "string" ? n : at(n)), [u = {}] = c.definitions.filter((h) => h.kind === "OperationDefinition"), { operation: d } = u, l = s || {};
    switch (d) {
      case "query":
      case "mutation": {
        const h = new AbortController();
        let f;
        return Rh(t) ? f = this._graphql(t, { query: c, variables: i, authMode: o }, l, h, a, r) : f = t(async (m) => await this._graphql(m, { query: c, variables: i, authMode: o }, l, h, a, r)), this._api.updateRequestToBeCancellable(f, h), f;
      }
      case "subscription":
        return this._graphqlSubscribe(t, { query: c, variables: i, authMode: o }, l, a, r);
      default:
        throw new Error(`invalid operation type: ${d}`);
    }
  }
  async _graphql(t, { query: n, variables: i, authMode: o }, r = {}, s, a, c) {
    const { region: u, endpoint: d, customEndpoint: l, customEndpointRegion: h, defaultAuthMode: f } = In(t), p = o || f || "iam", m = p === "identityPool" ? "iam" : p, { headers: g, withCredentials: E } = _o(t);
    let S;
    if (typeof r == "function") {
      const D = {
        method: "POST",
        url: new de(l || d || "").toString(),
        queryString: at(n)
      };
      S = await r(D);
    } else
      S = r;
    c && (S = {
      ...S,
      Authorization: c
    });
    const v = {
      ...!l && await this._headerBasedAuth(t, m, S),
      /**
       * Custom endpoint headers.
       * If there is both a custom endpoint and custom region present, we get the headers.
       * If there is a custom endpoint but no region, we return an empty object.
       * If neither are present, we return an empty object.
       */
      ...l && (h ? await this._headerBasedAuth(t, m, S) : {}) || {},
      // Custom headers included in Amplify configuration options:
      ...g && await g({
        query: at(n),
        variables: i
      }),
      // Custom headers from individual requests or API client configuration:
      ...S,
      // User agent headers:
      ...!l && {
        [Ch]: Je(a)
      }
    }, N = {
      query: at(n),
      variables: i || null
    };
    let A;
    l && !h || m !== "oidc" && m !== "userPool" && m !== "iam" && m !== "lambda" ? A = void 0 : A = {
      service: h ? "execute-api" : "appsync",
      region: h || u
    };
    const w = l || d;
    if (!w)
      throw xo(new fe(Ah));
    let _;
    try {
      const { body: D } = await this._api.post(t, {
        url: new de(w),
        options: {
          headers: v,
          body: N,
          signingServiceInfo: A,
          withCredentials: E
        },
        abortController: s
      });
      _ = await D.json();
    } catch (D) {
      if (this.isCancelError(D))
        throw D;
      _ = xo(D);
    }
    if (Nh(_))
      throw bo(_);
    return _;
  }
  /**
   * Checks to see if an error thrown is from an api request cancellation
   * @param {any} error - Any error
   * @return {boolean} - A boolean indicating if the error was from an api request cancellation
   */
  isCancelError(t) {
    return this._api.isCancelErrorREST(t);
  }
  /**
   * Cancels an inflight request. Only applicable for graphql queries and mutations
   * @param {any} request - request to cancel
   * @returns - A boolean indicating if the request was cancelled
   */
  cancel(t, n) {
    return this._api.cancelREST(t, n);
  }
  _graphqlSubscribe(t, { query: n, variables: i, authMode: o }, r = {}, s, a) {
    const c = In(t), u = o || (c == null ? void 0 : c.defaultAuthMode) || "iam", d = u === "identityPool" ? "iam" : u, { headers: l } = _o(t);
    return this.appSyncRealTime.subscribe({
      query: at(n),
      variables: i,
      appSyncGraphqlEndpoint: c == null ? void 0 : c.endpoint,
      region: c == null ? void 0 : c.region,
      authenticationType: d,
      apiKey: c == null ? void 0 : c.apiKey,
      additionalHeaders: r,
      authToken: a,
      libraryConfigHeaders: l
    }, s).pipe(ss((h) => {
      throw h.errors ? bo(h) : h;
    }));
  }
}
new Vr();
class _h extends Vr {
  getModuleName() {
    return "GraphQLAPI";
  }
  /**
   * Executes a GraphQL operation
   *
   * @param options - GraphQL Options
   * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
   * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
   */
  graphql(t, n, i) {
    return super.graphql(t, n, i, {
      category: Bt.API,
      action: Tn.GraphQl
    });
  }
  /**
   * Checks to see if an error thrown is from an api request cancellation
   * @param error - Any error
   * @returns A boolean indicating if the error was from an api request cancellation
   */
  isCancelError(t) {
    return super.isCancelError(t);
  }
  /**
   * Cancels an inflight request. Only applicable for graphql queries and mutations
   * @param {any} request - request to cancel
   * @returns A boolean indicating if the request was cancelled
   */
  cancel(t, n) {
    return super.cancel(t, n);
  }
}
const si = new _h();
function bh(e, t) {
  const n = ri(this);
  return e.authMode = e.authMode || n.authMode, e.authToken = e.authToken || n.authToken, si.graphql(
    // TODO: move V6Client back into this package?
    n.amplify,
    e,
    t
  );
}
function xh(e, t) {
  return si.cancel(e, t);
}
function Oh(e) {
  return si.isCancelError(e);
}
function ai(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e.attributes || [])
    if (Dh(n))
      for (const i of n.properties.rules)
        i.allow === "owner" ? t.add(i.ownerField || "owner") : i.allow === "groups" && i.groupsField !== void 0 && t.add(i.groupsField);
  return Array.from(t);
}
function Dh(e) {
  var t, n;
  return (e == null ? void 0 : e.type) === "auth" && typeof (e == null ? void 0 : e.properties) == "object" && Array.isArray((t = e == null ? void 0 : e.properties) == null ? void 0 : t.rules) ? ((n = e == null ? void 0 : e.properties) == null ? void 0 : n.rules).every((i) => !!i.allow) : !1;
}
function Ut(e) {
  return `${e[0].toUpperCase()}${e.slice(1)}`;
}
const Be = {
  HAS_ONE: "HAS_ONE",
  HAS_MANY: "HAS_MANY",
  BELONGS_TO: "BELONGS_TO"
}, Oo = {
  ID: "ID",
  String: "String",
  AWSDate: "String",
  AWSTime: "String",
  AWSDateTime: "String",
  AWSTimestamp: "Int",
  AWSEmail: "String",
  AWSPhone: "String",
  AWSURL: "String",
  AWSIPAddress: "String",
  AWSJSON: "String",
  Boolean: "Boolean",
  Int: "Int",
  Float: "Float"
}, Ht = (e) => e.length === 1 ? e[0] : e.reduce((t, n, i) => i === 0 ? n : t + Ut(n), ""), Ce = (e, t, n) => {
  var o;
  if (!n)
    return null;
  const i = {};
  for (const [r, s] of Object.entries(n)) {
    const a = t ? (o = e.models[t]) == null ? void 0 : o.fields[r] : void 0, c = { fieldDef: a, value: s };
    kh(c) ? i[r] = c.value.items.map((u) => Ce(e, c.fieldDef.type.model, u)) : Ph(a) ? i[r] = Ce(e, a.type.model, s) : i[r] = s;
  }
  return i;
};
function kh(e) {
  var t, n;
  return typeof ((t = e.fieldDef) == null ? void 0 : t.type) == "object" && "model" in e.fieldDef.type && typeof e.fieldDef.type.model == "string" && e.fieldDef.isArray && Array.isArray((n = e.value) == null ? void 0 : n.items);
}
function Ph(e) {
  return typeof (e == null ? void 0 : e.type) == "object" && "model" in e.type && typeof e.type.model == "string";
}
function ge(e, t, n, i, o, r, s = !1) {
  const a = i.models[t], c = a.fields, u = Object.entries(c).filter(([d, l]) => {
    var h;
    return ((h = l == null ? void 0 : l.type) == null ? void 0 : h.model) !== void 0;
  }).map(([d]) => d);
  return n.map((d) => {
    var h, f;
    const l = {};
    for (const p of u) {
      const m = c[p], E = (m == null ? void 0 : m.type).model, S = i.models[E], v = S.primaryKeyInfo.primaryKeyFieldName, N = S.primaryKeyInfo.sortKeyFieldNames, A = (h = m.association) == null ? void 0 : h.connectionType;
      let w = [];
      m.association && "associatedWith" in m.association && (w = m.association.associatedWith);
      const _ = [];
      switch (m.association && "targetNames" in m.association && _.push(...m.association.targetNames), A) {
        case Be.BELONGS_TO: {
          const D = N.reduce(
            // TODO(Eslint): is this implementation correct?
            // eslint-disable-next-line array-callback-return
            (O, U) => {
              if (d[U])
                return O[U] = d[U];
            },
            {}
          );
          s ? l[p] = (O, U) => d[_[0]] ? e.models[E].get(O, {
            [v]: d[_[0]],
            ...D
          }, {
            authMode: (U == null ? void 0 : U.authMode) || o,
            authToken: (U == null ? void 0 : U.authToken) || r
          }) : { data: null } : l[p] = (O) => d[_[0]] ? e.models[E].get({
            [v]: d[_[0]],
            ...D
          }, {
            authMode: (O == null ? void 0 : O.authMode) || o,
            authToken: (O == null ? void 0 : O.authToken) || r
          }) : { data: null };
          break;
        }
        case Be.HAS_ONE:
        case Be.HAS_MANY: {
          const D = A === Be.HAS_ONE ? (C) => ({
            data: (C == null ? void 0 : C.data.shift()) || null,
            errors: C.errors,
            extensions: C.extensions
          }) : (C) => C, O = a.primaryKeyInfo.primaryKeyFieldName, U = a.primaryKeyInfo.sortKeyFieldNames, Re = S.fields[w[0]];
          if (Re.type.model) {
            let C = [];
            Re.association && "targetNames" in Re.association && (C = (f = Re.association) == null ? void 0 : f.targetNames);
            const b = C.map((k, M) => M === 0 ? { [k]: { eq: d[O] } } : { [k]: { eq: d[U[M - 1]] } });
            s ? l[p] = (k, M) => d[O] ? e.models[E].list(k, {
              filter: { and: b },
              limit: M == null ? void 0 : M.limit,
              nextToken: M == null ? void 0 : M.nextToken,
              authMode: (M == null ? void 0 : M.authMode) || o,
              authToken: (M == null ? void 0 : M.authToken) || r
            }).then(D) : [] : l[p] = (k) => d[O] ? e.models[E].list({
              filter: { and: b },
              limit: k == null ? void 0 : k.limit,
              nextToken: k == null ? void 0 : k.nextToken,
              authMode: (k == null ? void 0 : k.authMode) || o,
              authToken: (k == null ? void 0 : k.authToken) || r
            }).then(D) : [];
            break;
          }
          const K = w.map((C, b) => b === 0 ? { [C]: { eq: d[O] } } : { [C]: { eq: d[U[b - 1]] } });
          s ? l[p] = (C, b) => d[O] ? e.models[E].list(C, {
            filter: { and: K },
            limit: b == null ? void 0 : b.limit,
            nextToken: b == null ? void 0 : b.nextToken,
            authMode: (b == null ? void 0 : b.authMode) || o,
            authToken: (b == null ? void 0 : b.authToken) || r
          }).then(D) : [] : l[p] = (C) => d[O] ? e.models[E].list({
            filter: { and: K },
            limit: C == null ? void 0 : C.limit,
            nextToken: C == null ? void 0 : C.nextToken,
            authMode: (C == null ? void 0 : C.authMode) || o,
            authToken: (C == null ? void 0 : C.authToken) || r
          }).then(D) : [];
          break;
        }
      }
    }
    return { ...d, ...l };
  });
}
const jr = {
  CREATE: { operationPrefix: "create", usePlural: !1 },
  READ: { operationPrefix: "get", usePlural: !1 },
  UPDATE: { operationPrefix: "update", usePlural: !1 },
  DELETE: { operationPrefix: "delete", usePlural: !1 },
  LIST: { operationPrefix: "list", usePlural: !0 },
  INDEX_QUERY: { operationPrefix: "", usePlural: !1 },
  ONCREATE: { operationPrefix: "onCreate", usePlural: !1 },
  ONUPDATE: { operationPrefix: "onUpdate", usePlural: !1 },
  ONDELETE: { operationPrefix: "onDelete", usePlural: !1 },
  OBSERVE_QUERY: { operationPrefix: "observeQuery", usePlural: !1 }
}, Mn = "*", hn = (e, t) => {
  const { fields: n } = e, i = Object.values(n).map(({ type: o, name: r }) => {
    if (typeof o.enum == "string")
      return [r, ze];
    if (typeof o.nonModel == "string")
      return [
        r,
        hn(t.nonModels[o.nonModel], t)
      ];
    if (typeof o == "string")
      return [r, ze];
  }).filter((o) => o !== void 0);
  return Object.fromEntries(i);
}, Mh = (e, t) => {
  const { fields: n } = e, i = Object.values(n).map(({ type: r, name: s }) => {
    if (typeof r.enum == "string" || typeof r == "string")
      return [s, ze];
    if (typeof r.nonModel == "string")
      return [
        s,
        hn(t.nonModels[r.nonModel], t)
      ];
  }).filter((r) => r !== void 0), o = ai(e).map((r) => [
    r,
    ze
  ]);
  return Object.fromEntries(i.concat(o));
};
function Fh(e) {
  const { fields: t } = e, n = Object.values(t).map(({ type: o, name: r }) => {
    if (typeof o == "string")
      return r;
    if (typeof o == "object") {
      if (typeof (o == null ? void 0 : o.enum) == "string")
        return r;
      if (typeof (o == null ? void 0 : o.nonModel) == "string")
        return `${r}.${Mn}`;
    }
  }).filter(Boolean), i = ai(e);
  return Array.from(new Set(n.concat(i)));
}
const ze = "";
function Lh(e, t, n) {
  const i = (o, r) => {
    var g, E, S, v, N, A;
    const [s, ...a] = o.split("."), c = a[0], u = e.models[r] ?? e.nonModels[r], d = u == null ? void 0 : u.fields, l = (E = (g = d == null ? void 0 : d[s]) == null ? void 0 : g.type) == null ? void 0 : E.model, h = e.models[l], f = (v = (S = d == null ? void 0 : d[s]) == null ? void 0 : S.type) == null ? void 0 : v.nonModel, p = e.nonModels[f], m = h ? "model" : p ? "nonModel" : "field";
    if (m === "nonModel") {
      let w = {};
      if (!c)
        throw Error(`${s} must declare a wildcard (*) or a field of custom type ${f}`);
      return c === Mn ? w = {
        [s]: hn(p, e)
      } : w = {
        [s]: i(a.join("."), f)
      }, w;
    } else if (m === "model") {
      let w = {};
      if (!c)
        throw Error(`${s} must declare a wildcard (*) or a field of model ${l}`);
      if (c === Mn) {
        const _ = e.models[l];
        w = {
          [s]: Mh(_, e)
        };
      } else
        w = {
          [s]: i(a.join("."), l)
        };
      return (N = d[s]) != null && N.isArray && (w = {
        [s]: {
          items: w[s]
        }
      }), w;
    } else {
      const w = d == null ? void 0 : d[s], _ = e.nonModels[r], D = (A = _ == null ? void 0 : _.fields) == null ? void 0 : A[s];
      if (_) {
        if (!D)
          throw Error(`${s} is not a field of custom type ${r}`);
      } else {
        const O = ai(u).includes(s);
        if (!w && !O)
          throw Error(`${s} is not a field of model ${r}`);
      }
      return { [s]: ze };
    }
  };
  return n.reduce((o, r) => Hr(i(r, t), o), {});
}
function Wt(e) {
  const t = [];
  return Object.entries(e).forEach(([n, i]) => {
    i === ze ? t.push(n) : typeof i == "object" && i !== null && (i != null && i.items ? t.push(n, "{", "items", "{", Wt(i.items), "}", "}") : t.push(n, "{", Wt(i), "}"));
  }), t.join(" ");
}
function Hr(e, t) {
  const n = (i) => i && typeof i == "object";
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) && n(t[i]) ? Hr(e[i], t[i]) : t[i] = e[i]);
  return t;
}
function Wr(e, t, n) {
  const i = e.models[t], o = Lh(e, t, n ?? Fh(i));
  return Wt(o);
}
function pn(e, t, n, i, o) {
  var Ue, K;
  const r = e.models[t], { name: s, pluralName: a, fields: c, primaryKeyInfo: { isCustomPrimaryKey: u, primaryKeyFieldName: d, sortKeyFieldNames: l }, attributes: h } = r, f = s.charAt(0).toUpperCase() + s.slice(1), p = a.charAt(0).toUpperCase() + a.slice(1), { operationPrefix: m, usePlural: g } = jr[n], { selectionSet: E } = i || {};
  let S, v;
  if (m)
    S = `${m}${g ? p : f}`;
  else if (o) {
    const { queryField: C, pk: b, sk: k = [] } = o;
    S = C;
    let M = {};
    if (k.length === 1) {
      const [Ke] = k, ot = typeof c[Ke].type == "string" ? c[Ke].type : "String", Te = Oo[ot];
      M = {
        [Ke]: `Model${Te}KeyConditionInput`
      };
    } else if (k.length > 1) {
      const Ke = Ht(k), ot = (K = (Ue = h == null ? void 0 : h.find((Te) => {
        var rt;
        return ((rt = Te == null ? void 0 : Te.properties) == null ? void 0 : rt.queryField) === C;
      })) == null ? void 0 : Ue.properties) == null ? void 0 : K.name;
      M = {
        [Ke]: `Model${Ut(t)}${Ut(ot)}CompositeKeyConditionInput`
      };
    }
    v = {
      [b]: `${Object.prototype.hasOwnProperty.call(c[b].type, "enum") ? c[b].type.enum : c[b].type}!`,
      ...M
    };
  } else
    throw new Error("Error generating GraphQL Document - invalid operation name");
  let N, A, w;
  const _ = Wr(e, t, E), D = {
    [d]: `${c[d].type}!`
  }, O = {}, U = (C) => {
    if (l.length === 0)
      return {};
    if (C === "get")
      return l.reduce((b, k) => {
        const M = c[k].type;
        return C === "get" && (b[k] = `${M}!`), b;
      }, {});
    if (l.length === 1) {
      const [b] = l, k = typeof c[b].type == "string" ? c[b].type : "String", M = Oo[k];
      return {
        [b]: `Model${M}KeyConditionInput`
      };
    } else
      return {
        [Ht(l)]: `Model${Ut(t)}PrimaryCompositeKeyConditionInput`
      };
  };
  switch (u && (Object.assign(D, U("get")), Object.assign(O, {
    // PK is only included in list query field args in the generated GQL
    // when explicitly specifying PK with .identifier(['fieldName']) or @primaryKey in the schema definition
    [d]: `${c[d].type}`,
    // PK is always a nullable arg for list (no `!` after the type)
    sortDirection: "ModelSortDirection"
  }, U("list"))), n) {
    case "CREATE":
    case "UPDATE":
    case "DELETE":
      w ?? (w = {
        input: `${m.charAt(0).toLocaleUpperCase() + m.slice(1)}${f}Input!`
      }), N ?? (N = "mutation");
    case "READ":
      w ?? (w = D), A ?? (A = _);
    case "LIST":
      w ?? (w = {
        ...O,
        // eslint doesn't like the ts-ignore, because it thinks it's unnecessary.
        // But TS doesn't like the `filter: ...` because it think it will always be
        // overwritten. (it won't be.) so, we need to ignore the TS error and then
        // ignore the eslint error on the ts-ignore.
        // eslint-disable-next-line
        // @ts-ignore
        filter: `Model${f}FilterInput`,
        limit: "Int",
        nextToken: "String"
      }), N ?? (N = "query"), A ?? (A = `items { ${_} } nextToken __typename`);
    case "INDEX_QUERY":
      w ?? (w = {
        ...v,
        filter: `Model${f}FilterInput`,
        sortDirection: "ModelSortDirection",
        limit: "Int",
        nextToken: "String"
      }), N ?? (N = "query"), A ?? (A = `items { ${_} } nextToken __typename`);
    case "ONCREATE":
    case "ONUPDATE":
    case "ONDELETE":
      w ?? (w = {
        filter: `ModelSubscription${f}FilterInput`
      }), N ?? (N = "subscription"), A ?? (A = _);
      break;
    case "OBSERVE_QUERY":
    default:
      throw new Error("Internal error: Attempted to generate graphql document for observeQuery. Please report this error.");
  }
  return `${N}${w ? `(${Object.entries(w).map(([C, b]) => `$${C}: ${b}`)})` : ""} { ${S}${w ? `(${Object.keys(w).map((C) => `${C}: $${C}`)})` : ""} { ${A} } }`;
}
function fn(e, t, n, i, o) {
  const { fields: r, primaryKeyInfo: { isCustomPrimaryKey: s, primaryKeyFieldName: a, sortKeyFieldNames: c } } = e, u = (c == null ? void 0 : c.length) && Ht(c);
  let d = {};
  switch (t) {
    case "CREATE":
      d = {
        input: n ? Do(n, e, i) : {}
      };
      break;
    case "UPDATE":
      d = {
        input: n ? Object.fromEntries(Object.entries(Do(n, e, i)).filter(([l]) => {
          const { isReadOnly: h } = r[l];
          return !h;
        })) : {}
      };
      break;
    case "READ":
    case "DELETE":
      n && (d = s ? [a, ...c].reduce((l, h) => (l[h] = n[h], l), {}) : { [a]: n[a] }), t === "DELETE" && (d = { input: d });
      break;
    case "LIST":
      n != null && n.filter && (d.filter = n.filter), n != null && n.sortDirection && (d.sortDirection = n.sortDirection), n && n[a] && (d[a] = n[a]), u && n && n[u] && (d[u] = n[u]), n != null && n.nextToken && (d.nextToken = n.nextToken), n != null && n.limit && (d.limit = n.limit);
      break;
    case "INDEX_QUERY": {
      const { pk: l, sk: h = [] } = o, f = (h == null ? void 0 : h.length) && Ht(h);
      d[l] = n[l], f && n && n[f] && (d[f] = n[f]), n != null && n.filter && (d.filter = n.filter), n != null && n.sortDirection && (d.sortDirection = n.sortDirection), n != null && n.nextToken && (d.nextToken = n.nextToken), n != null && n.limit && (d.limit = n.limit);
      break;
    }
    case "ONCREATE":
    case "ONUPDATE":
    case "ONDELETE":
      n != null && n.filter && (d = { filter: n.filter });
      break;
    case "OBSERVE_QUERY":
      throw new Error("Internal error: Attempted to build variables for observeQuery. Please report this error.");
    default: {
      const l = t;
      throw new Error(`Unhandled operation case: ${l}`);
    }
  }
  return d;
}
function Do(e, t, n) {
  const { fields: i } = t, o = {};
  return Object.entries(e).forEach(([r, s]) => {
    var u, d;
    const a = (u = i[r]) == null ? void 0 : u.type, c = a == null ? void 0 : a.model;
    if (c) {
      const l = (d = i[r]) == null ? void 0 : d.association, f = n.models[c].primaryKeyInfo;
      if ((l == null ? void 0 : l.connectionType) === Be.HAS_ONE) {
        const p = l;
        p.targetNames.forEach((m, g) => {
          const E = p.associatedWith[g];
          o[m] = s[E];
        });
      }
      (l == null ? void 0 : l.connectionType) === Be.BELONGS_TO && l.targetNames.forEach((m, g) => {
        if (g === 0) {
          const E = f.primaryKeyFieldName;
          o[m] = s[E];
        } else {
          const E = f.sortKeyFieldNames[g - 1];
          o[m] = s[E];
        }
      });
    } else
      o[r] = s;
  }), o;
}
function nt(e, t, n = {}) {
  const i = t(e);
  return {
    authMode: n.authMode || i.authMode,
    authToken: n.authToken || i.authToken
  };
}
function it(e, t, n) {
  let i = t(e).headers || {};
  return n && (i = n), i;
}
function Fn(e) {
  if (e != null && e.errors)
    return {
      ...e,
      data: []
    };
  throw e;
}
function Gt(e) {
  if (e.errors)
    return {
      ...e,
      data: null
    };
  throw e;
}
const Uh = (e) => {
  var t;
  return typeof ((t = e == null ? void 0 : e.token) == null ? void 0 : t.value) == "symbol";
};
function Kh(e, t, n, i, o, r) {
  const s = i.arguments !== void 0;
  return (...c) => {
    const u = c[c.length - 1];
    let d, l;
    if (o)
      if (Uh(c[0]))
        d = c[0];
      else
        throw new Error(`Invalid first argument passed to ${i.name}. Expected contextSpec`);
    return s && (o ? l = c[1] : l = c[0]), n === "subscription" ? qh(
      // subscriptions are only enabled on the clientside
      e,
      t,
      i,
      r,
      l,
      u
    ) : $h(e, t, n, i, r, l, u, d);
  };
}
function $e(e, t) {
  return typeof e[t] == "string";
}
function Bh(e) {
  const t = e.isRequired ? "!" : "";
  return e.type instanceof Object && "enum" in e.type ? e.type.enum + t : e.type + t;
}
function Gr(e) {
  if (e.arguments === void 0)
    return "";
  const t = Object.entries(e.arguments).map(([n, i]) => {
    const o = Bh(i), r = i.isArray ? `[${o}]${i.isArrayNullable ? "" : "!"}` : o;
    return `$${n}: ${r}`;
  }).join(", ");
  return t.length > 0 ? `(${t})` : "";
}
function zr(e) {
  if (e.arguments === void 0)
    return "";
  const t = Object.keys(e.arguments).map((n) => `${n}: $${n}`).join(", ");
  return t.length > 0 ? `(${t})` : "";
}
function Qr(e, t) {
  if ($e(t, "type") || $e(t.type, "enum"))
    return "";
  if ($e(t.type, "nonModel")) {
    const n = e.nonModels[t.type.nonModel];
    return `{${Wt(hn(n, e))}}`;
  } else
    return $e(t.type, "model") ? `{${Wr(e, t.type.model)}}` : "";
}
function Yr(e, t = {}) {
  const n = {};
  if (e.arguments === void 0)
    return n;
  for (const i of Object.values(e.arguments))
    if (typeof t[i.name] < "u")
      n[i.name] = t[i.name];
    else if (i.isRequired)
      throw new Error(`${e.name} requires arguments '${i.name}'`);
  return n;
}
async function $h(e, t, n, i, o, r, s, a) {
  const { name: c } = i, u = nt(e, o, s), d = it(e, o, s == null ? void 0 : s.headers), l = Gr(i), h = zr(i), f = Qr(t, i), p = $e(i.type, "model") ? i.type.model : void 0, m = `
    ${n.toLocaleLowerCase()}${l} {
      ${c}${h} ${f}
    }
  `, g = Yr(i, r);
  try {
    const { data: E, extensions: S } = a ? await e.graphql(a, {
      ...u,
      query: m,
      variables: g
    }, d) : await e.graphql({
      ...u,
      query: m,
      variables: g
    }, d);
    if (E) {
      const [v] = Object.keys(E), N = Array.isArray(E[v]), A = N ? E[v].filter((_) => _) : E[v], w = p ? ge(e, p, N ? A : [A], t, u.authMode, u.authToken, !!a) : A;
      return {
        data: !N && Array.isArray(w) ? w.shift() : w,
        extensions: S
      };
    } else
      return { data: null, extensions: S };
  } catch (E) {
    const { data: S, errors: v } = E;
    if (S && Object.keys(S).length !== 0 && v) {
      const [N] = Object.keys(S), A = Array.isArray(S[N]), w = A ? S[N].filter((_) => _) : S[N];
      if (w) {
        const _ = p ? ge(e, p, A ? w : [w], t, u.authMode, u.authToken, !!a) : w;
        return {
          data: !A && Array.isArray(_) ? _.shift() : _,
          errors: v
        };
      } else
        return Gt(E);
    } else
      return Gt(E);
  }
}
function qh(e, t, n, i, o, r) {
  const s = "subscription", { name: a } = n, c = nt(e, i, r), u = it(e, i, r == null ? void 0 : r.headers), d = Gr(n), l = zr(n), h = Qr(t, n), f = $e(n.type, "model") ? n.type.model : void 0, p = `
    ${s.toLocaleLowerCase()}${d} {
      ${a}${l} ${h}
    }
  `, m = Yr(n, o);
  return e.graphql({
    ...c,
    query: p,
    variables: m
  }, u).pipe(Ln((E) => {
    const [S] = Object.keys(E.data), v = E.data[S], [N] = f ? ge(e, f, [v], t, c.authMode, c.authToken) : [v];
    return N;
  }));
}
const Vh = {
  queries: "query",
  mutations: "mutation",
  subscriptions: "subscription"
};
function ci(e, t, n, i) {
  if (!t)
    return {};
  const o = t.modelIntrospection;
  if (!o)
    return {};
  const r = o[n];
  if (!r)
    return {};
  const s = {}, a = i(e).amplify === null;
  for (const c of Object.values(r))
    s[c.name] = Kh(e, o, Vh[n], c, a, i);
  return s;
}
function jh(e, t, n) {
  return ci(e, t, "mutations", n);
}
function Hh(e, t, n) {
  return ci(e, t, "queries", n);
}
function Wh(e, t, n) {
  return ci(e, t, "subscriptions", n);
}
const Gh = (e) => {
  const t = e.modelIntrospection;
  if (!t)
    return {};
  const n = {};
  for (const [i, o] of Object.entries(t.enums))
    n[o.name] = {
      values: () => o.values
    };
  return n;
};
function zh(e, t, n, i, o = !1) {
  return o ? async (a, c) => ko(e, t, n, i, c, a) : async (a) => ko(e, t, n, i, a);
}
async function ko(e, t, n, i, o, r) {
  var d, l, h, f;
  const { name: s } = n, a = pn(t, s, "LIST", o), c = fn(n, "LIST", o, t), u = nt(e, i, o);
  try {
    const p = it(e, i, o == null ? void 0 : o.headers), { data: m, extensions: g } = r ? await e.graphql(r, {
      ...u,
      query: a,
      variables: c
    }, p) : await e.graphql({
      ...u,
      query: a,
      variables: c
    }, p);
    if (m !== void 0) {
      const [E] = Object.keys(m);
      if (m[E].items) {
        const S = m[E].items.map((v) => Ce(t, s, v));
        return o != null && o.selectionSet ? {
          data: S,
          nextToken: m[E].nextToken,
          extensions: g
        } : {
          data: ge(e, s, S, t, u.authMode, u.authToken, !!r),
          nextToken: m[E].nextToken,
          extensions: g
        };
      }
      return {
        data: m[E],
        nextToken: m[E].nextToken,
        extensions: g
      };
    }
  } catch (p) {
    const { data: m, errors: g } = p;
    if (m != null && Object.keys(m).length !== 0 && g) {
      const [E] = Object.keys(m);
      if ((d = m[E]) != null && d.items) {
        const S = m[E].items.map((v) => Ce(t, s, v));
        return S ? o != null && o.selectionSet ? {
          data: S,
          nextToken: (l = m[E]) == null ? void 0 : l.nextToken,
          errors: g
        } : {
          data: ge(e, s, S, t, u.authMode, u.authToken, !!r),
          nextToken: (h = m[E]) == null ? void 0 : h.nextToken,
          errors: g
        } : {
          data: m[E],
          nextToken: (f = m[E]) == null ? void 0 : f.nextToken,
          errors: g
        };
      } else
        return Fn(p);
    } else
      return Fn(p);
  }
}
function Qh(e, t, n, i, o, r = !1) {
  return r ? async (c, u, d) => Po(e, t, n, i, o, {
    ...u,
    ...d
  }, c) : async (c, u) => Po(e, t, n, i, o, {
    ...c,
    ...u
  });
}
function Yh(e, t, n, i, o) {
  const { data: r, extensions: s } = n, [a] = Object.keys(r);
  if (r[a].items) {
    const c = r[a].items.map((u) => Ce(e, t, u));
    return {
      data: i ? c : o(c),
      nextToken: r[a].nextToken,
      extensions: s
    };
  }
  return {
    data: r[a],
    nextToken: r[a].nextToken,
    extensions: s
  };
}
async function Po(e, t, n, i, o, r, s) {
  var h, f, p, m;
  const { name: a } = n, c = pn(t, a, "INDEX_QUERY", r, i), u = fn(n, "INDEX_QUERY", r, t, i), d = nt(e, o, r), l = (g) => ge(e, a, g, t, d.authMode, d.authToken, !!s);
  try {
    const g = it(e, o, r == null ? void 0 : r.headers), S = [{
      ...d,
      query: c,
      variables: u
    }, g];
    s !== void 0 && S.unshift(s);
    const v = await e.graphql(...S);
    if (v.data !== void 0)
      return Yh(t, a, v, r == null ? void 0 : r.selectionSet, l);
  } catch (g) {
    const { data: E, errors: S } = g;
    if (E !== void 0 && Object.keys(E).length !== 0 && S) {
      const [v] = Object.keys(E);
      if ((h = E[v]) != null && h.items) {
        const N = (f = E[v]) == null ? void 0 : f.items.map((A) => Ce(t, a, A));
        if (N)
          return {
            data: r != null && r.selectionSet ? N : l(N),
            nextToken: (p = E[v]) == null ? void 0 : p.nextToken
          };
      }
      return {
        data: E[v],
        nextToken: (m = E[v]) == null ? void 0 : m.nextToken
      };
    } else
      return Fn(g);
  }
}
function Jh(e, t, n, i, o, r = !1) {
  return r ? async (c, u, d) => Mo(e, t, n, u, d, i, o, c) : async (c, u) => Mo(e, t, n, c, u, i, o);
}
async function Mo(e, t, n, i, o, r, s, a) {
  const { name: c } = n, u = pn(t, c, r, o), d = fn(n, r, i, t), l = nt(e, s, o);
  try {
    const h = it(e, s, o == null ? void 0 : o.headers), { data: f, extensions: p } = a ? await e.graphql(a, {
      ...l,
      query: u,
      variables: d
    }, h) : await e.graphql({
      ...l,
      query: u,
      variables: d
    }, h);
    if (f) {
      const [m] = Object.keys(f), g = Ce(t, c, f[m]);
      if (g === null)
        return { data: null, extensions: p };
      if (o != null && o.selectionSet)
        return { data: g, extensions: p };
      {
        const [E] = ge(e, c, [g], t, l.authMode, l.authToken, !!a);
        return { data: E, extensions: p };
      }
    } else
      return { data: null, extensions: p };
  } catch (h) {
    const { data: f, errors: p } = h;
    if (f && Object.keys(f).length !== 0 && p) {
      const [m] = Object.keys(f), g = Ce(t, c, f[m]);
      if (g) {
        if (o != null && o.selectionSet)
          return { data: g, errors: p };
        {
          const [E] = ge(e, c, [g], t, l.authMode, l.authToken, !!a);
          return { data: E, errors: p };
        }
      } else
        return Gt(h);
    } else
      return Gt(h);
  }
}
function Xh(e, t, n, i, o) {
  const { name: r } = n;
  return (a) => {
    const c = pn(t, r, i, a), u = fn(n, i, a, t), d = nt(e, o, a), l = it(e, o, a == null ? void 0 : a.headers);
    return e.graphql({
      ...d,
      query: c,
      variables: u
    }, l).pipe(Ln((f) => {
      const [p] = Object.keys(f.data), m = f.data[p], [g] = ge(e, r, [m], t, d.authMode, d.authToken);
      return g;
    }));
  };
}
function Zh(e) {
  const { primaryKeyFieldName: t, sortKeyFieldNames: n } = e.primaryKeyInfo;
  return [t, ...n];
}
function ep(e, t, n) {
  const i = Object.fromEntries(n.map((o) => [o, e[o]]));
  for (let o = 0; o < t.length; o++)
    if (Object.keys(i).every((r) => i[r] === t[o][r]))
      return o;
  return -1;
}
function tp(e, t) {
  const { name: n } = t;
  return (o) => new pt((r) => {
    const s = [], a = [];
    let c = (...p) => a.push(...p);
    const u = e[n].onCreate(o).subscribe({
      next(p) {
        c({ item: p, type: "create" });
      },
      error(p) {
        r.error({ type: "onCreate", error: p });
      }
    }), d = e[n].onUpdate(o).subscribe({
      next(p) {
        c({ item: p, type: "update" });
      },
      error(p) {
        r.error({ type: "onUpdate", error: p });
      }
    }), l = e[n].onDelete(o).subscribe({
      next(p) {
        c({ item: p, type: "delete" });
      },
      error(p) {
        r.error({ type: "onDelete", error: p });
      }
    });
    function h(p) {
      for (const m of p) {
        const g = ep(m.item, s, f);
        switch (m.type) {
          case "create":
            g < 0 && s.push(m.item);
            break;
          case "update":
            g >= 0 && (s[g] = m.item);
            break;
          case "delete":
            g >= 0 && s.splice(g, 1);
            break;
          default:
            console.error("Unrecognized message in observeQuery.", m);
        }
      }
      r.next({
        items: s,
        isSynced: !0
      });
    }
    const f = Zh(t);
    return (async () => {
      let p = !0, m = null;
      for (; !r.closed && (p || m); ) {
        p = !1;
        const { data: g, errors: E, nextToken: S } = await e[n].list({ ...o, nextToken: m });
        m = S, s.push(...g);
        const v = a.length === 0 && m == null;
        if (r.next({
          items: s,
          isSynced: v
        }), Array.isArray(E))
          for (const N of E)
            r.error(N);
      }
      a.length > 0 && h(a), c = (...g) => (h(g), s.length);
    })(), () => {
      u.unsubscribe(), d.unsubscribe(), l.unsubscribe();
    };
  });
}
const np = (e) => {
  var t, n, i;
  return e.type === "key" && // presence of `name` property distinguishes GSI from primary index
  ((t = e.properties) == null ? void 0 : t.name) && ((n = e.properties) == null ? void 0 : n.queryField) && ((i = e.properties) == null ? void 0 : i.fields.length) > 0;
}, ip = (e) => {
  var n;
  return ((n = e.attributes) == null ? void 0 : n.filter(np).map((i) => {
    const o = i.properties.queryField, [r, ...s] = i.properties.fields;
    return {
      queryField: o,
      pk: r,
      sk: s
    };
  })) || [];
};
function op(e, t, n) {
  const i = {}, o = t.modelIntrospection;
  if (!o)
    return {};
  const r = ["ONCREATE", "ONUPDATE", "ONDELETE"];
  for (const s of Object.values(o.models)) {
    const { name: a } = s;
    i[a] = {}, Object.entries(jr).forEach(([u, { operationPrefix: d }]) => {
      const l = u;
      l === "LIST" ? i[a][d] = zh(e, o, s, n) : r.includes(l) ? i[a][d] = Xh(e, o, s, l, n) : l === "OBSERVE_QUERY" ? i[a][d] = tp(i, s) : i[a][d] = Jh(e, o, s, l, n);
    });
    const c = ip(s);
    for (const u of c)
      i[a][u.queryField] = Qh(e, o, s, u, n);
  }
  return i;
}
function Jr(e, t, n) {
  return e.models = op(e, t, n), e.enums = Gh(t), e.queries = Hh(e, t, n), e.mutations = jh(e, t, n), e.subscriptions = Wh(e, t, n), e;
}
function Xr(e) {
  return e !== void 0;
}
function rp(e) {
  return e.event === "configure";
}
function sp(e) {
  var i;
  const t = {
    [Kr]: e.amplify,
    [Br]: e.authMode,
    [$r]: e.authToken,
    [qr]: e.headers,
    graphql: bh,
    cancel: xh,
    isCancelError: Oh,
    models: ct,
    enums: ct,
    queries: ct,
    mutations: ct,
    subscriptions: ct
  }, n = (i = e.amplify.getConfig().API) == null ? void 0 : i.GraphQL;
  return Xr(n) ? Jr(t, n, ri) : ap(t), t;
}
const ap = (e) => {
  ce.listen("core", (t) => {
    var i;
    if (!rp(t.payload))
      return;
    const n = (i = t.payload.data.API) == null ? void 0 : i.GraphQL;
    Xr(n) && Jr(e, n, ri);
  });
}, ct = new Proxy({}, {
  get() {
    throw new Error("Client could not be generated. This is likely due to `Amplify.configure()` not being called prior to `generateClient()` or because the configuration passed to `Amplify.configure()` is missing GraphQL provider configuration.");
  }
});
function Ip(e = {}) {
  return sp({
    ...e,
    amplify: J
  });
}
export {
  J as A,
  pp as C,
  ce as H,
  Sp as a,
  gp as b,
  ld as c,
  Zt as d,
  fp as e,
  Ep as f,
  Ip as g,
  fr as h,
  mp as i,
  xi as j,
  Ds as p,
  yp as s
};
